import {Formik, useFormik, useFormikContext} from 'formik'
import React, {FC, useCallback, useEffect, useMemo, useRef, useState} from 'react'
import {Alert, OverlayTrigger, Tooltip} from 'react-bootstrap'
import {
  FIELD_MAPPING_DATA,
  FIELD_MAPPING_TYPE,
  RetrievePlatformDataType,
  SECTION_WISE_SAVED_FIELD_MAPPING,
  SETTINGS_OF_PLATFORM,
  ShippingMethodMapping,
} from 'src/interfaces/Platform.interface'
import {
  getSavedFieldMappingsDataAsync,
  getSettingsOfPrimaryPlatformAsyncNew,
  getSettingsOfSelectedPlatformAsyncNew,
  refreshMappingAsync,
  saveFieldMappingForSectionWiseAsync,
  saveFieldMappingsAsync,
} from 'src/redux/actions/platformSettingActions'
import {useAppDispatch, useAppSelector} from 'src/redux/storeHooks'
import Loader from 'src/utils/Loader'
import {BaseNames} from 'src/marketConnect/helpers'
import {
  applyUnavailableChannelSettingTurnOff,
  buildConnectedStoreState,
  getChannelSettingAvailability,
  isChannelSettingRuleKey,
} from 'src/utils/channelSettingAvailability'
import {
  handleBooleanSettingChange,
  isTruthySettingValue,
  resolveSettingFieldPath,
  sanitizeBooleanSettingFields,
} from 'src/utils/normalizeBooleanSettingValue'
import {
  buildChildSettingControlRenderOptions,
  shouldRenderChildByDropdownControl,
  shouldRenderMappingByDropdownControl,
} from 'src/utils/settingControlVisibility'
import {isPendingFieldMappingVisibleForSettingControl} from 'src/utils/settingControlVisibilityPersistence'
import {
  collectPlatformSettingSyncPairs,
  runSettingControlHiddenStateSync,
} from 'src/utils/useSettingControlHiddenStateSync'
import {runNestedMappingParentHiddenStateSync} from 'src/utils/useNestedMappingParentHiddenStateSync'
import InfoTooltip from './components/InfoTooltip'
import CustomInput from './components/CustomInput'
import {applyPlatformSettingShortcodes} from 'src/utils/platformSettingDisplayText'
import SettingNotes from './components/SettingNotes'
import ShortCodeInput from './components/ShortCodeInput'
import {
  createPlatformSettingAsync,
  fetchConnectedPlatformAsync,
  getPlatformTokenDatasync,
  retrivePlatformDataAsync,
  setPlatformTokenDatasync,
} from 'src/redux/actions/platformActions'
import {Link, useNavigate, useParams} from 'react-router-dom'
import DynamicChildSetting from './components/DynamicChildSetting'
import {LinkedBooleanMappingBlock} from './components/LinkedSettingsChildPanel'
import useAppToast, {getApiErrorMsg} from 'src/hooks/useAppToast'
import {
  getRefreshMappingErrorMessage,
  getRefreshMappingSuccessMessage,
  isApiPayloadSuccess,
} from 'src/utils/refreshMappingResponse'
import {isActiveBoolean} from 'src/redux/actions/changeisActiveAction'
import IndependentMapping from './components/IndependentMapping'
import DependentMapping from './components/DependentMapping'
import SettingFileActionCallout from './components/SettingFileActionCallout'
import {
  getDirectSettingFileChildActions,
  getSettingFileMappingsForCallout,
  hasSettingFileActions,
  isSettingFileActionMapping,
  isSettingFileChildInputType,
} from 'src/utils/settingFileFieldMappings'
import {
  applySyncStartDatesOnSave,
} from 'src/utils/syncStartDate'
import {formatDateForDateTimeLocal} from 'src/utils/formatDateForDateTimeLocal'
import './DynamicPlatformSettingNew.css'
import 'src/app/features/advanced-channel-settings/styles/advanced-channel-settings.css'
import DOMPurify from 'dompurify'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCircleInfo} from '@fortawesome/free-solid-svg-icons'
import CustomSelect from './components/CustomSelect'
import {setInitialPopupDataAsync} from 'src/redux/actions/authActions'
import {PlatformSettingDataTypesValues} from 'src/app/_interfaces/setting.interface'
import {useCustomerAccess} from 'src/hooks/useCustomerAccess'
import {
  shouldShowAction,
  getActionButtonProps,
  getFormFieldDisabled,
} from 'src/utils/customerAccessUtils'
import {
  buildPayoutChildFieldMappingsCached,
  buildSecondaryOrderMappingsData,
  clearPayoutChildFieldMappingsCache,
  resolvePayoutBuildContext,
  shouldValidatePayoutMapping,
} from 'src/utils/payoutMapping'
import {
  inspectChannelSettingsSaveBeforeApi,
  isChannelSettingsSaveDebugEnabled,
} from 'src/utils/channelSettingsSaveDebug'
import {
  dedupeFieldMappingsForSave,
  findMappingDisplayNameInSettingsCatalog,
  findDependentSavedFieldMapping,
  findIndependentSavedFieldMapping,
  mergeSavedMappingsIntoSettingValues,
  resolveSecondaryOrderTypeDependentLookupCodes,
  findSourcePlatformSettingByGroup,
  findSourcePlatformSettingInLists,
  resolveChildMappingSource,
  getSourceAdditionalChildSettings,
  getConnectedSourceFileActionPanels,
  collectLocationSlotCandidates,
  findSourceLocationMapping,
  filterMappingsByRelatedAvailablePlatform,
  hasMappingDatasetValue,
  isFieldMappingSaveable,
  normalizeMappingGroupCode,
  normalizeSavedFieldMappingsPayload,
  isSavedFieldMappingsPayload,
  resolveIndependentLocationFieldMappingSlot,
  aliasBackendFieldMappingsOnSettingContainer,
  collectFieldMappingIdsFromSettingContainer,
  pickLoadedSettingsForSource,
  resolveGroupScopedPlatformSettings,
  resolveSettingMappingIdForSave,
  shouldHideDefaultLocationMapping,
  shouldHideDefaultWhenOneToOneExists,
  shouldHideOneToOneLocationSlot,
  shouldResolveIndependentLocationFieldMappingSlot,
  shouldSkipRequiredMappingValidation,
  shouldSourceLocationOwnPair,
} from 'src/utils/fieldMappingSaveUtils'
import {shouldRenderThisSideMappingsOnPrimaryHub} from 'src/utils/channelSettingsThisSideMappings'
import {
  resolveDependentMappingPartner,
  usesNewDependentPairFormation,
} from 'src/utils/dependentMappingPair'
import {shouldShowShippingMethodUploadButton} from 'src/utils/shippingMethodUploadButton'
import {buildFieldMappingMetaMap, enrichFieldMapping} from 'src/utils/fieldMappingMetaUtils'
import {
  getBooleanMappingChildren,
  getMappingOwnId,
  groupMappingRenderEntries,
  isTruthyMappingParentValue,
} from 'src/utils/mappingParentGroup'
import {usePermission} from 'src/hooks/usePermission'
import ShippingProviderUploadModal from './components/ShippingProviderUploadModal'
import {
  applyLegacyIdentifierScalars,
  ProductIdentifierMappingSection,
  type ProductIdentifierMappingPayload,
} from './ProductIdentifierSettings'
import {findSavedProductIdentifierPair} from 'src/utils/productIdentifierResolveUtils'
import {
  buildPageSiblingRankMap,
  sortChannelSettingsCatalog,
} from 'src/utils/channelSettingsSequence'
import {
  createSequenceNodeRegistry,
  getEarliestPositionChild,
  isAdvancedSettingItem,
  registerSequenceNode,
} from 'src/utils/channelSettingSequenceRegistry'
import {
  getSequenceCustomInputContainerClass,
  getSequenceFieldShellStyle,
  getSequenceFieldWrapperClass,
  getSequenceInnerColumnClass,
} from 'src/utils/channelSettingSequenceLayout'
import ChannelSettingSequenceRow, {
  ChannelSettingLegacySequenceContainer,
} from './components/ChannelSettingSequenceRow'
import SequenceFieldShell from './components/SequenceFieldShell'

const dedupeChildFieldMappingsByCode = (fieldMappings: FIELD_MAPPING_TYPE[] = []) => {
  const deduped = new Map<string, FIELD_MAPPING_TYPE>()
  fieldMappings.forEach((mapping) => {
    if (!mapping?.field_code) return
    const key = `${mapping.field_code}::${Boolean(mapping.isDefault)}`
    if (!deduped.has(key)) {
      deduped.set(key, mapping)
    }
  })
  return Array.from(deduped.values())
}

type PlatformSettingProps = {
  availablePlatformId?: string
  selectedPlatformId?: string
  isFromOnboarding?: boolean
  afterSettingCB?: () => Promise<void>
  onSave?: () => void
}

const ERP_IDENTIFIER_KEY = 'erp_identifier'
const TICKET_SETTING_TYPE = 'TICKET_STORE_SETTING'
const TICKET_SETTING_FIELD = 'ticket'
const ORDER_PAYOUT_SETTING_FIELD = 'order_payout'
const TICKET_DEFAULT_CUSTOMER_FIELD = 'default_customer'

const getPlatformCode = (platform: any): string =>
  `${platform?.code ?? platform?.name ?? platform?.platform_info?.name ?? ''}`.toUpperCase()

const isErpLikePlatform = (platform: any): boolean => {
  if (!platform) return false
  if (platform?.isErpStore) return true

  const nature = `${platform?.platform_info?.nature ?? platform?.nature ?? ''}`.toUpperCase()
  const code = `${platform?.code ?? ''}`.toUpperCase()
  const name = `${platform?.name ?? platform?.platform_info?.name ?? ''}`.toUpperCase()

  return nature.includes('ERP') || code.includes('ERP') || name.includes('ERP')
}

const isOmsLikePlatform = (platform: any): boolean => {
  if (!platform) return false
  if (platform?.isOmsStore) return true

  const nature = `${platform?.platform_info?.nature ?? platform?.nature ?? ''}`.toUpperCase()
  const code = `${platform?.code ?? ''}`.toUpperCase()
  const name = `${platform?.name ?? platform?.platform_info?.name ?? ''}`.toUpperCase()

  return nature.includes('OMS') || code.includes('OMS') || name.includes('OMS')
}

const isTicketLikePlatform = (platform: any): boolean => {
  if (!platform) return false
  if (platform?.isTicketStore) return true

  const nature = `${platform?.platform_info?.nature ?? platform?.nature ?? ''}`.toUpperCase()
  const type = `${platform?.platform_info?.type ?? platform?.type ?? ''}`.toUpperCase()
  const code = `${platform?.code ?? ''}`.toUpperCase()
  const name = `${platform?.name ?? platform?.platform_info?.name ?? ''}`.toUpperCase()
  const displayName = `${platform?.display_name ?? platform?.platform_info?.display_name ?? ''}`.toUpperCase()
  const values = [nature, type, code, name, displayName]

  return values.some((value) =>
    value === 'TICKET' ||
    value.includes('TICKET') ||
    value.includes('HELPDESK') ||
    value.includes('HELP_DESK') ||
    value.includes('HELP DESK')
  )
}

const getSettingReadonlyFallbackValue = (setting: any): string => {
  const name = setting?.name
  const selfNamedValue =
    name && typeof setting[name] === 'string' && setting[name] !== name ? setting[name] : undefined
  const fallbackValue =
    setting?.value ??
    setting?.default_value ??
    setting?.setting_value ??
    setting?.initial_value ??
    setting?.readonly_value ??
    selfNamedValue ??
    ''

  if (fallbackValue === null || fallbackValue === undefined) return ''
  return `${fallbackValue}`
}

const getTicketDefaultCustomerFallbackValue = (settings: any[] = []): string => {
  const ticketSetting = settings.find(
    (setting) =>
      setting?.group_code === 'TICKET' &&
      Array.isArray(setting?.children)
  )
  const defaultCustomerSetting = ticketSetting?.children?.find(
    (child) =>
      child?.group_code === 'TICKET' &&
      child?.name === TICKET_DEFAULT_CUSTOMER_FIELD &&
      `${child?.input_type ?? ''}`.endsWith('_READONLY')
  )

  return getSettingReadonlyFallbackValue(defaultCustomerSetting)
}

const getAvailableSourcesForSetting = (setting: any): any[] => {
  if (Array.isArray(setting?.available_sources) && setting.available_sources.length) {
    return setting.available_sources
  }

  const groupCode = `${setting?.group_code ?? ''}`.toUpperCase()
  const sourceKeyByGroup: Record<string, string> = {
    SHIPMENT: 'available_shipping_sources',
    TICKET: 'available_ticket_sources',
    ORDER_PAYOUT: 'available_payout_sources',
  }
  const groupSourceKey = sourceKeyByGroup[groupCode]

  if (groupSourceKey && Array.isArray(setting?.[groupSourceKey])) {
    return setting[groupSourceKey]
  }

  return []
}

const getAvailableSourcesDisplayName = (setting: any): string => {
  const groupCode = `${setting?.group_code ?? ''}`.toUpperCase()
  const displayNameByGroup: Record<string, string> = {
    SHIPMENT: 'available_shipping_sources_display_name',
    TICKET: 'available_ticket_sources_display_name',
    ORDER_PAYOUT: 'available_payout_sources_display_name',
  }
  const groupDisplayNameKey = displayNameByGroup[groupCode]

  return (
    setting?.available_sources_display_name ||
    (groupDisplayNameKey ? setting?.[groupDisplayNameKey] : '') ||
    ''
  )
}

const DynamicPlatformSettingNew: FC<PlatformSettingProps> = ({
  availablePlatformId: propsAvailableId,
  selectedPlatformId: propsSelectedId,
  isFromOnboarding = false,
  afterSettingCB,
  onSave,
}) => {
  const {isRead, isWrite, isDelete} = usePermission()
  //possible groupcode ORDER, PRODUCT, INVENTORY, SHIPMENT, PRICING
  const {availablePlatformId: routeAvailableId, selectedPlatformId: routeSelectedId} = useParams()

  // Use props if provided, otherwise fallback to route params
  const availablePlatformId = propsAvailableId ?? routeAvailableId
  const selectedPlatformId = propsSelectedId ?? routeSelectedId

  const dispatch = useAppDispatch()
  const {errorToast, successToast, warningToast} = useAppToast()
  const {loadPlatformSetting, settings} = useAppSelector((state) => state.platformSetting)
  const [platformSettings, setPlatformSettings] = useState<SETTINGS_OF_PLATFORM[] | []>([])
  const [primaryPlatformSettings, setPrimaryPlatformSettings] = useState<
    SETTINGS_OF_PLATFORM[] | []
  >([])
  const [formFields, setFormFields] = useState<any>({
    main_product_identifier: '',
    secondary_product_identifier: '',
    platform_partner_id: '',
    account_mode: '',
    secondary_accounting_identifier: '',
    accounting_identifier: '',
    primary_accounting_identifier: '',
    accounting_identifier_primary: '',
    secondary_shipping_identifier: '',
    shipping_identifier: '',
    primary_shipping_identifier: '',
    shipping_identifier_primary: '',
    primary_erp_identifier: '',
    secondary_erp_identifier: '',
    [ERP_IDENTIFIER_KEY]: '',
    [`${ERP_IDENTIFIER_KEY}_primary`]: '',
    secondary_oms_identifier: '',
    oms_identifier: '',
    primary_oms_identifier: '',
    oms_identifier_primary: '',
    primary_ticket_identifier: '',
    secondary_ticket_identifier: '',
    ticket_product_identifier: '',
    ticket_identifier: '',
    ticket_identifier_primary: '',
  })
  const [retriveDataLoading, setRetriveDataLoading] = useState<boolean>(true)
  const [loadingFormFields, setLoadingFormFields] = useState(true)
  const [loadInitialKeyValues, setLoadInitialKeyValues] = useState<boolean>(false)
  const {
    mainStoreData,
    accountingStoreData,
    shippingStoreData,
    erpStoreData,
    omsStoreData,
    ticketStoreData,
    fetchedConnectedPlatformLoading,
    fetchedConnectedPlatformData,
  } = useAppSelector((state) => state.fetchConnectedPlatform)
  const {connectedPlatformData} = useAppSelector((state) => state.connectedPlatform)
  const effectivePrimarySourceStoreData = mainStoreData ?? omsStoreData ?? null
  const effectivePrimarySourceSettingType = mainStoreData
    ? 'MAIN_STORE_SETTING'
    : omsStoreData
    ? 'OMS_STORE_SETTING'
    : 'MAIN_STORE_SETTING'
  const fallbackSourceSettingType = mainStoreData
    ? 'MAIN_STORE_SETTING'
    : omsStoreData
    ? 'OMS_STORE_SETTING'
    : accountingStoreData
    ? 'ACCOUNTING_STORE_SETTING'
    : shippingStoreData
    ? 'SHIPPING_STORE_SETTING'
    : erpStoreData
    ? 'ERP_STORE_SETTING'
    : ticketStoreData
    ? TICKET_SETTING_TYPE
    : 'MAIN_STORE_SETTING'
  const getStoreDataForSettingType = (settingType?: string | null) => {
    if (settingType === 'ACCOUNTING_STORE_SETTING') return accountingStoreData
    if (settingType === 'SHIPPING_STORE_SETTING') return shippingStoreData
    if (settingType === 'ERP_STORE_SETTING') return erpStoreData
    if (settingType === 'OMS_STORE_SETTING') return omsStoreData
    if (settingType === TICKET_SETTING_TYPE) return ticketStoreData
    return mainStoreData
  }
  const getStoreDataForSelectedSource = (
    settingType?: string | null,
    selectedSourceId?: number | null
  ) => {
    if (selectedSourceId != null && Array.isArray(fetchedConnectedPlatformData)) {
      const matched = fetchedConnectedPlatformData.find(
        (item: any) => Number(item?.id) === Number(selectedSourceId)
      )
      if (matched) return matched
    }
    return getStoreDataForSettingType(settingType)
  }
  const connectedStores = useMemo(
    () =>
      buildConnectedStoreState({
        mainStoreData,
        accountingStoreData,
        shippingStoreData,
        erpStoreData,
        omsStoreData,
        ticketStoreData,
      }),
    [
      mainStoreData,
      accountingStoreData,
      shippingStoreData,
      erpStoreData,
      omsStoreData,
      ticketStoreData,
    ]
  )
  const [retrivedPlatformData, setRetrivedPlatformData] = useState<RetrievePlatformDataType | null>(
    null
  )
  const [fieldMappings, setFieldMappings] = useState<any>([])
  const [isMappingChanged, setIsMappingChanged] = useState(false)
  const [hasIdentifier, setHasIdentifier] = useState<any>({
    main_product_identifier: false,
    secondary_product_identifier: false,
    secondary_accounting_identifier: false,
    accounting_identifier: false,
    primary_accounting_identifier: false,
    accounting_identifier_primary: false,
    secondary_shipping_identifier: false,
    shipping_identifier: false,
    primary_shipping_identifier: false,
    shipping_identifier_primary: false,
    primary_erp_identifier: false,
    secondary_erp_identifier: false,
    [ERP_IDENTIFIER_KEY]: false,
    [`${ERP_IDENTIFIER_KEY}_primary`]: false,
    primary_oms_identifier: false,
    secondary_oms_identifier: false,
    oms_identifier: false,
    oms_identifier_primary: false,
    primary_ticket_identifier: false,
    secondary_ticket_identifier: false,
    ticket_product_identifier: false,
    ticket_identifier: false,
    ticket_identifier_primary: false,
  })
  const [savedMappings, setSavedMappings] = useState<SECTION_WISE_SAVED_FIELD_MAPPING[]>([])
  const [missingRequiredMappingKeys, setMissingRequiredMappingKeys] = useState<Set<string>>(
    new Set()
  )
  const shopwareAccountModeOptions = [
    {label: 'Sandbox', value: 'SANDBOX'},
    {label: 'Live', value: 'LIVE'},
  ]
  const buildMappingErrorKey = ({
    groupCode,
    settingMappingId,
    fieldCode,
    apiCode,
    isDefault,
  }: {
    groupCode?: string
    settingMappingId?: number | null
    fieldCode?: string | null
    apiCode?: string | null
    isDefault?: boolean
  }) => {
    if (settingMappingId !== undefined && settingMappingId !== null) {
      return `smid:${settingMappingId}`
    }

    return `group:${groupCode ?? ''}|code:${fieldCode ?? apiCode ?? ''}|default:${
      isDefault ? '1' : '0'
    }`
  }

  const getMappingValueBySettingMappingId = useCallback(
    (settingMappingId?: number | null): string | null => {
      if (!settingMappingId) {
        return null
      }

      const pendingMapping = fieldMappings.find(
        (mapping) => mapping?.setting_mapping_id === settingMappingId
      )

      const resolveValueFromPendingRows = (rows: any[] = []): string | null => {
        for (const row of rows) {
          const destStr = row?.destination_platform_data_str
          if (destStr !== undefined && destStr !== null && `${destStr}`.trim() !== '') {
            return `${destStr}`
          }

          const destId = row?.destination_platform_data_id
          if (
            (Array.isArray(destId) && destId.length > 0) ||
            (!Array.isArray(destId) &&
              destId !== undefined &&
              destId !== null &&
              `${destId}`.trim() !== '')
          ) {
            return Array.isArray(destId) ? `${destId[0]}` : `${destId}`
          }

          const sourceStr = row?.source_platform_data_str
          if (sourceStr !== undefined && sourceStr !== null && `${sourceStr}`.trim() !== '') {
            return `${sourceStr}`
          }

          const sourceId = row?.source_platform_data_id
          if (
            (Array.isArray(sourceId) && sourceId.length > 0) ||
            (!Array.isArray(sourceId) &&
              sourceId !== undefined &&
              sourceId !== null &&
              `${sourceId}`.trim() !== '')
          ) {
            return Array.isArray(sourceId) ? `${sourceId[0]}` : `${sourceId}`
          }
        }

        return null
      }

      if (pendingMapping?.fieldMappingDataSet?.length) {
        const pendingValue = resolveValueFromPendingRows(pendingMapping.fieldMappingDataSet)
        if (pendingValue !== null) {
          return pendingValue
        }
      }

      const savedMappingEntry = savedMappings?.find(
        (mapping: any) => mapping?.setting_mapping_id === settingMappingId
      )

      if (savedMappingEntry?.fieldmappingdata_set?.length) {
        for (const row of savedMappingEntry.fieldmappingdata_set) {
          if (
            row?.destination_platform_data_str !== undefined &&
            row?.destination_platform_data_str !== null &&
            `${row.destination_platform_data_str}`.trim() !== ''
          ) {
            return `${row.destination_platform_data_str}`
          }

          const destData = row?.destination_platform_data
          if (destData?.id !== undefined && destData?.id !== null) {
            return `${destData.id}`
          }

          if (
            row?.source_platform_data_str !== undefined &&
            row?.source_platform_data_str !== null &&
            `${row.source_platform_data_str}`.trim() !== ''
          ) {
            return `${row.source_platform_data_str}`
          }

          const sourceData = row?.source_platform_data
          if (sourceData?.id !== undefined && sourceData?.id !== null) {
            return `${sourceData.id}`
          }
        }
      }

      return null
    },
    [fieldMappings, savedMappings]
  )

  const isMappingDependencySatisfied = useCallback(
    (mapping: FIELD_MAPPING_TYPE) => {
      if (!mapping?.belongs_to_id) {
        return true
      }
      const value = getMappingValueBySettingMappingId(mapping.belongs_to_id)
      if (value === null) {
        return false
      }
      const normalized = `${value}`.trim().toLowerCase()
      return (
        normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'on'
      )
    },
    [getMappingValueBySettingMappingId]
  )
  const hasDispatched = useRef(false)
  const lastSettingsRequestSignatureRef = useRef<string>('')
  const settingsFetchGenerationRef = useRef(0)
  const settingsFetchInFlightRef = useRef<string | null>(null)
  const [refreshMapping, setRefreshMapping] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)
  const [disableRefreshButton, setDisableRefreshButton] = useState(false)
  const [hasCooldownStarted, setHasCooldownStarted] = useState(false)
  const [timeLeft, setTimeLeft] = useState(0)
  const [showAlert, setShowAlert] = useState(false)
  const [accountingPlatformSettings, setAccountingPlatformSettings] = useState<
    SETTINGS_OF_PLATFORM[] | []
  >([])
  const [shippingPlatformSettings, setShippingPlatformSettings] = useState<
    SETTINGS_OF_PLATFORM[] | []
  >([])
  const [erpPlatformSettings, setErpPlatformSettings] = useState<SETTINGS_OF_PLATFORM[] | []>([])
  const [omsPlatformSettings, setOmsPlatformSettings] = useState<SETTINGS_OF_PLATFORM[] | []>([])
  const [ticketPlatformSettings, setTicketPlatformSettings] = useState<SETTINGS_OF_PLATFORM[] | []>(
    []
  )

  useEffect(() => {
    clearPayoutChildFieldMappingsCache()
  }, [erpPlatformSettings, accountingPlatformSettings])
  const [fetchedSettingTypes, setFetchedSettingTypes] = useState<any>([])
  const [platformSettingByGroup, setPlatformSettingByGroup] = useState<any>({})
  const sourceSettingsInFlightRef = useRef<Record<string, boolean>>({})
  const sourceSettingsCacheRef = useRef<Record<string, SETTINGS_OF_PLATFORM[]>>({})
  const {fetchedUserAccountData} = useAppSelector((state) => state.userAccountData)
  const customerAccess = useCustomerAccess()
  const navigate = useNavigate()
  const [temuTokenData, setTemuTokenData] = useState({token: '', expire_date: ''})
  const [isSaving, setIsSaving] = useState(false)
  const [showShippingProviderUploadModal, setShowShippingProviderUploadModal] = useState(false)
  const [shippingProviderUploadTarget, setShippingProviderUploadTarget] = useState<any>(null)
  const [identifierMappingPayload, setIdentifierMappingPayload] =
    useState<ProductIdentifierMappingPayload | null>(null)
  const [hasIncompleteIdentifierRows, setHasIncompleteIdentifierRows] = useState(false)
  const selectedPlatformIdNumber = Number(selectedPlatformId)
  const isRetrievedErpStore = isErpLikePlatform(retrivedPlatformData)
  const isRetrievedOmsStore = isOmsLikePlatform(retrivedPlatformData)
  const isRetrievedPrimaryHubStore = Boolean(
    retrivedPlatformData?.isMainStore || isRetrievedOmsStore
  )
  const isSelectedPrimaryHubStore = Boolean(
    Number(mainStoreData?.id) === selectedPlatformIdNumber ||
    Number(omsStoreData?.id) === selectedPlatformIdNumber ||
    (isRetrievedPrimaryHubStore &&
      Number(retrivedPlatformData?.id) === selectedPlatformIdNumber)
  )
  const isRetrievedAccountingStore = Boolean(retrivedPlatformData?.isAccountingStore)
  const isRetrievedShippingStore = Boolean(retrivedPlatformData?.isShippingStore)
  const isRetrievedTicketStore = Boolean(
    retrivedPlatformData?.isTicketStore || isTicketLikePlatform(retrivedPlatformData)
  )
  const isAuxiliaryIdentifierPlatform =
    !isSelectedPrimaryHubStore &&
    (isRetrievedAccountingStore ||
      isRetrievedShippingStore ||
      isRetrievedErpStore ||
      isRetrievedOmsStore ||
      isRetrievedTicketStore)

  const buildShippingProviderUploadTarget = (platform?: any) => ({
    platformId: `${platform?.id ?? selectedPlatformId ?? ''}`,
    platformName: getPlatformCode(platform) || retrivedPlatformData?.code || '',
    platformDisplayName:
      platform?.display_name ||
      platform?.platform_info?.display_name ||
      retrivedPlatformData?.display_name ||
      retrivedPlatformData?.platform_info?.display_name ||
      '',
  })

  const openShippingProviderUploadModal = (platform?: any) => {
    setShippingProviderUploadTarget(buildShippingProviderUploadTarget(platform))
    setShowShippingProviderUploadModal(true)
  }

  const closeShippingProviderUploadModal = () => {
    setShowShippingProviderUploadModal(false)
    setShippingProviderUploadTarget(null)
  }

  const identifierRelatedSettingsByPlatformId = useMemo(() => {
    const settingsByPlatformId: Record<number, SETTINGS_OF_PLATFORM[]> = {}
    const addSettings = (
      platform: {id?: number | string | null} | null | undefined,
      settings: SETTINGS_OF_PLATFORM[] | []
    ) => {
      const platformId = Number(platform?.id)
      if (platformId && settings?.length) {
        settingsByPlatformId[platformId] = settings as SETTINGS_OF_PLATFORM[]
      }
    }

    const resolvedHubStoreForIdentifiers =
      (effectivePrimarySourceStoreData &&
      Number(effectivePrimarySourceStoreData.id) === selectedPlatformIdNumber
        ? effectivePrimarySourceStoreData
        : null) ??
      (isRetrievedPrimaryHubStore &&
      Number(retrivedPlatformData?.id) === selectedPlatformIdNumber
        ? retrivedPlatformData
        : null)

    const primaryHubSettings =
      isSelectedPrimaryHubStore && resolvedHubStoreForIdentifiers
        ? platformSettings
        : primaryPlatformSettings

    addSettings(resolvedHubStoreForIdentifiers, primaryHubSettings)
    addSettings(accountingStoreData, accountingPlatformSettings)
    addSettings(shippingStoreData, shippingPlatformSettings)
    addSettings(erpStoreData, erpPlatformSettings)
    addSettings(omsStoreData, omsPlatformSettings)
    addSettings(ticketStoreData, ticketPlatformSettings)

    return settingsByPlatformId
  }, [
    accountingPlatformSettings,
    accountingStoreData,
    effectivePrimarySourceStoreData,
    erpPlatformSettings,
    erpStoreData,
    isRetrievedPrimaryHubStore,
    isSelectedPrimaryHubStore,
    omsPlatformSettings,
    omsStoreData,
    platformSettings,
    primaryPlatformSettings,
    retrivedPlatformData,
    selectedPlatformIdNumber,
    shippingPlatformSettings,
    shippingStoreData,
    ticketPlatformSettings,
    ticketStoreData,
  ])
  const handleIdentifierRowsChange = useCallback(
    (payload: ProductIdentifierMappingPayload, hasIncompleteRows = false) => {
      setIdentifierMappingPayload(payload)
      setHasIncompleteIdentifierRows(hasIncompleteRows)
    },
    []
  )
  const shouldShowPrimarySecondaryIdentifierBlock = !isAuxiliaryIdentifierPlatform
  const booleanFieldPaths = useMemo(() => {
    const fieldPaths = new Set<string>()

    const collectBooleanFields = (items: SETTINGS_OF_PLATFORM[] = [], baseField: string) => {
      if (!baseField) return

      items.forEach((item) => {
        if (item.input_type === 'BOOLEAN') {
          fieldPaths.add(`${baseField}_setting.${item.name}`)
        }

        if (item.children?.length) {
          collectBooleanFields(item.children, baseField)
        }
      })
    }

    platformSettings?.forEach((setting) => {
      const settingField =
        setting.group_code === 'ORDER'
          ? 'order'
          : setting.group_code === 'PRODUCT'
          ? 'product'
          : setting.group_code === 'INVENTORY'
          ? 'inventory'
          : setting.group_code === 'SHIPMENT'
          ? 'shipment'
          : setting.group_code === 'PRICING'
          ? 'pricing'
          : setting.group_code.toLocaleLowerCase()

      collectBooleanFields([setting], settingField)
    })

    return fieldPaths
  }, [platformSettings])

  const resolveSettingFieldForControlSync = useCallback((groupCode?: string) => {
    if (!groupCode) return ''
    if (groupCode === 'ORDER') return 'order'
    if (groupCode === 'ACCOUNTING_ORDER') return 'accounting_order'
    if (groupCode === 'ERP_ORDER') return 'erp_order'
    if (groupCode === 'OMS_ORDER') return 'oms_order'
    if (groupCode === 'SHIPMENT') return 'shipment'
    if (groupCode === 'INVENTORY') return 'inventory'
    if (groupCode === 'PRICING') return 'pricing'
    if (groupCode === 'PRODUCT') return 'product'
    return groupCode.toLowerCase()
  }, [])

  const settingControlSyncPairs = useMemo(() => {
    const platformSettingsMap: Record<string, SETTINGS_OF_PLATFORM[]> = {
      MAIN_STORE_SETTING: primaryPlatformSettings || [],
      ACCOUNTING_STORE_SETTING: accountingPlatformSettings || [],
      SHIPPING_STORE_SETTING: shippingPlatformSettings || [],
      ERP_STORE_SETTING: erpPlatformSettings || [],
      OMS_STORE_SETTING: omsPlatformSettings || [],
      [TICKET_SETTING_TYPE]: ticketPlatformSettings || [],
    }

    return collectPlatformSettingSyncPairs(
      platformSettings,
      (setting) => {
        const selectedTypeForGroup = platformSettingByGroup?.[setting?.group_code]?.settingType
        if (!selectedTypeForGroup || !platformSettingsMap[selectedTypeForGroup]) {
          return null
        }
        return findSourcePlatformSettingByGroup(
          platformSettingsMap[selectedTypeForGroup],
          setting?.group_code,
          setting?.name
        )
      },
      resolveSettingFieldForControlSync
    )
  }, [
    platformSettings,
    primaryPlatformSettings,
    accountingPlatformSettings,
    shippingPlatformSettings,
    erpPlatformSettings,
    omsPlatformSettings,
    ticketPlatformSettings,
    platformSettingByGroup,
    resolveSettingFieldForControlSync,
  ])

  const sanitizeBooleanFields = (valuesObj: Record<string, any>) =>
    sanitizeBooleanSettingFields(valuesObj, booleanFieldPaths)

  const normalizeNumberFields = (
    valuesObj: Record<string, any>,
    fieldPaths: string[]
  ): Record<string, any> => {
    const normalizedValues: Record<string, any> = {...valuesObj}

    fieldPaths.forEach((path) => {
      const [parentKey, fieldKey] = path.split('.')
      if (!parentKey || !fieldKey) return

      const parent = normalizedValues[parentKey]
      if (!parent || typeof parent !== 'object') return

      const rawVal = parent[fieldKey]
      if (rawVal === '' || rawVal === undefined) {
        parent[fieldKey] = null
      } else if (typeof rawVal === 'string') {
        const trimmed = rawVal.trim()
        const numVal = trimmed === '' ? null : Number(trimmed)
        parent[fieldKey] = Number.isFinite(numVal as number) ? numVal : null
      }
    })

    return normalizedValues
  }

  const {
    handleChange,
    values,
    handleSubmit,
    setFormikState,
    isSubmitting,
    setValues,
    setFieldValue,
  } = useFormik({
    initialValues: formFields,
    onSubmit: (values, helpers) => {
      let {...othervalues} = values
      const settingControlSyncAtSave = runSettingControlHiddenStateSync({
        fieldMappings,
        formValues: othervalues,
        savedMappings,
        syncPairs: settingControlSyncPairs,
      })
      if (settingControlSyncAtSave.mappingsChanged) {
        setFieldMappings(settingControlSyncAtSave.fieldMappings)
      }
      if (settingControlSyncAtSave.valuesChanged) {
        othervalues = settingControlSyncAtSave.formValues
        setValues(settingControlSyncAtSave.formValues)
      }
      let fieldMappingsForSave = settingControlSyncAtSave.fieldMappings
      const nestedMappingParentSyncAtSave = runNestedMappingParentHiddenStateSync({
        fieldMappings: fieldMappingsForSave,
        syncPairs: settingControlSyncPairs,
        resolveMappingValue: (id) => getMappingValueBySettingMappingId(id),
      })
      if (nestedMappingParentSyncAtSave.mappingsChanged) {
        setFieldMappings(nestedMappingParentSyncAtSave.fieldMappings)
        fieldMappingsForSave = nestedMappingParentSyncAtSave.fieldMappings
      }
      applySyncStartDatesOnSave({
        formValues: othervalues,
        savedPlatformSettings: retrivedPlatformData?.platform_settings,
      })
      const sanitizedValues = sanitizeBooleanFields(othervalues)

      // WIX (as secondary store) backend uses main_product_identifier for the secondary channel
      // and secondary_product_identifier for the primary channel selection. Swap accordingly.
      if (retrivedPlatformData?.code === 'WIX' && !retrivedPlatformData?.isMainStore) {
        const secondarySelection = sanitizedValues.secondary_product_identifier
        const primarySelection = sanitizedValues.main_product_identifier

        if (secondarySelection !== undefined) {
          sanitizedValues.main_product_identifier = secondarySelection
        }

        if (primarySelection !== undefined) {
          sanitizedValues.secondary_product_identifier = primarySelection
        }
      }
      const numericFieldPaths = ['inventory_setting.syncMaxLimit']
      let normalizedValues = normalizeNumberFields(sanitizedValues, numericFieldPaths)
      normalizedValues = applyUnavailableChannelSettingTurnOff(normalizedValues, connectedStores)

      if (hasIncompleteIdentifierRows) {
        warningToast('Please select both identifiers for every product identifier mapping row.')
        helpers.setSubmitting(false)
        setIsSaving(false)
        return
      }

      if (normalizedValues.ticket_setting?.Tags !== undefined) {
        normalizedValues.ticket_setting.tags = normalizedValues.ticket_setting.Tags
        delete normalizedValues.ticket_setting.Tags
      }

      // Keep nested identifier_setting in sync with top-level identifier fields used by this form.
      if (
        normalizedValues.identifier_setting &&
        typeof normalizedValues.identifier_setting === 'object'
      ) {
        const syncedIdentifierSetting = {...normalizedValues.identifier_setting}
        Object.keys(syncedIdentifierSetting).forEach((identifierKey) => {
          if (normalizedValues[identifierKey] !== undefined) {
            syncedIdentifierSetting[identifierKey] = normalizedValues[identifierKey]
          }
        })
        normalizedValues.identifier_setting = syncedIdentifierSetting
      }

      // Ensure platform_partner_id is also in identifier_setting for backend compatibility
      if (normalizedValues.platform_partner_id !== undefined) {
        if (!normalizedValues.identifier_setting) {
          normalizedValues.identifier_setting = {}
        }
        normalizedValues.identifier_setting.platform_partner_id =
          normalizedValues.platform_partner_id
      }

      // OMS identifier compatibility:
      // backend settings use "*oms_product_identifier*" keys, while this form uses "*oms_identifier*" keys.
      if (normalizedValues.oms_identifier !== undefined) {
        normalizedValues.oms_product_identifier = normalizedValues.oms_identifier
      }
      if (normalizedValues.oms_identifier_primary !== undefined) {
        normalizedValues.oms_product_identifier_primary = normalizedValues.oms_identifier_primary
      }
      if (normalizedValues.secondary_oms_identifier !== undefined) {
        normalizedValues.secondary_oms_product_identifier =
          normalizedValues.secondary_oms_identifier
      }
      if (normalizedValues.primary_oms_identifier !== undefined) {
        normalizedValues.primary_oms_product_identifier = normalizedValues.primary_oms_identifier
      }

      // ERP settings compatibility:
      // Dynamic ERP setting forms use keys like "erp_inventory_setting",
      // while retrieve/create APIs can persist the same data under "inventory_setting".
      if (normalizedValues?.erp_inventory_setting) {
        normalizedValues.inventory_setting = {
          ...(normalizedValues.inventory_setting || {}),
          ...normalizedValues.erp_inventory_setting,
        }
      } else if (normalizedValues?.inventory_setting) {
        normalizedValues.erp_inventory_setting = {
          ...(normalizedValues.erp_inventory_setting || {}),
          ...normalizedValues.inventory_setting,
        }
      }

      const selectedPlatformIdNumber = Number(selectedPlatformId)
      const isPrimarySelected =
        Number(mainStoreData?.id) === selectedPlatformIdNumber ||
        Number(omsStoreData?.id) === selectedPlatformIdNumber ||
        (isRetrievedPrimaryHubStore &&
          Number(retrivedPlatformData?.id) === selectedPlatformIdNumber)
      const selectedPlatformRole = (() => {
        if (!retrivedPlatformData) return 'SECONDARY'
        if (retrivedPlatformData?.isMainStore) return 'PRIMARY'
        if (retrivedPlatformData?.isAccountingStore) return 'ACCOUNTING'
        if (retrivedPlatformData?.isShippingStore) return 'SHIPPING'
        if (isErpLikePlatform(retrivedPlatformData)) return 'ERP'
        if (isOmsLikePlatform(retrivedPlatformData)) return 'OMS'
        if (isTicketLikePlatform(retrivedPlatformData)) return 'TICKET'
        return 'SECONDARY'
      })()

      const normalizeIdentifierValue = (value: any): string => {
        if (value === null || value === undefined) return ''
        return `${value}`.trim()
      }

      const existingProductIdentifierPairs = Array.isArray(
        (retrivedPlatformData?.platform_settings as Record<string, any> | undefined)
          ?.product_identifiers
      )
        ? ((retrivedPlatformData?.platform_settings as Record<string, any>)
            ?.product_identifiers as any[]) ?? []
        : []

      const productIdentifiers: any[] = []

      const addProductIdentifierPair = ({
        platform2,
        platformIdentifier2,
        selectedKey,
        relatedKey,
      }: {
        platform2?: number | null
        platformIdentifier2: string
        selectedKey: string
        relatedKey: string
      }) => {
        const normalizedPlatform2 = Number(platform2)
        if (!Number.isFinite(normalizedPlatform2)) return
        if (!selectedPlatformIdNumber || normalizedPlatform2 === selectedPlatformIdNumber) return

        const selectedValue = normalizeIdentifierValue(normalizedValues?.[selectedKey])
        const relatedValue = normalizeIdentifierValue(normalizedValues?.[relatedKey])

        if (!selectedValue || !relatedValue) return

        const existingPair = findSavedProductIdentifierPair(
          existingProductIdentifierPairs,
          selectedPlatformIdNumber,
          normalizedPlatform2,
          selectedPlatformRole,
          platformIdentifier2
        )

        const nextPair: Record<string, any> = {
          platform1: selectedPlatformIdNumber,
          platform2: normalizedPlatform2,
          platform_identifier1: selectedPlatformRole,
          platform_identifier2: platformIdentifier2,
          platform_product_identifier1: selectedValue,
          platform_product_identifier2: relatedValue,
        }

        if (existingPair?.id) {
          nextPair.id = existingPair.id
        }
        if (existingPair?.platform_setting) {
          nextPair.platform_setting = existingPair.platform_setting
        }

        productIdentifiers.push(nextPair)
      }

      if (mainStoreData?.id && mainStoreData.id !== selectedPlatformIdNumber) {
        addProductIdentifierPair({
          platform2: mainStoreData.id,
          platformIdentifier2: 'PRIMARY',
          selectedKey: isPrimarySelected
            ? 'main_product_identifier'
            : 'secondary_product_identifier',
          relatedKey: isPrimarySelected
            ? 'secondary_product_identifier'
            : 'main_product_identifier',
        })
      }

      if (accountingStoreData?.id) {
        addProductIdentifierPair({
          platform2: accountingStoreData.id,
          platformIdentifier2: 'ACCOUNTING',
          selectedKey: isPrimarySelected
            ? 'primary_accounting_identifier'
            : 'secondary_accounting_identifier',
          relatedKey: isPrimarySelected ? 'accounting_identifier_primary' : 'accounting_identifier',
        })
      }

      if (shippingStoreData?.id) {
        addProductIdentifierPair({
          platform2: shippingStoreData.id,
          platformIdentifier2: 'SHIPPING',
          selectedKey: isPrimarySelected
            ? 'primary_shipping_identifier'
            : 'secondary_shipping_identifier',
          relatedKey: isPrimarySelected ? 'shipping_identifier_primary' : 'shipping_identifier',
        })
      }

      if (erpStoreData?.id) {
        addProductIdentifierPair({
          platform2: erpStoreData.id,
          platformIdentifier2: 'ERP',
          selectedKey: isPrimarySelected ? 'primary_erp_identifier' : 'secondary_erp_identifier',
          relatedKey: isPrimarySelected ? `${ERP_IDENTIFIER_KEY}_primary` : ERP_IDENTIFIER_KEY,
        })
      }

      if (omsStoreData?.id && omsStoreData.id !== selectedPlatformIdNumber) {
        addProductIdentifierPair({
          platform2: omsStoreData.id,
          platformIdentifier2: 'OMS',
          selectedKey: isPrimarySelected ? 'primary_oms_identifier' : 'secondary_oms_identifier',
          relatedKey: isPrimarySelected ? 'oms_identifier_primary' : 'oms_identifier',
        })
      }

      if (
        productIdentifiers.length === 0 &&
        effectivePrimarySourceStoreData?.id &&
        effectivePrimarySourceStoreData.id !== selectedPlatformIdNumber
      ) {
        addProductIdentifierPair({
          platform2: effectivePrimarySourceStoreData.id,
          platformIdentifier2: mainStoreData?.id ? 'PRIMARY' : omsStoreData?.id ? 'OMS' : 'PRIMARY',
          selectedKey: isPrimarySelected
            ? 'main_product_identifier'
            : 'secondary_product_identifier',
          relatedKey: isPrimarySelected
            ? 'secondary_product_identifier'
            : 'main_product_identifier',
        })
      }

      if (identifierMappingPayload?.productIdentifiers?.length) {
        normalizedValues.product_identifiers = identifierMappingPayload.productIdentifiers
        Object.assign(normalizedValues, identifierMappingPayload.legacyScalars)
      } else {
        normalizedValues.product_identifiers = productIdentifiers
      }
      applyLegacyIdentifierScalars(
        normalizedValues,
        Array.isArray(normalizedValues.product_identifiers)
          ? normalizedValues.product_identifiers
          : []
      )

      const isMappingGroupEnabled = (groupCode?: string) => {
        switch (normalizeMappingGroupCode(groupCode)) {
          case 'ORDER':
            return normalizedValues?.order_setting?.isImportOrderToSource === true
          case 'ACCOUNTING_ORDER':
            return normalizedValues?.accounting_order_setting?.isImportOrderToSource === true
          case 'ERP_ORDER':
            return normalizedValues?.erp_order_setting?.isImportOrderToSource === true
          case 'OMS_ORDER':
            return normalizedValues?.oms_order_setting?.isImportOrderToSource === true
          case 'SHIPMENT':
            return normalizedValues?.shipment_setting?.isImportShipmentFromMain === true
          case 'INVENTORY':
            return normalizedValues?.inventory_setting?.isImportInventory === true
          case 'erp_inventory_setting':
            return (
              normalizedValues?.erp_inventory_setting?.isImportInventory === true ||
              normalizedValues?.inventory_setting?.isImportInventory === true
            )
          case 'PRICING':
            return normalizedValues?.pricing_setting?.isImportPrice === true
          case 'PRODUCT':
            return normalizedValues?.product_setting?.isImportProductFromSource === true
          case 'ORDER_PAYOUT':
            return normalizedValues?.order_payout_setting?.isImportOrderPayout === true
          default:
            return true
        }
      }

      const resolveSettingContainerKey = (groupCode?: string) => {
        if (!groupCode) return null
        switch (groupCode) {
          case 'ORDER':
            return 'order_setting'
          case 'ACCOUNTING_ORDER':
            return 'accounting_order_setting'
          case 'ERP_ORDER':
            return 'erp_order_setting'
          case 'OMS_ORDER':
            return 'oms_order_setting'
          case 'SHIPMENT':
            return 'shipment_setting'
          case 'INVENTORY':
            return 'inventory_setting'
          case 'PRICING':
            return 'pricing_setting'
          case 'PRODUCT':
            return 'product_setting'
          case 'ORDER_PAYOUT':
            return 'order_payout_setting'
          case 'IDENTIFIER':
            return null
          default:
            return `${groupCode.toLowerCase()}_setting`
        }
      }

      const hasRequiredValue = (value: any, inputType?: string) => {
        if (inputType === 'BOOLEAN') return true
        if (Array.isArray(value)) return value.length > 0
        if (value === null || value === undefined) return false
        if (typeof value === 'string') return value.trim() !== ''
        return true
      }

      const resolveSettingFieldByGroup = (groupCode?: string) => {
        if (!groupCode) return ''
        if (groupCode === 'ORDER') return 'order'
        if (groupCode === 'ACCOUNTING_ORDER') return 'accounting_order'
        if (groupCode === 'ERP_ORDER') return 'erp_order'
        if (groupCode === 'SHIPMENT') return 'shipment'
        if (groupCode === 'INVENTORY') return 'inventory'
        if (groupCode === 'PRICING') return 'pricing'
        if (groupCode === 'PRODUCT') return 'product'
        return groupCode.toLowerCase()
      }

      const allSettingsForMappingLookup = [
        ...(platformSettings || []),
        ...(primaryPlatformSettings || []),
        ...(accountingPlatformSettings || []),
        ...(shippingPlatformSettings || []),
        ...(erpPlatformSettings || []),
        ...(omsPlatformSettings || []),
        ...(ticketPlatformSettings || []),
      ]

      const platformSettingsMapForControl: Record<string, SETTINGS_OF_PLATFORM[]> = {
        MAIN_STORE_SETTING: primaryPlatformSettings || [],
        ACCOUNTING_STORE_SETTING: accountingPlatformSettings || [],
        SHIPPING_STORE_SETTING: shippingPlatformSettings || [],
        ERP_STORE_SETTING: erpPlatformSettings || [],
        OMS_STORE_SETTING: omsPlatformSettings || [],
        [TICKET_SETTING_TYPE]: ticketPlatformSettings || [],
      }

      const resolveOppositeGroupSettingForControl = (groupSetting: any) => {
        const selectedTypeForGroup = platformSettingByGroup?.[groupSetting?.group_code]?.settingType
        if (!selectedTypeForGroup || !platformSettingsMapForControl[selectedTypeForGroup]) {
          return null
        }
        return findSourcePlatformSettingByGroup(
          platformSettingsMapForControl[selectedTypeForGroup],
          groupSetting?.group_code,
          groupSetting?.name
        )
      }

      const missingRequiredSettingLabels: string[] = []
      const missingKeySet = new Set<string>()

      const requiredValidationGroups = new Set([
        'ORDER',
        'ACCOUNTING_ORDER',
        'ERP_ORDER',
        'OMS_ORDER',
        'SHIPMENT',
        'INVENTORY',
        'PRICING',
        'PRODUCT',
      ])

      const pushMissingSetting = (groupCode: string, settingName: string, displayName: string) => {
        const key = `${groupCode}::${settingName}`
        if (!missingKeySet.has(key)) {
          missingKeySet.add(key)
          missingRequiredSettingLabels.push(displayName || settingName)
        }
      }

      const validateChildSettings = (
        childSettings: any[] | undefined,
        groupCode: string,
        containerValues: Record<string, any>,
        parentEnabled: boolean,
        childVisibility?: {
          formValues: Record<string, any>
          settingField: string
          thisSideChildren: any[]
          oppositeSideChildren: any[]
          settingControlRenderOptions: ReturnType<typeof buildChildSettingControlRenderOptions>
        }
      ) => {
        if (!parentEnabled || !Array.isArray(childSettings) || childSettings.length === 0) return

        childSettings.forEach((child) => {
          const childValue = containerValues?.[child?.name]
          const isChildRequired = !!child?.is_required
          const childInputType = child?.input_type
          const childEnabled = childInputType === 'BOOLEAN' ? Boolean(childValue) : parentEnabled

          const hiddenBySettingControl =
            childVisibility &&
            !shouldRenderChildByDropdownControl(
              child,
              childVisibility.thisSideChildren,
              childVisibility.formValues,
              childVisibility.settingField,
              childVisibility.oppositeSideChildren,
              childVisibility.settingControlRenderOptions
            )

          if (
            !hiddenBySettingControl &&
            isChildRequired &&
            !hasRequiredValue(childValue, childInputType)
          ) {
            pushMissingSetting(groupCode, child?.name, child?.display_name)
          }

          if (Array.isArray(child?.children) && child.children.length) {
            validateChildSettings(
              child.children,
              groupCode,
              containerValues,
              childEnabled,
              childVisibility
            )
          }
        })
      }

      ;(platformSettings || []).forEach((setting: any) => {
        const groupCode = setting?.group_code
        if (!requiredValidationGroups.has(groupCode)) return
        if (!isMappingGroupEnabled(groupCode)) return

        const containerKey = resolveSettingContainerKey(groupCode)
        const containerValues = containerKey
          ? normalizedValues?.[containerKey] || {}
          : normalizedValues

        const settingValue = containerValues?.[setting?.name]
        const isSettingRequired = !!setting?.is_required
        const settingInputType = setting?.input_type
        const settingEnabled = settingInputType === 'BOOLEAN' ? Boolean(settingValue) : true

        if (isSettingRequired && !hasRequiredValue(settingValue, settingInputType)) {
          pushMissingSetting(groupCode, setting?.name, setting?.display_name)
        }

        if (Array.isArray(setting?.children) && setting.children.length) {
          const relatedGroupSetting = resolveOppositeGroupSettingForControl(setting)
          validateChildSettings(
            setting.children,
            groupCode,
            containerValues,
            settingEnabled,
            {
              formValues: normalizedValues,
              settingField: resolveSettingFieldByGroup(groupCode),
              thisSideChildren: setting.children ?? [],
              oppositeSideChildren: relatedGroupSetting?.children ?? [],
              settingControlRenderOptions: buildChildSettingControlRenderOptions(
                setting,
                relatedGroupSetting,
                fieldMappingsForSave,
                savedMappings
              ),
            }
          )
        }
      })

      if (missingRequiredSettingLabels.length) {
        setMissingRequiredMappingKeys(new Set())
        const fieldsPreview = missingRequiredSettingLabels.slice(0, 3).join(', ')
        const moreCount = missingRequiredSettingLabels.length - 3
        warningToast(
          moreCount > 0
            ? `Please fill required fields: ${fieldsPreview} and ${moreCount} more.`
            : `Please fill required fields: ${fieldsPreview}.`
        )
        helpers.setSubmitting(false)
        setIsSaving(false)
        return
      }

      const requiredActiveFieldMappings = fieldMappingsForSave.filter((mapping: any) => {
        if (!isMappingGroupEnabled(mapping?.groupCode)) return false
        if (
          !shouldValidatePayoutMapping(
            normalizedValues,
            mapping?.groupCode,
            mapping?.fieldCode ?? mapping?.api_code
          )
        ) {
          return false
        }
        return !!mapping?.isRequired
      })

      const missingRequiredFromVisibleMappings = requiredActiveFieldMappings.filter(
        (mapping: any) => {
          if (
            !isPendingFieldMappingVisibleForSettingControl(
              mapping?.setting_mapping_id,
              allSettingsForMappingLookup,
              fieldMappingsForSave,
              savedMappings,
              resolveOppositeGroupSettingForControl
            )
          ) {
            return false
          }
          const dataset = mapping?.fieldMappingDataSet || []
          if (!dataset.length) return true
          return !hasMappingDatasetValue(dataset, mapping)
        }
      )

      const missingRequiredFromSettingDefinitions: string[] = []
      const missingRequiredMappingLabels: string[] = []
      const seenMissingMappingLabels = new Set<string>()

      const addMissingMappingLabel = (label?: string | null) => {
        const normalized = `${label ?? ''}`.trim()
        if (!normalized || seenMissingMappingLabels.has(normalized)) return
        seenMissingMappingLabels.add(normalized)
        missingRequiredMappingLabels.push(normalized)
      }

      ;(platformSettings || []).forEach((setting: any) => {
        if (!isMappingGroupEnabled(setting?.group_code)) return

        const settingField = resolveSettingFieldByGroup(setting?.group_code)
        const isSettingEnabled =
          !!normalizedValues?.[`${settingField}_setting`]?.[`${setting?.name}`]
        if (!isSettingEnabled) return

        const platformSettingsMap: Record<string, SETTINGS_OF_PLATFORM[]> = {
          MAIN_STORE_SETTING: primaryPlatformSettings || [],
          ACCOUNTING_STORE_SETTING: accountingPlatformSettings || [],
          SHIPPING_STORE_SETTING: shippingPlatformSettings || [],
          ERP_STORE_SETTING: erpPlatformSettings || [],
          OMS_STORE_SETTING: omsPlatformSettings || [],
          [TICKET_SETTING_TYPE]: ticketPlatformSettings || [],
        }

        const selectedTypeForGroup = platformSettingByGroup?.[setting?.group_code]?.settingType
        const relatedGroupSetting =
          selectedTypeForGroup && platformSettingsMap[selectedTypeForGroup]
            ? findSourcePlatformSettingByGroup(
                platformSettingsMap[selectedTypeForGroup],
                setting?.group_code,
                setting?.name
              )
            : null

        const collectRequiredMappings = (groupSetting: any, oppositeGroupSetting: any) => {
          if (!groupSetting || !(groupSetting?.mappings_data?.length > 0)) return []
          const fieldMappingMetaMap = buildFieldMappingMetaMap(groupSetting?.field_mappings)
          return (groupSetting?.mappings_data || [])
            .map((mapping: any) => enrichFieldMapping(mapping, fieldMappingMetaMap))
            .filter(
              (mapping: any) =>
                shouldValidatePayoutMapping(
                  normalizedValues,
                  setting?.group_code,
                  mapping?.field_code ?? mapping?.api_code
                ) &&
                isMappingDependencySatisfied(mapping) &&
                shouldRenderMappingByDropdownControl(
                  mapping,
                  groupSetting?.mappings_data || [],
                  fieldMappingsForSave,
                  savedMappings,
                  oppositeGroupSetting?.mappings_data || []
                ) &&
                mapping?.isRequired
            )
        }

        const requiredMappingContexts: Array<{
          mapping: any
          owningGroupSetting: any
          oppositeGroupSetting: any
        }> = []
        const seenRequiredSettingMappingIds = new Set<number>()

        const appendRequiredMappingContexts = (
          groupSetting: any,
          oppositeGroupSetting: any
        ) => {
          collectRequiredMappings(groupSetting, oppositeGroupSetting).forEach((mapping: any) => {
            const settingMappingId = mapping?.setting_mapping_id
            if (
              settingMappingId === undefined ||
              settingMappingId === null ||
              seenRequiredSettingMappingIds.has(settingMappingId)
            ) {
              return
            }

            seenRequiredSettingMappingIds.add(settingMappingId)
            requiredMappingContexts.push({
              mapping,
              owningGroupSetting: groupSetting,
              oppositeGroupSetting,
            })
          })
        }

        appendRequiredMappingContexts(setting, relatedGroupSetting)
        appendRequiredMappingContexts(relatedGroupSetting, setting)

        if (!requiredMappingContexts.length) return

        requiredMappingContexts.forEach(
          ({mapping, owningGroupSetting, oppositeGroupSetting}) => {
            const settingMappingId = mapping?.setting_mapping_id
            if (settingMappingId === undefined || settingMappingId === null) {
              return
            }

            const matchingFieldMappings = fieldMappingsForSave.filter(
              (item: any) => item?.setting_mapping_id === settingMappingId
            )

            if (
              shouldSkipRequiredMappingValidation({
                mapping,
                owningGroupSetting,
                oppositeGroupSetting,
                matchingFieldMappings,
                allPendingMappings: fieldMappingsForSave,
                allSavedMappings: savedMappings,
                resolveMappingValue: getMappingValueBySettingMappingId,
              })
            ) {
              return
            }

            missingRequiredFromSettingDefinitions.push(
              buildMappingErrorKey({
                groupCode: `${settingField}_setting`,
                settingMappingId,
                fieldCode: mapping?.field_code,
                apiCode: mapping?.api_code,
                isDefault: mapping?.isDefault,
              })
            )
            addMissingMappingLabel(
              mapping?.display_name ||
                findMappingDisplayNameInSettingsCatalog(
                  allSettingsForMappingLookup,
                  settingMappingId,
                  mapping?.api_code || mapping?.field_code
                )
            )
          }
        )
      })

      missingRequiredFromVisibleMappings.forEach((mapping: any) => {
        addMissingMappingLabel(
          findMappingDisplayNameInSettingsCatalog(
            allSettingsForMappingLookup,
            mapping?.setting_mapping_id,
            mapping?.fieldCode
          )
        )
      })

      const nextMissingRequiredMappingKeys = new Set<string>([
        ...missingRequiredFromVisibleMappings.map((mapping: any) =>
          buildMappingErrorKey({
            groupCode: mapping?.groupCode,
            settingMappingId: mapping?.setting_mapping_id,
            fieldCode: mapping?.fieldCode,
            apiCode: mapping?.api_code,
            isDefault: mapping?.isDefault,
          })
        ),
        ...missingRequiredFromSettingDefinitions,
      ])

      if (nextMissingRequiredMappingKeys.size > 0) {
        setMissingRequiredMappingKeys(nextMissingRequiredMappingKeys)
        const fieldsPreview = missingRequiredMappingLabels.slice(0, 3).join(', ')
        const moreCount = missingRequiredMappingLabels.length - 3
        warningToast(
          missingRequiredMappingLabels.length > 0
            ? moreCount > 0
              ? `Please complete required mappings: ${fieldsPreview} and ${moreCount} more.`
              : missingRequiredMappingLabels.length === 1
              ? `Please complete required mapping: ${fieldsPreview}.`
              : `Please complete required mappings: ${fieldsPreview}.`
            : 'Please select a value for all required mappings before saving.'
        )
        window.requestAnimationFrame(() => {
          document.querySelector('.mapping-required-missing')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
        })
        helpers.setSubmitting(false)
        setIsSaving(false)
        return
      }
      setMissingRequiredMappingKeys(new Set())

      const allSettings = {
        platformId: Number(selectedPlatformId),
        ...normalizedValues,
      } as unknown as PlatformSettingDataTypesValues
      try {
        if (isChannelSettingsSaveDebugEnabled()) {
          inspectChannelSettingsSaveBeforeApi({
            settingsPayload: allSettings as Record<string, unknown>,
            fieldMappings: fieldMappingsForSave,
            savedMappings,
            platformSettings: (retrivedPlatformData?.platform_settings ?? null) as Record<
              string,
              any
            > | null,
            selectedPlatformId,
          })
        }
        setIsSaving(true)
        dispatch(createPlatformSettingAsync(allSettings)).then(async (response) => {
          if (response?.payload?.__channelSettingsSaveDebugBlocked) {
            helpers.setSubmitting(false)
            setIsSaving(false)
            return
          }
          if (response?.payload?.status_code === 200) {
            if (response.payload?.data && fieldMappingsForSave.length) {
              const field_mapping_ids: any = []
              const payload: any = []
              // Track mapping IDs per platform
              const platformMappingIdSet: Record<string, Set<any>> = {}
              const normalizedFieldMappings = dedupeFieldMappingsForSave(
                fieldMappingsForSave,
                savedMappings
              )
              for (let settingField of normalizedFieldMappings) {
                if (response.payload?.data[settingField.groupCode]) {
                  const mappingDataset = settingField.fieldMappingDataSet || []

                  const hasAnyMappingValue = (item: any) => {
                    const hasPersistedMappingDataId = item?.id !== null && item?.id !== undefined
                    const hasDest =
                      (item.destination_platform_data_id !== null &&
                        item.destination_platform_data_id !== undefined &&
                        item.destination_platform_data_id !== '') ||
                      (item.destination_platform_data_str ?? '') !== ''
                    const hasSource =
                      (item.source_platform_data_id !== null &&
                        item.source_platform_data_id !== undefined &&
                        item.source_platform_data_id !== '') ||
                      (item.source_platform_data_str ?? '') !== ''
                    const requiresSourcePair =
                      !settingField?.isDefault &&
                      settingField?.sourceFieldId !== null &&
                      settingField?.sourceFieldId !== undefined
                    const hasPair = item?.hasPair !== false
                    return {
                      hasPersistedMappingDataId,
                      hasDest,
                      hasSource,
                      hasPair,
                      hasValue: requiresSourcePair ? hasDest && hasSource : hasDest,
                    }
                  }

                  const hadPersistedMappingEntries = mappingDataset.some(
                    (item) => item?.id !== null && item?.id !== undefined
                  )

                  const clearedPersistedRows = mappingDataset.filter((item) => {
                    const {hasPersistedMappingDataId, hasValue} = hasAnyMappingValue(item)
                    return hasPersistedMappingDataId && !hasValue
                  })

                  const clearedPersistedRowIds = new Set(
                    clearedPersistedRows.map((item) => item.id)
                  )

                  const sanitizedDataset = mappingDataset.filter((item) => {
                    if (
                      item?.id !== null &&
                      item?.id !== undefined &&
                      clearedPersistedRowIds.has(item.id)
                    ) {
                      return false
                    }
                    const {hasPersistedMappingDataId, hasPair, hasValue} = hasAnyMappingValue(item)
                    return (hasPersistedMappingDataId && hasValue) || (hasPair && hasValue)
                  })

                  let mapping_for_save = sanitizedDataset.map((item) => ({
                    ...(item?.id ? {id: item.id} : {}),
                    source_platform_data_id:
                      item?.source_platform_data_id !== undefined
                        ? item.source_platform_data_id
                        : null,
                    destination_platform_data_id:
                      item?.destination_platform_data_id !== null &&
                      item?.destination_platform_data_id !== undefined &&
                      item?.destination_platform_data_id !== '' &&
                      /^[+-]?\d+$/.test(item.destination_platform_data_id)
                        ? Number(item.destination_platform_data_id)
                        : item?.destination_platform_data_id ?? null,
                    source_platform_data_str: item?.source_platform_data_str ?? '',
                    destination_platform_data_str: item?.destination_platform_data_str ?? '',
                    isDefault: settingField?.isDefault,
                  }))

                  const hasExistingMappingId =
                    settingField?.savedMappingId !== null &&
                    settingField?.savedMappingId !== undefined
                      ? true
                      : settingField?.field_mapping_id !== null &&
                        settingField?.field_mapping_id !== undefined

                  if (
                    mapping_for_save.length === 0 &&
                    !hadPersistedMappingEntries &&
                    !hasExistingMappingId
                  ) {
                    mapping_for_save = [
                      {
                        source_platform_data_id: null,
                        destination_platform_data_id: null,
                        source_platform_data_str: '',
                        destination_platform_data_str: '',
                        isDefault: settingField?.isDefault,
                      },
                    ]
                  }

                  const resolveMappingIdForQuery = (mappingField: any) => {
                    const directId = mappingField?.savedMappingId ?? mappingField?.field_mapping_id
                    if (directId !== null && directId !== undefined) {
                      return directId
                    }

                    const fallbackFromSavedMappings = (savedMappings || []).find(
                      (savedItem: any) => {
                        if (!savedItem) return false

                        const destinationMatch =
                          mappingField?.destinationFieldId !== null &&
                          mappingField?.destinationFieldId !== undefined &&
                          savedItem?.destination_field?.id === mappingField?.destinationFieldId

                        const sourceMatch =
                          mappingField?.sourceFieldId === null ||
                          mappingField?.sourceFieldId === undefined
                            ? savedItem?.source_field === null
                            : savedItem?.source_field?.id === mappingField?.sourceFieldId

                        const defaultMatch =
                          mappingField?.isDefault === undefined ||
                          savedItem?.isDefault === mappingField?.isDefault

                        const groupSettingMatch =
                          mappingField?.savedSettingId === null ||
                          mappingField?.savedSettingId === undefined ||
                          savedItem?.setting_id === mappingField?.savedSettingId

                        if (destinationMatch && sourceMatch && defaultMatch && groupSettingMatch) {
                          return true
                        }

                        const hasPairIdentity =
                          mappingField?.destinationFieldId !== null &&
                          mappingField?.destinationFieldId !== undefined

                        return (
                          !hasPairIdentity &&
                          mappingField?.setting_mapping_id !== null &&
                          mappingField?.setting_mapping_id !== undefined &&
                          savedItem?.setting_mapping_id === mappingField?.setting_mapping_id
                        )
                      }
                    )

                    return fallbackFromSavedMappings?.id ?? null
                  }

                  // Platform-specific mapping ID logic
                  const mappingIdForQuery = resolveMappingIdForQuery(settingField)
                  const platformKey = String(settingField.platformId || selectedPlatformId)
                  if (mappingIdForQuery !== null && mappingIdForQuery !== undefined) {
                    if (!platformMappingIdSet[platformKey])
                      platformMappingIdSet[platformKey] = new Set()
                    platformMappingIdSet[platformKey].add(mappingIdForQuery)
                  }
                  if (!isFieldMappingSaveable(settingField, mapping_for_save)) {
                    continue
                  }
                  payload.push({
                    [settingField.groupCode + '_id']:
                      response.payload?.data[settingField.groupCode]['id'],
                    field_mapping_id: settingField.field_mapping_id ?? mappingIdForQuery ?? null,
                    isDefault: settingField?.isDefault,
                    setting_mapping_id: resolveSettingMappingIdForSave(
                      settingField,
                      savedMappings
                    ),
                    source_field_id: settingField.sourceFieldId,
                    destination_field_id: settingField.destinationFieldId,
                    fieldmappingdata_set: mapping_for_save || [],
                  })
                }
              }
              // Only include mapping IDs for the current platform
              const currentPlatformKey = String(selectedPlatformId)
              const uniqueFieldMappingIds = platformMappingIdSet[currentPlatformKey]
                ? Array.from(platformMappingIdSet[currentPlatformKey])
                : []
              await dispatch(
                saveFieldMappingsAsync({field_mapping_ids: uniqueFieldMappingIds as any, payload})
              )
                .then((response) => {
                  if (response.meta.requestStatus === 'fulfilled') {
                    successToast('Channel settings saved successfully !')
                    helpers.setSubmitting(false)
                    setIsMappingChanged(!isMappingChanged)
                  } else {
                    errorToast(`Failed to save settings. ${response?.payload?.data?.message}`)
                    helpers.setSubmitting(false)
                  }
                })
                .catch((error) => {
                  console.log(error)
                })
            } else {
              successToast('Channel settings saved successfully !')
              helpers.setSubmitting(false)
            }
            dispatch(fetchConnectedPlatformAsync())
            if (isFromOnboarding) {
              await dispatch(setInitialPopupDataAsync({isOnboardingProcessCompleted: true}))
              afterSettingCB?.()
              if (fetchedUserAccountData?.is_subscribed) {
                navigate('/dashboard')
              } else {
                navigate('/pricing')
              }
            }

            if (selectedPlatformId) {
              const retrieveRes = await dispatch(
                retrivePlatformDataAsync({id: selectedPlatformId, fetch_limited_data: true})
              )
              setRetrivedPlatformData(retrieveRes?.payload ?? null)
              setRefreshMapping((prev) => !prev)
            }

            if (!isFromOnboarding) onSave?.()
          } else if (response?.payload?.data?.status_code === 400) {
            warningToast(response?.payload?.data?.massage)
            helpers.setSubmitting(false)
          } else if (response?.payload?.data?.status_code === 500) {
            warningToast(response?.payload?.data?.massage)
            helpers.setSubmitting(false)
          } else {
            warningToast('Setting not updated')
            helpers.setSubmitting(false)
          }
        })
        if (retrivedPlatformData?.code === 'TEMU') {
          dispatch(
            setPlatformTokenDatasync({
              id: {id: selectedPlatformId},
              payload: {expiry_date: temuTokenData.expire_date, token: temuTokenData.token},
            })
          )
            .then(() => undefined)
            .catch(() => undefined)
        }
      } catch (error) {
        helpers.setSubmitting(false)
      }
      const id = Number(selectedPlatformId)!
      const display_name = connectedPlatformData?.display_name
      const isActive = connectedPlatformData?.isActive == false ? true : true
      const payload = {
        display_name,
        isActive,
      }

      dispatch(isActiveBoolean({...payload, id}))
    },
  })

  useEffect(() => {
    const syncResult = runSettingControlHiddenStateSync({
      fieldMappings,
      formValues: values,
      savedMappings,
      syncPairs: settingControlSyncPairs,
    })
    if (syncResult.mappingsChanged) {
      setFieldMappings(syncResult.fieldMappings)
    }
    if (syncResult.valuesChanged) {
      setValues(syncResult.formValues)
    }
  }, [fieldMappings, values, savedMappings, settingControlSyncPairs, setValues])

  useEffect(() => {
    const nestedSyncResult = runNestedMappingParentHiddenStateSync({
      fieldMappings,
      syncPairs: settingControlSyncPairs,
      resolveMappingValue: (id) => getMappingValueBySettingMappingId(id),
    })
    if (nestedSyncResult.mappingsChanged) {
      setFieldMappings(nestedSyncResult.fieldMappings)
    }
  }, [fieldMappings, settingControlSyncPairs, getMappingValueBySettingMappingId])

  useEffect(() => {
    dispatch(fetchConnectedPlatformAsync())
  }, [dispatch])

  useEffect(() => {
    const fetchSettings = async () => {
      const canFetch =
        availablePlatformId &&
        selectedPlatformId &&
        fetchedConnectedPlatformData &&
        !fetchedConnectedPlatformLoading

      if (!canFetch) {
        setRetriveDataLoading(true)
        setLoadingFormFields(true)
        return
      }

      const requestSignature = JSON.stringify({
        availablePlatformId,
        selectedPlatformId,
        refreshMapping,
        mainStoreId: mainStoreData?.id ?? null,
        accountingStoreId: accountingStoreData?.id ?? null,
        shippingStoreId: shippingStoreData?.id ?? null,
        erpStoreId: erpStoreData?.id ?? null,
        omsStoreId: omsStoreData?.id ?? null,
        ticketStoreId: ticketStoreData?.id ?? null,
      })

      if (
        lastSettingsRequestSignatureRef.current === requestSignature ||
        settingsFetchInFlightRef.current === requestSignature
      ) {
        return
      }

      lastSettingsRequestSignatureRef.current = requestSignature
      settingsFetchInFlightRef.current = requestSignature
      const fetchGeneration = ++settingsFetchGenerationRef.current

      setRetriveDataLoading(true)
      setLoadingFormFields(true)

      try {
          const resp = await dispatch(
            retrivePlatformDataAsync({id: selectedPlatformId, fetch_limited_data: true})
          )
          if (fetchGeneration !== settingsFetchGenerationRef.current) {
            return
          }

          setRetrivedPlatformData(resp.payload)
          const {isMainStore, isAccountingStore, isShippingStore, isErpStore, isOmsStore} =
            resp.payload
          const isErpStoreResolved = Boolean(isErpStore || isErpLikePlatform(resp.payload))
          const isOmsStoreResolved = Boolean(isOmsStore || isOmsLikePlatform(resp.payload))
          const isTicketStoreResolved = Boolean(
            resp.payload?.isTicketStore || isTicketLikePlatform(resp.payload)
          )
          const isPrimaryHubStore = isMainStore || isOmsStoreResolved
          const isSecondaryDestinationStore =
            isTicketStoreResolved ||
            (!isMainStore &&
              !isAccountingStore &&
              !isShippingStore &&
              !isErpStoreResolved &&
              !isOmsStoreResolved)

          const selectedSettingType = isMainStore
            ? 'MAIN_STORE_SETTING'
            : isAccountingStore
            ? 'ACCOUNTING_STORE_SETTING'
            : isShippingStore
            ? 'SHIPPING_STORE_SETTING'
            : isErpStoreResolved
            ? 'ERP_STORE_SETTING'
            : isOmsStoreResolved
            ? 'OMS_STORE_SETTING'
            : isTicketStoreResolved
            ? TICKET_SETTING_TYPE
            : 'SECONDARY_STORE_SETTING'

          type PrimarySettingsKey =
            | 'primary'
            | 'accounting'
            | 'shipping'
            | 'erp'
            | 'oms'
            | 'ticket'

          const primarySettingsFetches: Array<{
            key: PrimarySettingsKey
            promise: Promise<unknown>
          }> = []

          const queuePrimarySettingsFetch = (
            key: PrimarySettingsKey,
            storeData: typeof mainStoreData,
            type: string
          ) => {
            if (!storeData?.platform_info?.id || !storeData?.id) {
              return
            }

            primarySettingsFetches.push({
              key,
              promise: dispatch(
                getSettingsOfPrimaryPlatformAsyncNew({
                  primaryAvailablePlatformId: storeData.platform_info.id,
                  selectedPlatformId,
                  primaryPlatformId: storeData.id,
                  erp_flow: true,
                  type,
                })
              ),
            })
          }

          if (isSecondaryDestinationStore) {
            queuePrimarySettingsFetch(
              'primary',
              effectivePrimarySourceStoreData,
              effectivePrimarySourceSettingType
            )
            queuePrimarySettingsFetch(
              'accounting',
              accountingStoreData,
              'ACCOUNTING_STORE_SETTING'
            )
            queuePrimarySettingsFetch('shipping', shippingStoreData, 'SHIPPING_STORE_SETTING')
            queuePrimarySettingsFetch('erp', erpStoreData, 'ERP_STORE_SETTING')
            if (omsStoreData && omsStoreData.id !== Number(selectedPlatformId)) {
              queuePrimarySettingsFetch('oms', omsStoreData, 'OMS_STORE_SETTING')
            }
            if (ticketStoreData && ticketStoreData.id !== Number(selectedPlatformId)) {
              queuePrimarySettingsFetch('ticket', ticketStoreData, TICKET_SETTING_TYPE)
            }
          }

          if (isPrimaryHubStore) {
            queuePrimarySettingsFetch(
              'accounting',
              accountingStoreData,
              'ACCOUNTING_STORE_SETTING'
            )
            queuePrimarySettingsFetch('shipping', shippingStoreData, 'SHIPPING_STORE_SETTING')
            queuePrimarySettingsFetch('erp', erpStoreData, 'ERP_STORE_SETTING')
            if (omsStoreData && omsStoreData.id !== Number(selectedPlatformId)) {
              queuePrimarySettingsFetch('oms', omsStoreData, 'OMS_STORE_SETTING')
            }
            if (ticketStoreData && ticketStoreData.id !== Number(selectedPlatformId)) {
              queuePrimarySettingsFetch('ticket', ticketStoreData, TICKET_SETTING_TYPE)
            }
          }

          const [selectedRes, ...primarySettingsResults] = await Promise.all([
            dispatch(
              getSettingsOfSelectedPlatformAsyncNew({
                availablePlatformId,
                primaryPlatformId:
                  effectivePrimarySourceStoreData?.id! ||
                  accountingStoreData?.id! ||
                  shippingStoreData?.id! ||
                  erpStoreData?.id! ||
                  omsStoreData?.id!,
                platform_id: selectedPlatformId,
                erp_flow: true,
                type: selectedSettingType,
              })
            ),
            ...primarySettingsFetches.map(({promise}) => promise),
          ])

          if (fetchGeneration !== settingsFetchGenerationRef.current) {
            return
          }

          let primaryRes: any
          let accountingRes: any
          let shippingRes: any
          let erpRes: any
          let omsRes: any
          let ticketRes: any

          primarySettingsFetches.forEach(({key}, index) => {
            const result = primarySettingsResults[index]
            switch (key) {
              case 'primary':
                primaryRes = result
                break
              case 'accounting':
                accountingRes = result
                break
              case 'shipping':
                shippingRes = result
                break
              case 'erp':
                erpRes = result
                break
              case 'oms':
                omsRes = result
                break
              case 'ticket':
                ticketRes = result
                break
            }
          })

          // Handle Selected Platform Settings
          let selectedData = selectedRes?.payload?.data ?? []

          // Frontend remap for WIX when it is the secondary store:
          // The API returns the secondary identifier as main_product_identifier.
          // Rename to secondary_product_identifier to avoid key collisions with the primary identifier.
          if (resp?.payload?.code === 'WIX' && !resp?.payload?.isMainStore) {
            selectedData = selectedData.map((setting) => {
              if (
                setting?.group_code === 'IDENTIFIER' &&
                setting?.name === 'main_product_identifier'
              ) {
                return {...setting, name: 'secondary_product_identifier'}
              }
              return setting
            })
          }

          selectedData = sortChannelSettingsCatalog(selectedData)

          if (selectedData.length) {
            setPlatformSettings(selectedData)

            const currentPlatformSettings = selectedData
            let shadow = {...formFields}
            const uniqueSettingSourceTypes = new Set()
            const uniqueSettingSources: any = []

            currentPlatformSettings.forEach((groupItem) => {
              let InitialValues = {}
              let settingField =
                groupItem.group_code === 'ORDER'
                  ? 'order'
                  : groupItem.group_code === 'PRODUCT'
                  ? 'product'
                  : groupItem.group_code === 'INVENTORY'
                  ? 'inventory'
                  : groupItem.group_code === 'SHIPMENT'
                  ? 'shipment'
                  : groupItem.group_code === 'PRICING'
                  ? 'pricing'
                  : groupItem.group_code === 'TICKET'
                  ? TICKET_SETTING_FIELD
                  : groupItem?.setting_source?.setting_type === TICKET_SETTING_TYPE
                  ? TICKET_SETTING_FIELD
                  : groupItem.group_code.toLowerCase()

              if (!InitialValues[`${settingField}_setting`]) {
                InitialValues[`${settingField}_setting`] = {}

                // Add selected source for settings that can choose a source platform.
                const availableSourceOptions = getAvailableSourcesForSetting(groupItem)
                if (['shipment', ORDER_PAYOUT_SETTING_FIELD, TICKET_SETTING_FIELD].includes(settingField)) {
                  const initialSourceId =
                    groupItem?.setting_source?.platform_id ??
                    availableSourceOptions?.[0]?.id ??
                    null
                  InitialValues[`${settingField}_setting`][`selected_source_platform`] = {}
                  InitialValues[`${settingField}_setting`][`selected_source_platform`]['id'] =
                    initialSourceId
                  InitialValues[`${settingField}_setting`][`selected_source_platform_id`] =
                    initialSourceId
                }
              }

              // Initialize each top-level field (multiple settings can share one *_setting object).
              if (
                InitialValues[`${settingField}_setting`][`${groupItem.name}`] === undefined
              ) {
                if (groupItem.input_type === 'BOOLEAN') {
                  InitialValues[`${settingField}_setting`][`${groupItem.name}`] = false
                } else if (groupItem.input_type === 'INTEGER') {
                  InitialValues[`${settingField}_setting`][`${groupItem.name}`] = 0
                } else if (groupItem.input_type === 'DATETIME') {
                  InitialValues[`${settingField}_setting`][`${groupItem.name}`] = null
                } else {
                  InitialValues[`${settingField}_setting`][`${groupItem.name}`] = ''
                }
              }

              // Handle children
              if (groupItem.children.length) {
                groupItem.children.forEach((childItem) => {
                  let defaultValue =
                    childItem.input_type === 'BOOLEAN'
                      ? false
                      : childItem.input_type === 'INTEGER'
                      ? 0
                      : childItem.input_type === 'DATETIME'
                      ? null
                      : ''

                  if (
                    settingField === TICKET_SETTING_FIELD &&
                    childItem.group_code === 'TICKET' &&
                    childItem.name === TICKET_DEFAULT_CUSTOMER_FIELD &&
                    `${childItem.input_type ?? ''}`.endsWith('_READONLY')
                  ) {
                    defaultValue = getSettingReadonlyFallbackValue(childItem)
                  }

                  InitialValues[`${settingField}_setting`][`${childItem.name}`] = defaultValue

                  if (childItem.children.length) {
                    const children = generateInitialKeyFromChildrenForPlatformSetting(
                      childItem.children
                    )
                    InitialValues[`${settingField}_setting`] = {
                      ...InitialValues[`${settingField}_setting`],
                      ...children,
                    }
                  }
                })
              }

              shadow = {...shadow, ...InitialValues}

              // Get setting source channels
              if (groupItem?.setting_source) {
                const source = groupItem.setting_source
                const type = source?.setting_type
                if (type && !uniqueSettingSourceTypes.has(type)) {
                  uniqueSettingSourceTypes.add(type)
                  uniqueSettingSources.push(source)
                }
              }
              const {group_code, available_sources, setting_source} = groupItem
              const settingType =
                setting_source?.setting_type ??
                (group_code === 'ACCOUNTING_ORDER'
                  ? 'ACCOUNTING_STORE_SETTING'
                  : group_code === 'ERP_ORDER'
                  ? 'ERP_STORE_SETTING'
                  : group_code === 'OMS_ORDER'
                  ? 'OMS_STORE_SETTING'
                  : group_code === 'SHIPMENT'
                  ? available_sources?.[0]?.setting_type
                  : group_code === 'TICKET'
                  ? TICKET_SETTING_TYPE
                  : fallbackSourceSettingType)

              setPlatformSettingByGroup((prev) => ({
                ...prev,
                [groupItem.group_code]: {
                  ...prev[groupItem.group_code],
                  showSetting: true,
                  settingType: settingType,
                },
              }))
            })
            setFormFields(shadow)

            // Fetch store settings as per source
            const uniqueSettingSourceTypesArray = Array.from(uniqueSettingSourceTypes)
            setFetchedSettingTypes(uniqueSettingSourceTypesArray)
            // uniqueSettingSources.forEach((setting:any)=>{
            //   if(setting.setting_type !== 'MAIN_STORE_SETTING'){
            //   dispatch(getSettingsOfPrimaryPlatformAsyncNew({
            //       primaryAvailablePlatformId: setting.available_platform_id,
            //       selectedPlatformId: selectedPlatformId,
            //       primaryPlatformId: setting.platform_id,
            //       erp_flow: [389, 1017, 1022].includes(fetchedUserAccountData?.id!) ? true : false,
            //       type: setting.setting_type
            //    })).then((response)=>
            //     {
            //       if(setting.setting_type === 'ACCOUNTING_STORE_SETTING')setAccountingPlatformSettings(response?.payload?.data)
            //       if(setting.setting_type === 'SHIPPING_STORE_SETTING')setShippingPlatformSettings(response?.payload?.data)
            // })}
            // })
          }

          // Handle Primary Platform Settings
          const primaryData = primaryRes?.payload?.data ?? []
          setPrimaryPlatformSettings(sortChannelSettingsCatalog(primaryData))
          setAccountingPlatformSettings(sortChannelSettingsCatalog(accountingRes?.payload?.data ?? []))
          setShippingPlatformSettings(sortChannelSettingsCatalog(shippingRes?.payload?.data ?? []))
          setErpPlatformSettings(sortChannelSettingsCatalog(erpRes?.payload?.data ?? []))
          setOmsPlatformSettings(sortChannelSettingsCatalog(omsRes?.payload?.data ?? []))
          setTicketPlatformSettings(
            sortChannelSettingsCatalog(
              isTicketStoreResolved
                ? selectedRes?.payload?.data ?? []
                : ticketRes?.payload?.data ?? []
            )
          )
      } catch (err) {
        if (fetchGeneration !== settingsFetchGenerationRef.current) {
          return
        }
        console.error('Error while fetching platform settings:', err)
        setPlatformSettings([])
        setPrimaryPlatformSettings([])
        setAccountingPlatformSettings([])
        setShippingPlatformSettings([])
        setErpPlatformSettings([])
        setOmsPlatformSettings([])
        setTicketPlatformSettings([])
      } finally {
        if (settingsFetchInFlightRef.current === requestSignature) {
          settingsFetchInFlightRef.current = null
        }
        if (fetchGeneration === settingsFetchGenerationRef.current) {
          setLoadingFormFields(false)
          setRetriveDataLoading(false)
        }
      }
    }
    fetchSettings()
  }, [
    availablePlatformId,
    selectedPlatformId,
    fetchedConnectedPlatformData,
    fetchedConnectedPlatformLoading,
    refreshMapping,
    mainStoreData?.id,
    accountingStoreData?.id,
    shippingStoreData?.id,
    erpStoreData?.id,
    omsStoreData?.id,
    ticketStoreData?.id,
  ])

  const generateInitialKeyFromChildrenForPlatformSetting = (fields: SETTINGS_OF_PLATFORM[]) => {
    const initialValues = {}

    fields.forEach((field) => {
      if (field.input_type === 'BOOLEAN') {
        initialValues[field.name] = false
      } else if (field.input_type === 'TEXT') {
        initialValues[field.name] = ''
      } else if (field.input_type === 'DATETIME') {
        initialValues[field.name] = null
      } else if (field.input_type === 'INTEGER') {
        initialValues[field.name] = 0
      } else {
        initialValues[field.name] = '' // Default to empty string for other types
      }

      // Recursively handle children
      if (field.children && field.children.length > 0) {
        const childValues = generateInitialKeyFromChildrenForPlatformSetting(field.children)
        Object.assign(initialValues, childValues)
      }
    })

    return initialValues
  }

  // Check if a identifier already has some saved value
  useEffect(() => {
    if (!retrivedPlatformData?.platform_settings) return

    const platformSettings = retrivedPlatformData.platform_settings as Record<string, any>

    setHasIdentifier((prev) => {
      const updated: typeof prev = {...prev}

      for (const key in updated) {
        if (!Object.prototype.hasOwnProperty.call(updated, key)) {
          continue
        }

        updated[key] = Boolean(platformSettings?.[key])
      }

      // WIX as secondary: backend stores the secondary identifier under main_product_identifier.
      if (retrivedPlatformData?.code === 'WIX' && !retrivedPlatformData?.isMainStore) {
        updated.secondary_product_identifier = Boolean(
          platformSettings?.secondary_product_identifier ??
            platformSettings?.main_product_identifier
        )
      }

      return updated
    })
  }, [retrivedPlatformData, refreshMapping])

  // this effect is work to set the saved setting in shown fields
  useEffect(() => {
    const field_mapping_ids: any = []
    setLoadInitialKeyValues(true)
    if (formFields && retrivedPlatformData?.platform_settings) {
      let newObj = {...formFields}
      for (let settingField in {...retrivedPlatformData.platform_settings}) {
        if (settingField.includes('setting')) {
          if (retrivedPlatformData.platform_settings[settingField] !== null) {
            let isNotExistKeysForSpreadObj =
              typeof formFields[settingField] === 'object' ? formFields[settingField] : {}
            newObj[settingField] = aliasBackendFieldMappingsOnSettingContainer(
              {
                ...isNotExistKeysForSpreadObj,
                ...retrivedPlatformData.platform_settings[settingField],
              },
              settingField
            )
            if (
              settingField === 'ticket_setting' &&
              retrivedPlatformData.platform_settings[settingField]?.tags !== undefined
            ) {
              newObj[settingField].Tags = retrivedPlatformData.platform_settings[settingField].tags
            }
            if (
              settingField === 'ticket_setting' &&
              !newObj[settingField]?.[TICKET_DEFAULT_CUSTOMER_FIELD]
            ) {
              const ticketDefaultCustomerFallback =
                getTicketDefaultCustomerFallbackValue(platformSettings)
              if (ticketDefaultCustomerFallback) {
                newObj[settingField][TICKET_DEFAULT_CUSTOMER_FIELD] =
                  ticketDefaultCustomerFallback
              }
            }
            if (
              retrivedPlatformData.platform_settings?.shipment_setting?.selected_source_platform?.id
            ) {
              setPlatformSettingByGroup((prev) => ({
                ...prev,
                SHIPMENT: {
                  ...prev.SHIPMENT,
                  showSetting: true,
                },
              }))
            }
            // let newobj2 =   Object.assign(formFields, {...retrivedPlatformData.platform_settings[settingField]})
            collectFieldMappingIdsFromSettingContainer(
              retrivedPlatformData.platform_settings[settingField],
              settingField
            ).forEach((mappingId) => {
              field_mapping_ids.push(mappingId)
            })
          } else {
            //  newObj = Object.assign( newObj , {...retrivedPlatformData.platform_settings[settingField]})
          }
        } else if (typeof retrivedPlatformData.platform_settings[settingField] !== 'object') {
          const identifierKeys = [
            'secondary_product_identifier',
            'main_product_identifier',
            'platform_partner_id',
            'account_mode',
            'secondary_accounting_identifier',
            'accounting_identifier',
            'primary_accounting_identifier',
            'accounting_identifier_primary',
            'secondary_shipping_identifier',
            'shipping_identifier',
            'primary_shipping_identifier',
            'shipping_identifier_primary',
            'primary_erp_identifier',
            'secondary_erp_identifier',
            ERP_IDENTIFIER_KEY,
            `${ERP_IDENTIFIER_KEY}_primary`,
            'primary_oms_identifier',
            'secondary_oms_identifier',
            'oms_identifier',
            'oms_identifier_primary',
          ]

          if (identifierKeys.includes(settingField)) {
            newObj[settingField] = retrivedPlatformData.platform_settings[settingField]
          }
        }
      }
      // For WIX secondary stores, the API uses main_product_identifier; mirror it into secondary_product_identifier for UI consistency.
      if (
        retrivedPlatformData?.code === 'WIX' &&
        !retrivedPlatformData?.isMainStore &&
        (retrivedPlatformData.platform_settings?.main_product_identifier !== undefined ||
          retrivedPlatformData.platform_settings?.secondary_product_identifier !== undefined)
      ) {
        const backendSecondaryId = retrivedPlatformData.platform_settings?.main_product_identifier
        const backendPrimaryId =
          retrivedPlatformData.platform_settings?.secondary_product_identifier

        if (backendSecondaryId !== undefined && backendSecondaryId !== null) {
          newObj.secondary_product_identifier = backendSecondaryId
        }

        if (backendPrimaryId !== undefined && backendPrimaryId !== null) {
          newObj.main_product_identifier = backendPrimaryId
        }
      }
      const adjustedValues = applyUnavailableChannelSettingTurnOff(newObj, connectedStores)
      setValues({...adjustedValues})
    } else {
      //set the initial values when platform_settings is null
      setValues({...formFields})
    }
    // Get saved mappings
    if (field_mapping_ids.length > 0) {
      setSavedMappings([])
      dispatch(getSavedFieldMappingsDataAsync({field_mapping_ids})).then((response) => {
        const payload = normalizeSavedFieldMappingsPayload(response.payload)
        if (
          response.meta.requestStatus !== 'fulfilled' ||
          !isSavedFieldMappingsPayload(response.payload)
        ) {
          errorToast(
            getApiErrorMsg(
              response.payload,
              'Unable to load saved field mappings. Some mapping values may be unavailable.'
            ),
            {toastId: `saved-field-mappings-load-${selectedPlatformId}`}
          )
          return
        }
        setSavedMappings(payload)
        setValues((prev) => mergeSavedMappingsIntoSettingValues(prev, payload))
      })
    } else {
      setSavedMappings([])
    }
    setLoadInitialKeyValues(false)
  }, [formFields, retrivedPlatformData, refreshMapping])

  useEffect(() => {
    if (!hasCooldownStarted) return

    if (timeLeft <= 0) {
      setDisableRefreshButton(false)
      setHasCooldownStarted(false)
      setShowAlert(false)
      return
    }

    const timer = setInterval(() => {
      setTimeLeft((t) => t - 1)
    }, 1000)

    return () => clearInterval(timer)
  }, [hasCooldownStarted, timeLeft])

  const handleRefreshMapping = async (isAutoCall: boolean = false) => {
    if (hasCooldownStarted && !isAutoCall) {
      setDisableRefreshButton(true)
      setShowAlert(true)
      return
    }

    // First click (or after cooldown expired). Auto-refresh should not block onboarding input.
    if (!isAutoCall) {
      setIsDisabled(true)
    }
    setShowAlert(false)

    const payload = {platform_id: Number(selectedPlatformId)}
    const resetRefreshStateTimer = window.setTimeout(() => {
      setIsDisabled(false)
    }, 15000)

    try {
      const response = await dispatch(refreshMappingAsync({payload})).unwrap()
      if (!isApiPayloadSuccess(response)) {
        throw response
      }
      setRefreshMapping((prev) => !prev)
      successToast(getRefreshMappingSuccessMessage(response))
      localStorage.removeItem(
        `platformFirstConnect_${
          retrivedPlatformData?.name
        }_${retrivedPlatformData?.id.toString()}`
      )
    } catch (error) {
      const message = getRefreshMappingErrorMessage(error)
      if (!isAutoCall) {
        errorToast(message)
      } else {
        console.warn('Auto mapping refresh failed:', message, error)
      }
    } finally {
      window.clearTimeout(resetRefreshStateTimer)
      setIsDisabled(false)
      if (!isAutoCall) {
        setHasCooldownStarted(true)
        setTimeLeft(60)
      }
    }
  }

  //to get data of temu token and expiration date
  useEffect(() => {
    if (selectedPlatformId && retrivedPlatformData && retrivedPlatformData?.code === 'TEMU') {
      dispatch(getPlatformTokenDatasync({id: selectedPlatformId})).then((res) => {
        if (res.payload?.status_code == '200') {
          setTemuTokenData({
            token: '',
            expire_date: res.payload?.data?.expiry_date,
          })
        }
      })
    }
  }, [selectedPlatformId, retrivedPlatformData])

  useEffect(() => {
    if (retrivedPlatformData?.name) {
      const firstConnect = localStorage.getItem(
        `platformFirstConnect_${retrivedPlatformData?.name}_${retrivedPlatformData?.id.toString()}`
      )
      if (isFromOnboarding) {
        if (firstConnect === 'true') {
          handleRefreshMapping(true)
        }
      } else {
        if (firstConnect === 'true') {
          handleRefreshMapping(true)
        }
      }
    }
  }, [retrivedPlatformData?.name])

  const getSelectableSourceLookups = () => {
    const settingsByType: Record<string, SETTINGS_OF_PLATFORM[] | []> = {
      MAIN_STORE_SETTING: primaryPlatformSettings,
      SECONDARY_STORE_SETTING: primaryPlatformSettings,
      ACCOUNTING_STORE_SETTING: accountingPlatformSettings,
      SHIPPING_STORE_SETTING: shippingPlatformSettings,
      ERP_STORE_SETTING: erpPlatformSettings,
      OMS_STORE_SETTING: omsPlatformSettings,
      [TICKET_SETTING_TYPE]: ticketPlatformSettings,
    }
    const storeIdByType: Record<string, number | null | undefined> = {
      MAIN_STORE_SETTING: mainStoreData?.id,
      SECONDARY_STORE_SETTING: mainStoreData?.id,
      ACCOUNTING_STORE_SETTING: accountingStoreData?.id,
      SHIPPING_STORE_SETTING: shippingStoreData?.id,
      ERP_STORE_SETTING: erpStoreData?.id,
      OMS_STORE_SETTING: omsStoreData?.id,
      [TICKET_SETTING_TYPE]: ticketStoreData?.id,
    }
    return {settingsByType, storeIdByType}
  }

  const fetchPlatformSettingsBySelectedSource = (setting: any, selectedSource: any) => {
    if (!setting?.group_code) return

    if (!selectedSource?.id) {
      setPlatformSettingByGroup((prev) => ({
        ...prev,
        [setting.group_code]: {
          ...prev[setting.group_code],
          showSetting: false,
        },
      }))
      return
    }

    const settingType = selectedSource.setting_type || 'MAIN_STORE_SETTING'
    const sourcePlatformId = Number(selectedSource.id)
    const requestKey = `${setting.group_code}:${sourcePlatformId}`
    const cached = sourceSettingsCacheRef.current[requestKey]
    const {settingsByType, storeIdByType} = getSelectableSourceLookups()
    const reused =
      cached ?? pickLoadedSettingsForSource(selectedSource, storeIdByType, settingsByType)

    if (reused) {
      sourceSettingsCacheRef.current[requestKey] = reused
      setPlatformSettingByGroup((prev) => {
        const existing = prev[setting.group_code]
        if (
          Number(existing?.sourcePlatformId) === sourcePlatformId &&
          existing?.settings === reused
        ) {
          return prev
        }
        return {
          ...prev,
          [setting.group_code]: {
            ...existing,
            showSetting: true,
            settingType,
            sourcePlatformId,
            settings: reused,
          },
        }
      })
      return
    }

    if (sourceSettingsInFlightRef.current[requestKey]) {
      return
    }

    if (!selectedSource.available_platform_id || !selectedPlatformId) {
      return
    }

    sourceSettingsInFlightRef.current[requestKey] = true
    setPlatformSettingByGroup((prev) => ({
      ...prev,
      [setting.group_code]: {
        ...prev[setting.group_code],
        showSetting: true,
        settingType,
        sourcePlatformId,
      },
    }))

    dispatch(
      getSettingsOfPrimaryPlatformAsyncNew({
        primaryAvailablePlatformId: selectedSource.available_platform_id,
        selectedPlatformId,
        primaryPlatformId: sourcePlatformId,
        erp_flow: true,
        current_setting_platform_id: selectedPlatformId,
        type: settingType,
      })
    )
      .then((response) => {
        const data = Array.isArray(response?.payload?.data) ? response.payload.data : []
        sourceSettingsCacheRef.current[requestKey] = data
        setPlatformSettingByGroup((prev) => {
          if (Number(prev[setting.group_code]?.sourcePlatformId) !== sourcePlatformId) {
            return prev
          }
          return {
            ...prev,
            [setting.group_code]: {
              ...prev[setting.group_code],
              showSetting: true,
              settingType,
              sourcePlatformId,
              settings: data,
            },
          }
        })
      })
      .finally(() => {
        sourceSettingsInFlightRef.current[requestKey] = false
      })
  }

  useEffect(() => {
    if (!Array.isArray(platformSettings) || !platformSettings.length || !selectedPlatformId) {
      return
    }

    const selectableGroups = new Set(['SHIPMENT', 'ORDER_PAYOUT', 'TICKET'])
    platformSettings.forEach((setting) => {
      if (!selectableGroups.has(setting.group_code)) return

      const options = getAvailableSourcesForSetting(setting)
      if (!options.length) return

      const settingField =
        setting.group_code === 'SHIPMENT'
          ? 'shipment'
          : setting.group_code === 'TICKET'
          ? TICKET_SETTING_FIELD
          : ORDER_PAYOUT_SETTING_FIELD
      const selectedId =
        formFields[`${settingField}_setting`]?.selected_source_platform_id ??
        formFields[`${settingField}_setting`]?.selected_source_platform?.id ??
        setting.setting_source?.platform_id ??
        options[0]?.id
      const selectedSource =
        options.find((item) => Number(item.id) === Number(selectedId)) ?? options[0]
      if (!selectedSource) return

      fetchPlatformSettingsBySelectedSource(setting, selectedSource)
    })
  }, [
    platformSettings,
    selectedPlatformId,
    formFields.order_payout_setting?.selected_source_platform_id,
    formFields.order_payout_setting?.selected_source_platform?.id,
    formFields.shipment_setting?.selected_source_platform_id,
    formFields.ticket_setting?.selected_source_platform_id,
    primaryPlatformSettings,
    accountingPlatformSettings,
    shippingPlatformSettings,
    erpPlatformSettings,
    omsPlatformSettings,
    ticketPlatformSettings,
  ])

  const crossStoreRestrictions = (
    settingField: string,
    settingName: string,
    currentValue: boolean
  ) => {
    if (settingField === 'inventory' || settingField === 'pricing' || settingField === 'product') {
      const isSettingEnabledPrimary =
        effectivePrimarySourceStoreData?.platform_settings?.[`${settingField}_setting`]?.[
          settingName
        ]
      const isSettingEnabledAccounting =
        accountingStoreData?.platform_settings?.[`${settingField}_setting`]?.[settingName]
      const isSettingEnabledShipping =
        shippingStoreData?.platform_settings?.[`${settingField}_setting`]?.[settingName]
      const isSettingEnabledErp =
        erpStoreData?.platform_settings?.[`${settingField}_setting`]?.[settingName]
      const isSettingEnabledOms =
        omsStoreData?.platform_settings?.[`${settingField}_setting`]?.[settingName]
      const isSettingEnabledTicket =
        ticketStoreData?.platform_settings?.[`${settingField}_setting`]?.[settingName]

      if (
        currentValue &&
        (retrivedPlatformData?.isAccountingStore ||
          retrivedPlatformData?.isMainStore ||
          retrivedPlatformData?.isShippingStore ||
          isRetrievedErpStore ||
          isRetrievedOmsStore ||
          isRetrievedTicketStore)
      ) {
        return true
      } else if (isRetrievedPrimaryHubStore) {
        const enabledOnOtherStores = [
          isSettingEnabledAccounting,
          isSettingEnabledShipping,
          isSettingEnabledErp,
          isSettingEnabledTicket,
        ]
        if (retrivedPlatformData?.isMainStore) {
          enabledOnOtherStores.push(isSettingEnabledOms)
        }
        return enabledOnOtherStores.some((isEnabled) => isEnabled === true)
      } else if (retrivedPlatformData?.isAccountingStore) {
        return (isSettingEnabledPrimary ||
          isSettingEnabledShipping ||
          isSettingEnabledErp ||
          isSettingEnabledOms ||
          isSettingEnabledTicket) === true
          ? true
          : false
      } else if (retrivedPlatformData?.isShippingStore) {
        return (isSettingEnabledAccounting ||
          isSettingEnabledPrimary ||
          isSettingEnabledErp ||
          isSettingEnabledOms ||
          isSettingEnabledTicket) === true
          ? true
          : false
      } else if (isRetrievedErpStore) {
        return (isSettingEnabledPrimary ||
          isSettingEnabledAccounting ||
          isSettingEnabledShipping ||
          isSettingEnabledOms ||
          isSettingEnabledTicket) === true
          ? true
          : false
      } else if (isRetrievedOmsStore) {
        return (isSettingEnabledPrimary ||
          isSettingEnabledAccounting ||
          isSettingEnabledShipping ||
          isSettingEnabledErp ||
          isSettingEnabledTicket) === true
          ? true
          : false
      } else if (isRetrievedTicketStore) {
        return (isSettingEnabledPrimary ||
          isSettingEnabledAccounting ||
          isSettingEnabledShipping ||
          isSettingEnabledErp ||
          isSettingEnabledOms) === true
          ? true
          : false
      } else {
        return false
      }
    } else {
      return false
    }
  }

  const frozenDisabledMap = useMemo(() => {
    const map = {}

    platformSettings?.forEach((setting) => {
      const settingField =
        setting.group_code === 'ORDER'
          ? 'order'
          : setting.group_code === 'PRODUCT'
          ? 'product'
          : setting.group_code === 'INVENTORY'
          ? 'inventory'
          : setting.group_code === 'SHIPMENT'
          ? 'shipment'
          : setting.group_code === 'PRICING'
          ? 'pricing'
          : setting.group_code.toLowerCase()

      const currentValue = values?.[`${settingField}_setting`]?.[`${setting.name}`] ?? false

      map[`${settingField}_${setting.name}`] = crossStoreRestrictions(
        settingField,
        setting.name,
        currentValue
      )
    })

    return map
  }, [
    platformSettings,
    values,
    effectivePrimarySourceStoreData,
    accountingStoreData,
    shippingStoreData,
    erpStoreData,
    omsStoreData,
    ticketStoreData,
    retrivedPlatformData,
    isRetrievedPrimaryHubStore,
    isRetrievedErpStore,
    isRetrievedOmsStore,
    isRetrievedTicketStore,
  ])

  if (
    loadingFormFields ||
    retriveDataLoading ||
    loadInitialKeyValues ||
    fetchedConnectedPlatformLoading
  )
    return <Loader />

  const isInventoryEnabledMain =
    effectivePrimarySourceStoreData?.platform_settings?.[`inventory_setting`]?.['isImportInventory']
  const isInventoryEnabledAccounting =
    accountingStoreData?.platform_settings?.[`inventory_setting`]?.['isImportInventory']
  const isInventoryEnabledShipping =
    shippingStoreData?.platform_settings?.[`inventory_setting`]?.['isImportInventory']
  const isInventoryEnabledErp =
    erpStoreData?.platform_settings?.[`inventory_setting`]?.['isImportInventory']
  const isInventoryEnabledOms =
    omsStoreData?.platform_settings?.[`inventory_setting`]?.['isImportInventory']
  const isInventoryEnabledTicket =
    ticketStoreData?.platform_settings?.[`inventory_setting`]?.['isImportInventory']

  const isPricingEnabledMain =
    effectivePrimarySourceStoreData?.platform_settings?.[`pricing_setting`]?.['isImportPrice']
  const isPricingEnabledAccounting =
    accountingStoreData?.platform_settings?.[`pricing_setting`]?.['isImportPrice']
  const isPricingEnabledShipping =
    shippingStoreData?.platform_settings?.[`pricing_setting`]?.['isImportPrice']
  const isPricingEnabledErp =
    erpStoreData?.platform_settings?.[`pricing_setting`]?.['isImportPrice']
  const isPricingEnabledOms =
    omsStoreData?.platform_settings?.[`pricing_setting`]?.['isImportPrice']
  const isPricingEnabledTicket =
    ticketStoreData?.platform_settings?.[`pricing_setting`]?.['isImportPrice']
  const pricingEnabledFrom = isPricingEnabledMain
    ? BaseNames.PRIMARY_Name
    : isPricingEnabledAccounting
    ? 'Accounting'
    : isPricingEnabledShipping
    ? 'Shipping'
    : isPricingEnabledErp
    ? 'ERP'
    : isPricingEnabledOms
    ? 'OMS'
    : ''
  const formatSettingDisplayText = (text: string | null | undefined) =>
    applyPlatformSettingShortcodes(text, {
      retrievedPlatform: retrivedPlatformData,
      mainStore: mainStoreData,
      sourceChannelName: pricingEnabledFrom,
    })
  const normalizedCurrentPlatformCode = (
    retrivedPlatformData?.code ||
    (retrivedPlatformData as any)?.platform_info?.name ||
    retrivedPlatformData?.name ||
    (retrivedPlatformData as any)?.platform_info?.display_name ||
    ''
  )
    .toString()
    .replace(/[^a-zA-Z0-9]/g, '')
    .toUpperCase()
  const isShopwarePlatform = normalizedCurrentPlatformCode === 'SHOPWARE'
  const shouldShowStoreUrlField = ['SHOPIFY', 'WOOCOMMERCE', 'ODOO', 'MIRAKL', 'SHOPWARE'].includes(
    normalizedCurrentPlatformCode
  )
  return (
    <>
      {isFromOnboarding && (
        <div className='p-2 px-5 rounded bg-light-info my-2 fs-5 mb-4'>
          <i className='bi bi-telephone-fill fw-bold text-primary fs-5'></i> Book a call{' '}
          <a
            className='fw-bold'
            target='_blank'
            href='https://calendly.com/d/crrg-dfq-xkv/product-demo-integration-flow-discussion'
            rel='noreferrer'
          >
            here
          </a>
          , We'll set it up for free!
        </div>
      )}
      <div
        className={`d-flex ${isFromOnboarding ? 'justify-content-end' : 'justify-content-between'}`}
      >
        {!isFromOnboarding && (
          <ul className='breadcrumb text-muted  fw-semibold fs-6 my-0 mb-2'>
            <li className='breadcrumb-item'>
              <Link to={`/listing-channels`} className='text-primary text-decoration-none'>
                Manage Channels
              </Link>
            </li>
            <li className='breadcrumb-item'>{retrivedPlatformData?.platform_info?.display_name}</li>
          </ul>
        )}
        {showAlert && timeLeft > 0 && (
          <Alert variant='danger' className='px-2 py-1 mb-2'>
            ⏳ Please wait <strong className='mx-1'>{timeLeft}s</strong> before trying again.
          </Alert>
        )}
      </div>
      <div
        key={
          {...formFields} +
          '' +
          retrivedPlatformData?.platform_settings +
          loadInitialKeyValues +
          retriveDataLoading +
          retriveDataLoading
        }
        className={isDisabled || isSaving ? 'background-disable' : ''}
      >
        <div className='card'>
          <form onSubmit={handleSubmit}>
            <div className='card-header bg-white'>
              <div className='card-title'>Channel Settings</div>
              <div className='card-toolbar'>
                {/* <button type='button' disabled={isSubmitting} className='btn btn-sm btn-dark text-white'>
                Cancel
              </button> */}
                {isWrite &&
                  shouldShowAction(customerAccess, 'edit') &&
                  (() => {
                    const refreshButtonProps = getActionButtonProps(customerAccess, 'edit')
                    return (
                      <button
                        type='button'
                        {...refreshButtonProps}
                        disabled={
                          disableRefreshButton ||
                          refreshButtonProps.disabled ||
                          getFormFieldDisabled(customerAccess)
                        }
                        onClick={() => handleRefreshMapping(false)}
                        className='btn btn-sm btn-success ms-2 fw-bold'
                        style={{minWidth: '100px', width: '130px', ...refreshButtonProps.style}}
                        title={refreshButtonProps.title}
                      >
                        {isDisabled ? 'Refreshing...' : 'Refresh Mapping'}
                      </button>
                    )
                  })()}
                {isWrite &&
                  shouldShowAction(customerAccess, 'edit') &&
                  (() => {
                    const saveButtonProps = getActionButtonProps(customerAccess, 'edit')
                    return (
                      <button
                        type='submit'
                        {...saveButtonProps}
                        disabled={
                          isSubmitting ||
                          settings?.length === 0 ||
                          saveButtonProps.disabled ||
                          getFormFieldDisabled(customerAccess)
                        }
                        className='btn btn-sm btn-success ms-2 fw-bold w-100px'
                        style={saveButtonProps.style}
                        title={saveButtonProps.title}
                      >
                        {isSubmitting ? 'Saving...' : 'Save'}
                      </button>
                    )
                  })()}
              </div>
            </div>
            <div className='card-body p-2 px-sm-4'>
              <section>
                <div className='mt-5 border shadow rounded'>
                  <div className=' ribbon ribbon-start'>
                    <div className='ribbon-label bg-primary text-uppercase'>Channel Connection</div>
                  </div>
                  <div className='row p-2 p-sm-4 mx-auto'>
                    <div className='row my-4 my-sm-2 '>
                      <div className='col-6'>
                        <p className='h4'>
                          {retrivedPlatformData?.platform_info?.display_name} Channel Name:
                        </p>
                      </div>
                      <div className='col-6 d-flex align-items-center'>
                        <p className='h4'>{retrivedPlatformData?.display_name}</p>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-6 h4 '>Status:</div>
                      <div className='col-6'>
                        <span
                          className={`badge ${
                            retrivedPlatformData?.isConnected ? 'badge-success' : 'badge-danger'
                          }`}
                          style={{fontSize: '1.3rem', borderRadius: '6px'}}
                        >
                          {retrivedPlatformData?.isConnected ? 'Connected' : 'Not Connected'}
                        </span>
                      </div>
                    </div>
                    {shouldShowStoreUrlField && (
                      <div className='row mt-2'>
                        <div className='col-6 h4'>Store URL:</div>
                        <div className='col-6 h4'>
                          {retrivedPlatformData?.credentials?.identifier || '-'}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </section>
              {retrivedPlatformData?.code === 'TEMU' ? (
                <div className='mt-5 border shadow rounded'>
                  <div className='  ribbon ribbon-start'>
                    <div className='ribbon-label bg-primary'>Auth Token Update</div>
                  </div>
                  <div className='row m-4'>
                    <div className='col-12 col-sm-6'>
                      <label className='form-label' htmlFor='order_number_map'>
                        {' '}
                        Token Expiration Date
                      </label>
                      <input
                        type='datetime-local'
                        className='form-control form-control-lg'
                        disabled
                        value={
                          temuTokenData?.expire_date
                            ? formatDateForDateTimeLocal(temuTokenData.expire_date)
                            : ''
                        }
                        onChange={(ev) => {
                          setTemuTokenData((pre) => {
                            return {
                              ...pre,
                              expire_date: ev.target.value,
                            }
                          })
                        }}
                      />
                    </div>

                    <div className='col-12 col-sm-6'>
                      <label className='form-label' htmlFor='order_number_map'>
                        {' '}
                        Auth Token <InfoTooltip sourceChannelName={pricingEnabledFrom} message="Only update when it's about to expire." />
                      </label>
                      <input
                        type='text'
                        className='form-control form-control-lg'
                        placeholder='Auth Token Update'
                        // value={temuTokenData.token}
                        onChange={(ev) => {
                          setTemuTokenData((pre) => {
                            return {
                              ...pre,
                              token: ev.target.value,
                            }
                          })
                        }}
                      />
                    </div>
                  </div>
                </div>
              ) : null}
              {platformSettings?.length ? (
                platformSettings
                  .filter((setting) => {
                    // Un comment, if you want identifier to be display on toogle based switch condition in inventory/pricing
                    // const isAccountingOrderEnabled = values?.[`accounting_order_setting`]?.[`isImportOrderToSource`]
                    //  const isShipmentEnabled =  values?.[`shipment_setting`]?.[`isImportShipmentFromMain`]

                    // Primary / OMS hub store page
                    if (isSelectedPrimaryHubStore) {
                      if (
                        accountingStoreData ||
                        shippingStoreData ||
                        erpStoreData ||
                        omsStoreData ||
                        isRetrievedPrimaryHubStore
                      ) {
                        return true
                      } else {
                        return setting.group_code !== 'IDENTIFIER'
                      }
                    }

                    // Auxiliary source store pages (accounting, shipping, ERP, ticket — not primary hub)
                    if (
                      accountingStoreData?.id === Number(selectedPlatformId) ||
                      shippingStoreData?.id === Number(selectedPlatformId) ||
                      erpStoreData?.id === Number(selectedPlatformId) ||
                      omsStoreData?.id === Number(selectedPlatformId) ||
                      ticketStoreData?.id === Number(selectedPlatformId)
                    ) {
                      return setting.group_code !== 'IDENTIFIER'
                    }

                    // Secondary Store Page
                    return true
                  })
                  .sort((a, b) => {
                    if (!shouldShowPrimarySecondaryIdentifierBlock) return 0
                    if (a.group_code === 'IDENTIFIER' && b.group_code !== 'IDENTIFIER') return -1
                    if (a.group_code !== 'IDENTIFIER' && b.group_code === 'IDENTIFIER') return 1
                    return 0
                  })
                  .map((setting: any, platformSettingIndex: number) => {
                    let settingField =
                      setting.group_code === 'ORDER'
                        ? 'order'
                        : setting.group_code === 'PRODUCT'
                        ? 'product'
                        : setting.group_code === 'INVENTORY'
                        ? 'inventory'
                        : setting.group_code === 'SHIPMENT'
                        ? 'shipment'
                        : setting.group_code === 'PRICING'
                        ? 'pricing'
                        : setting.group_code === 'TICKET'
                        ? TICKET_SETTING_FIELD
                        : platformSettingByGroup[setting.group_code]?.settingType ===
                          TICKET_SETTING_TYPE
                        ? TICKET_SETTING_FIELD
                        : setting.group_code.toLocaleLowerCase()

                    if (
                      setting.group_code === 'IDENTIFIER' &&
                      !shouldShowPrimarySecondaryIdentifierBlock
                    ) {
                      return null
                    }

                    if (setting.group_code === 'IDENTIFIER' && setting.input_type === 'SELECT') {
                      return (
                        <section key={'sectionmap' + platformSettingIndex}>
                          <div className='mt-5 border shadow rounded'>
                            <div className='ribbon ribbon-start'>
                              <div className='ribbon-label bg-primary'>
                                {formatSettingDisplayText(
                                  setting?.grouptitle ?? 'MAP PRODUCT IDENTIFIER'
                                )}
                              </div>
                            </div>
                            <ProductIdentifierMappingSection
                              availablePlatformId={availablePlatformId}
                              selectedPlatformId={selectedPlatformId}
                              retrievedPlatform={retrivedPlatformData}
                              selectedSettings={platformSettings}
                              relatedSettingsByPlatformId={identifierRelatedSettingsByPlatformId}
                              disabled={isSaving}
                              onRowsChange={handleIdentifierRowsChange}
                            />
                          </div>
                        </section>
                      )
                    }

                    const PLATFORM_SETTINGS_MAP: Record<string, SETTINGS_OF_PLATFORM[] | []> = {
                      MAIN_STORE_SETTING: primaryPlatformSettings,
                      SECONDARY_STORE_SETTING: primaryPlatformSettings,
                      ACCOUNTING_STORE_SETTING: accountingPlatformSettings,
                      SHIPPING_STORE_SETTING: shippingPlatformSettings,
                      ERP_STORE_SETTING: erpPlatformSettings,
                      OMS_STORE_SETTING: omsPlatformSettings,
                      [TICKET_SETTING_TYPE]: ticketPlatformSettings,
                    }
                    const selectedPlatformSettingsByGroup = resolveGroupScopedPlatformSettings(
                      platformSettingByGroup[setting.group_code],
                      platformSettingByGroup[setting.group_code].settingType,
                      PLATFORM_SETTINGS_MAP,
                      {
                        MAIN_STORE_SETTING: mainStoreData?.id,
                        SECONDARY_STORE_SETTING: mainStoreData?.id,
                        ACCOUNTING_STORE_SETTING: accountingStoreData?.id,
                        SHIPPING_STORE_SETTING: shippingStoreData?.id,
                        ERP_STORE_SETTING: erpStoreData?.id,
                        OMS_STORE_SETTING: omsStoreData?.id,
                        [TICKET_SETTING_TYPE]: ticketStoreData?.id,
                      }[platformSettingByGroup[setting.group_code]?.settingType]
                    )
                    const isFrozen = frozenDisabledMap[`${settingField}_${setting.name}`] ?? false
                    const hasValue =
                      setting.input_type === 'BOOLEAN'
                        ? isTruthySettingValue(
                            values?.[`${settingField}_setting`]?.[`${setting.name}`]
                          )
                        : false
                    const selectedStoreIdentifierLabel = `${
                      retrivedPlatformData?.platform_info?.display_name ?? 'Selected'
                    } Store Identifier`
                    const availableSourceOptions = getAvailableSourcesForSetting(setting)
                    const availableSourceDisplayName = getAvailableSourcesDisplayName(setting)
                    const selectedSourcePlatformId =
                      values[`${settingField}_setting`]?.selected_source_platform?.id ??
                      values[`${settingField}_setting`]?.selected_source_platform_id ??
                      platformSettingByGroup[setting.group_code]?.sourcePlatformId ??
                      availableSourceOptions?.[0]?.id ??
                      null
                    const selectedSourceStoreData = getStoreDataForSelectedSource(
                      platformSettingByGroup[setting.group_code]?.settingType,
                      selectedSourcePlatformId
                    )
                    const mappings_setting_field = [
                      'ACCOUNTING_ORDER',
                      'ERP_ORDER',
                      'OMS_ORDER',
                    ].includes(setting?.group_code)
                      ? 'order'
                      : settingField
                    const effectiveSourceGroupCode = (() => {
                      if (setting.group_code !== 'ORDER') return setting.group_code
                      const sourceType = platformSettingByGroup[setting.group_code]?.settingType
                      if (sourceType === 'ERP_STORE_SETTING') return 'ERP_ORDER'
                      if (sourceType === 'ACCOUNTING_STORE_SETTING') return 'ACCOUNTING_ORDER'
                      if (sourceType === 'OMS_STORE_SETTING') return 'OMS_ORDER'
                      return setting.group_code
                    })()
                    const currentSettingValue =
                      values?.[`${settingField}_setting`]?.[`${setting.name}`]
                    const isCurrentSettingEnabled = isTruthySettingValue(currentSettingValue)
                    const channelAvailability = getChannelSettingAvailability(
                      setting.group_code,
                      connectedStores
                    )
                    const isDisabledByChannelAvailability = !channelAvailability.enabled
                    const shouldRenderChildSetting = (item: SETTINGS_OF_PLATFORM) => {
                      if (item.input_type === 'DATETIME') return false

                      if (mainStoreData?.name === 'QUICKBOOKS') {
                        const excludedNames = ['isSkipUnpaidOrders', 'isNotifyUnlinkedOrders']
                        if (excludedNames.includes(item.name)) return false
                      }

                      return true
                    }
                    const childSettings = setting?.children?.filter(shouldRenderChildSetting) ?? []
                    const standardChildSettings = childSettings.filter(
                      (item) => !item.is_advance_setting
                    )
                    const directFileChildSettings =
                      getDirectSettingFileChildActions(standardChildSettings)
                    const selectedGroupSettingForChildren = findSourcePlatformSettingInLists(
                      [
                        selectedPlatformSettingsByGroup,
                        erpPlatformSettings,
                        platformSettings,
                        primaryPlatformSettings,
                      ],
                      effectiveSourceGroupCode,
                      setting.name
                    )
                    const childSettingControlRenderOptions = buildChildSettingControlRenderOptions(
                      setting,
                      selectedGroupSettingForChildren,
                      fieldMappings,
                      savedMappings
                    )
                    const primaryAdditionalChildSettings = getSourceAdditionalChildSettings(
                      selectedPlatformSettingsByGroup,
                      effectiveSourceGroupCode,
                      setting.name,
                      setting.children
                    )
                    const siblingRanks = buildPageSiblingRankMap({
                      thisSetting: setting,
                      extraChildren: primaryAdditionalChildSettings,
                      otherSetting: selectedGroupSettingForChildren,
                    })
                    const connectedSourceFilePanels = getConnectedSourceFileActionPanels(
                      effectiveSourceGroupCode,
                      setting.name,
                      setting.children,
                      [
                        {
                          catalog: primaryPlatformSettings,
                          platformId: effectivePrimarySourceStoreData?.id ?? mainStoreData?.id,
                        },
                        {
                          catalog: accountingPlatformSettings,
                          platformId: accountingStoreData?.id,
                        },
                        {
                          catalog: shippingPlatformSettings,
                          platformId: shippingStoreData?.id,
                        },
                        {
                          catalog: erpPlatformSettings,
                          platformId: erpStoreData?.id,
                        },
                        {
                          catalog: omsPlatformSettings,
                          platformId: omsStoreData?.id,
                        },
                        {
                          catalog: ticketPlatformSettings,
                          platformId: ticketStoreData?.id,
                        },
                      ]
                    )
                    const hasAnySettingFileActions =
                      hasSettingFileActions(setting) || connectedSourceFilePanels.length > 0
                    const sequenceNodeRegistry = createSequenceNodeRegistry()
                    const sequenceWrapChildThis = (
                      childSetting: SETTINGS_OF_PLATFORM,
                      _key: string,
                      node: React.ReactNode
                    ) => {
                      registerSequenceNode(
                        sequenceNodeRegistry,
                        true,
                        'child',
                        'this',
                        childSetting,
                        node
                      )
                      return null
                    }
                    const sequenceWrapExtraChild = (
                      childSetting: SETTINGS_OF_PLATFORM,
                      _key: string,
                      node: React.ReactNode
                    ) => {
                      registerSequenceNode(
                        sequenceNodeRegistry,
                        true,
                        'child',
                        'other',
                        childSetting,
                        node
                      )
                      return null
                    }
                    const sequenceWrapPrimaryMapping = (
                      enrichedFieldMapping: any,
                      _mappingIndex: number,
                      node: React.ReactNode
                    ) => {
                      registerSequenceNode(
                        sequenceNodeRegistry,
                        true,
                        'mapping',
                        'other',
                        enrichedFieldMapping,
                        node
                      )
                      return isAdvancedSettingItem(enrichedFieldMapping) ? node : null
                    }
                    const sequenceWrapThisMapping = (
                      enrichedFieldMapping: any,
                      _mappingIndex: number,
                      node: React.ReactNode
                    ) => {
                      registerSequenceNode(
                        sequenceNodeRegistry,
                        true,
                        'mapping',
                        'this',
                        enrichedFieldMapping,
                        node
                      )
                      return isAdvancedSettingItem(enrichedFieldMapping) ? node : null
                    }
                    if (isCurrentSettingEnabled && hasAnySettingFileActions) {
                      if (hasSettingFileActions(setting)) {
                        const anchorChild = getEarliestPositionChild(directFileChildSettings)
                        if (anchorChild) {
                          registerSequenceNode(
                            sequenceNodeRegistry,
                            true,
                            'child',
                            'this',
                            anchorChild,
                            <SettingFileActionCallout
                              mappings={getSettingFileMappingsForCallout(setting)}
                              childSettings={directFileChildSettings}
                              parentAvailablePlatformSettingId={setting.id}
                              disabled={isDisabledByChannelAvailability}
                            />
                          )
                        }
                      }
                      connectedSourceFilePanels.forEach((panel) => {
                        const anchorChild = getEarliestPositionChild(panel.childSettings)
                        if (!anchorChild) {
                          return
                        }
                        registerSequenceNode(
                          sequenceNodeRegistry,
                          true,
                          'child',
                          'other',
                          anchorChild,
                          <SettingFileActionCallout
                            childSettings={panel.childSettings}
                            platformId={panel.platformId}
                            disabled={isDisabledByChannelAvailability}
                          />
                        )
                      })
                    }
                    return (
                      <section key={'sectionmap' + platformSettingIndex}>
                        <div className='mt-5 border shadow rounded'>
                          <div className=' ribbon ribbon-start'>
                            <div className='ribbon-label bg-primary'>
                              {formatSettingDisplayText(
                                setting?.grouptitle ?? setting.group_code.replace('_', ' ')
                              )}
                            </div>
                          </div>
                          <div className='row p-4 p-sm-4 mx-auto'>
                            {!setting.parent ? (
                              //currently parent is only considered for boolean
                              setting.input_type === 'BOOLEAN' ? (
                                <div
                                  className='row mt-4 mx-auto'
                                  key={
                                    platformSettingIndex + 'parentSetting' + platformSettingIndex
                                  }
                                >
                                  <div className='col-12 d-flex justify-content-between'>
                                    <div className=''>
                                      <CustomInput sourceChannelName={pricingEnabledFrom}
                                        label={setting.display_name}
                                        labelClass='form-label  me-sm-10 me-0 fs-4 mb-0'
                                        message={setting.description}
                                        containerClasses='form-check form-switch form-check-solid d-sm-flex ps-0 align-items-center'
                                        disabledReason={
                                          isDisabledByChannelAvailability
                                            ? channelAvailability.disabledReason
                                            : null
                                        }
                                        inputProps={{
                                          type: 'checkbox',
                                          className: 'form-check-input h-30px w-50px ms-sm-5 ms-0',
                                          name: settingField
                                            ? `${settingField}_setting.${setting.name}`
                                            : setting.name,
                                          checked: isTruthySettingValue(
                                            settingField && values[`${settingField}_setting`]
                                              ? values[`${settingField}_setting`][`${setting.name}`]
                                              : false
                                          ),
                                          disabled: (() => {
                                            if (isDisabledByChannelAvailability) {
                                              return true
                                            }

                                            const noStores =
                                              !retrivedPlatformData?.isAccountingStore &&
                                              !retrivedPlatformData?.isMainStore &&
                                              !retrivedPlatformData?.isShippingStore &&
                                              !isRetrievedErpStore &&
                                              !isRetrievedOmsStore

                                            if (noStores) {
                                              if (
                                                ['ACCOUNTING_ORDER', 'ERP_ORDER', 'OMS_ORDER'].includes(
                                                  setting.group_code
                                                ) &&
                                                ((setting.group_code === 'ACCOUNTING_ORDER' &&
                                                  !accountingStoreData) ||
                                                  (setting.group_code === 'ERP_ORDER' &&
                                                    !erpStoreData) ||
                                                  (setting.group_code === 'OMS_ORDER' &&
                                                    !omsStoreData))
                                              )
                                                return true
                                            }
                                            if (
                                              setting.group_code === 'ACCOUNTING_ORDER' &&
                                              !retrivedPlatformData?.isAccountingStore &&
                                              !accountingStoreData
                                            ) {
                                              return true
                                            }
                                            if (isRetrievedPrimaryHubStore) {
                                              if (
                                                ['SHIPMENT'].includes(setting.group_code) &&
                                                !shippingStoreData
                                              )
                                                return true
                                            }

                                            return (
                                              frozenDisabledMap[
                                                `${settingField}_${setting.name}`
                                              ] ?? false
                                            )
                                          })(),
                                          onChange: handleBooleanSettingChange(
                                            setFieldValue,
                                            resolveSettingFieldPath(settingField, setting.name)
                                          ),
                                          id: setting.group_code + setting.name,
                                        }}
                                      />
                                    </div>
                                    {/* Cross Channel Setting Alert */}
                                    {settingField === 'inventory' && isFrozen && !hasValue && (
                                      <Alert variant='danger' className='px-2 py-1 mb-2'>
                                        {`Please disable ${settingField} from ${
                                          isInventoryEnabledAccounting
                                            ? 'Accounting'
                                            : isInventoryEnabledShipping
                                            ? 'Shipping'
                                            : isInventoryEnabledOms
                                            ? 'OMS'
                                            : isInventoryEnabledMain
                                            ? BaseNames.PRIMARY_Name
                                            : ''
                                        } Platform first to make it available here.`}
                                      </Alert>
                                    )}
                                    {settingField === 'pricing' && isFrozen && !hasValue && (
                                      <Alert variant='danger' className='px-2 py-1 mb-2'>
                                        {`Please disable ${settingField} from ${
                                          isPricingEnabledAccounting
                                            ? 'Accounting'
                                            : isPricingEnabledShipping
                                            ? 'Shipping'
                                            : isPricingEnabledOms
                                            ? 'OMS'
                                            : isPricingEnabledMain
                                            ? BaseNames.PRIMARY_Name
                                            : ''
                                        } Platform first to make it available here.`}
                                      </Alert>
                                    )}
                                    {settingField === 'product' && isFrozen && !hasValue && (
                                      <Alert variant='danger' className='px-2 py-1 mb-2'>
                                        {`Please disable ${settingField} from ${
                                          accountingStoreData?.platform_settings?.product_setting?.[
                                            setting.name
                                          ]
                                            ? 'Accounting'
                                            : shippingStoreData?.platform_settings?.product_setting?.[
                                                setting.name
                                              ]
                                            ? 'Shipping'
                                            : erpStoreData?.platform_settings?.product_setting?.[
                                                setting.name
                                              ]
                                            ? 'ERP'
                                            : omsStoreData?.platform_settings?.product_setting?.[
                                                setting.name
                                              ]
                                            ? 'OMS'
                                            : ticketStoreData?.platform_settings?.product_setting?.[
                                                setting.name
                                              ]
                                            ? 'Ticket'
                                            : effectivePrimarySourceStoreData?.platform_settings
                                                ?.product_setting?.[setting.name]
                                            ? BaseNames.PRIMARY_Name
                                            : ''
                                        } Platform first to make it available here.`}
                                      </Alert>
                                    )}
                                    {isFrozen && hasValue && (
                                      <Alert variant='danger' className='px-2 py-1 mb-2'>
                                        {`Please contact support, to make this setting available again`}
                                      </Alert>
                                    )}

                                    {/* Accounting Channel not connected alert */}
                                    {isRetrievedPrimaryHubStore &&
                                      setting.group_code === 'ACCOUNTING_ORDER' &&
                                      !accountingStoreData &&
                                      !(
                                        settingField &&
                                        values?.[`${settingField}_setting`]?.[`${setting.name}`] ===
                                          true
                                      ) &&
                                      !(
                                        isChannelSettingRuleKey(setting.group_code) &&
                                        isDisabledByChannelAvailability
                                      ) && (
                                        <Alert variant='danger' className='px-2 py-1 mb-2'>
                                          {`Please connect your Accounting Platform to enable this setting.`}
                                        </Alert>
                                      )}
                                    {/* Shipping Channel not connected alert */}
                                    {['SHIPMENT'].includes(setting.group_code) &&
                                      !shippingStoreData &&
                                      isRetrievedPrimaryHubStore &&
                                      !(
                                        isChannelSettingRuleKey(setting.group_code) &&
                                        isDisabledByChannelAvailability
                                      ) && (
                                        <Alert variant='danger' className='px-2 py-1 mb-2'>
                                          {`Please connect your Shipping Platform to enable this setting.`}
                                        </Alert>
                                      )}
                                    {isChannelSettingRuleKey(setting.group_code) &&
                                      isDisabledByChannelAvailability &&
                                      !isCurrentSettingEnabled &&
                                      channelAvailability.disabledReason && (
                                        <Alert variant='danger' className='px-2 py-1 mb-2'>
                                          {channelAvailability.disabledReason}
                                        </Alert>
                                      )}
                                  </div>
                                  {setting?.notes && (
                                    <SettingNotes
                                      notes={setting.notes}
                                      retrivedPlatformData={retrivedPlatformData}
                                      mainStoreData={mainStoreData ?? undefined}
                                      pricingEnabledFrom={pricingEnabledFrom}
                                      className='p-1 d-flex ms-2'
                                    />
                                  )}
                                  <div className='separator mt-2'></div>
                                  {['shipment', ORDER_PAYOUT_SETTING_FIELD, TICKET_SETTING_FIELD].includes(settingField) &&
                                  isCurrentSettingEnabled &&
                                  availableSourceOptions.length > 0 ? (
                                    <div
                                      className='row px-4 channel-setting-pre-sequence-field'
                                      style={
                                        settingField === TICKET_SETTING_FIELD
                                          ? {visibility: 'hidden', height: 0, overflow: 'hidden'}
                                          : undefined
                                      }
                                    >
                                      <div
                                        className='col-12 col-sm-6 mt-4'
                                        style={{paddingRight: '5.5rem'}}
                                      >
                                        <label className='form-label'>
                                          {formatSettingDisplayText(availableSourceDisplayName)}
                                        </label>
                                        <select
                                          className='form-select form-select-lg'
                                          name={`${settingField}_setting.selected_source_platform.id`}
                                          disabled={availableSourceOptions.length === 1}
                                          value={
                                            values[`${settingField}_setting`]
                                              ?.selected_source_platform?.id ??
                                            values[`${settingField}_setting`]
                                              ?.selected_source_platform_id ??
                                            availableSourceOptions?.[0]?.id ??
                                            ''
                                          }
                                          onChange={(e) => {
                                            handleChange(e)
                                            const settingID = e.target.value
                                            const selectedSource =
                                              availableSourceOptions.find(
                                                (item) => item.id === Number(settingID)
                                              ) ?? null

                                            fetchPlatformSettingsBySelectedSource(
                                              setting,
                                              selectedSource
                                            )
                                            setFieldValue(
                                              `${settingField}_setting.selected_source_platform_id`,
                                              selectedSource?.id
                                            )
                                          }}
                                        >
                                          {availableSourceOptions.map((item: any) => (
                                            <option key={item.id} value={item.id}>
                                              {formatSettingDisplayText(item.setting_display_name)}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    </div>
                                  ) : null}
                                  <ChannelSettingLegacySequenceContainer
                                    enabled={false}
                                    className='row p-4'
                                  >
                                    {(!isSelectedPrimaryHubStore ||
                                      [
                                        'ACCOUNTING_ORDER',
                                        'ERP_ORDER',
                                        'OMS_ORDER',
                                        'SHIPMENT',
                                      ].includes(setting?.group_code)) &&
                                    platformSettingByGroup[setting.group_code].showSetting &&
                                    values[`${settingField}_setting`] &&
                                    isCurrentSettingEnabled ? (
                                      <>
                                        {setting?.children?.length
                                          ? setting?.children
                                              ?.filter((item) => {
                                                // Exclude all datetime inputs
                                                if (item.input_type === 'DATETIME') return false

                                                // If platform is QUICKBOOKS, exclude specific names
                                                if (mainStoreData?.name === 'QUICKBOOKS') {
                                                  const excludedNames = [
                                                    'isSkipUnpaidOrders',
                                                    'isNotifyUnlinkedOrders',
                                                  ]
                                                  if (excludedNames.includes(item.name))
                                                    return false
                                                }

                                                if (isSettingFileChildInputType(item.input_type)) {
                                                  return false
                                                }

                                                if (
                                                  !shouldRenderChildByDropdownControl(
                                                    item,
                                                    setting.children ?? [],
                                                    values,
                                                    settingField,
                                                    selectedGroupSettingForChildren?.children ?? [],
                                                    childSettingControlRenderOptions
                                                  )
                                                ) {
                                                  return false
                                                }

                                                // Otherwise, include the item
                                                return true
                                              })
                                              .map(
                                                (
                                                  childSetting1: SETTINGS_OF_PLATFORM,
                                                  childIndex1: number
                                                ) => {
                                                  const sourceGroupSetting =
                                                    findSourcePlatformSettingInLists(
                                                      [
                                                        selectedPlatformSettingsByGroup,
                                                        erpPlatformSettings,
                                                        platformSettings,
                                                        primaryPlatformSettings,
                                                      ],
                                                      effectiveSourceGroupCode,
                                                      setting.name
                                                    ) ??
                                                    primaryPlatformSettings.find(
                                                      (ite) => ite.group_code === 'ORDER'
                                                    )
                                                  const isOrderPayoutChild =
                                                    childSetting1.name === 'isImportOrderPayout'
                                                  const childSettingId =
                                                    retrivedPlatformData?.platform_settings?.[
                                                      `${settingField}_setting`
                                                    ]?.id ?? null
                                                  const findPayoutGroupSetting = (
                                                    groupCode: string
                                                  ) =>
                                                    findSourcePlatformSettingInLists(
                                                      [
                                                        selectedPlatformSettingsByGroup,
                                                        erpPlatformSettings,
                                                        platformSettings,
                                                        primaryPlatformSettings,
                                                      ],
                                                      groupCode,
                                                      groupCode === setting.group_code
                                                        ? setting.name
                                                        : undefined
                                                    ) ??
                                                    primaryPlatformSettings.find(
                                                      (ite) => ite.group_code === groupCode
                                                    )
                                                  const payoutSchemaFallbackSettings = [
                                                    ...(Array.isArray(
                                                      selectedPlatformSettingsByGroup
                                                    )
                                                      ? selectedPlatformSettingsByGroup
                                                      : []),
                                                    ...platformSettings,
                                                    ...primaryPlatformSettings,
                                                  ]
                                                  const payoutBuildContext = resolvePayoutBuildContext({
                                                    effectiveSourceGroupCode,
                                                    erpPlatformSettings,
                                                    accountingPlatformSettings,
                                                    omsPlatformSettings,
                                                    fallbackSettings:
                                                      payoutSchemaFallbackSettings,
                                                    childFieldMappings:
                                                      childSetting1.field_mappings ?? [],
                                                  })
                                                  const integrationPayoutChildFieldMappings =
                                                    payoutBuildContext.integrationSchema
                                                  const isPayoutSchemaReady =
                                                    !isOrderPayoutChild ||
                                                    payoutBuildContext.isReady
                                                  const payoutFieldMappings =
                                                    isOrderPayoutChild && isPayoutSchemaReady
                                                      ? buildPayoutChildFieldMappingsCached({
                                                          schemaFieldMappings:
                                                            childSetting1.field_mappings ?? [],
                                                          erpSchemaFieldMappings:
                                                            integrationPayoutChildFieldMappings,
                                                          savedMappings,
                                                          settingId: childSettingId,
                                                          relatedAvailablePlatformId:
                                                            availablePlatformId,
                                                          erpOrderMappingsData:
                                                            payoutBuildContext.integrationOrderMappingsData,
                                                          payoutFieldMeta:
                                                            findPayoutGroupSetting('ORDER')
                                                              ?.children?.find(
                                                                (child) =>
                                                                  child.name === 'isImportOrderPayout'
                                                              )
                                                              ?.field_mappings?.find(
                                                                (fieldMapping) =>
                                                                  fieldMapping.field_code ===
                                                                  'PAYOUT_COSTS'
                                                              ) ??
                                                            childSetting1.field_mappings?.find(
                                                              (fieldMapping) =>
                                                                fieldMapping.field_code ===
                                                                'PAYOUT_COSTS'
                                                            ),
                                                        })
                                                      : null
                                                  // Child mappings from this child or same-name source child; in: childSetting + source group; out: fieldMappings to render under the child.
                                                  const mappingSource = resolveChildMappingSource({
                                                    childSetting: childSetting1,
                                                    sourceGroupSetting:
                                                      selectedGroupSettingForChildren ??
                                                      sourceGroupSetting,
                                                  })
                                                  const usesSourceChildMappings =
                                                    !isOrderPayoutChild &&
                                                    setting.group_code !== 'ORDER' &&
                                                    mappingSource.fromSource &&
                                                    mappingSource.fieldMappings.length > 0
                                                  const childItem = isOrderPayoutChild
                                                    ? {
                                                        ...childSetting1,
                                                        field_mappings: (payoutFieldMappings?.length
                                                          ? payoutFieldMappings
                                                          : []) as FIELD_MAPPING_TYPE[],
                                                      }
                                                    : payoutFieldMappings?.length
                                                    ? {
                                                        ...childSetting1,
                                                        field_mappings:
                                                          payoutFieldMappings as FIELD_MAPPING_TYPE[],
                                                      }
                                                    : {
                                                        ...childSetting1,
                                                        field_mappings: dedupeChildFieldMappingsByCode(
                                                          mappingSource.fieldMappings as FIELD_MAPPING_TYPE[]
                                                        ),
                                                      }
                                                  const sourceStoreData =
                                                    getStoreDataForSettingType(
                                                      platformSettingByGroup[setting.group_code]
                                                        ?.settingType
                                                    )
                                                  const sourceStoreName =
                                                    sourceStoreData?.platform_info?.display_name ??
                                                    sourceStoreData?.display_name

                                                  return sequenceWrapChildThis(
                                                    childSetting1,
                                                    'childsetting' +
                                                      platformSettingIndex +
                                                      childIndex1,
                                                    <DynamicChildSetting sourceChannelName={pricingEnabledFrom}
                                                      childItem={childItem}
                                                      childItemIndex={childIndex1}
                                                      settingField={settingField}
                                                      values={values}
                                                      handleChange={handleChange}
                                                      setFieldValue={setFieldValue}
                                                      settingName={`${settingField}_setting`}
                                                      settingId={
                                                        retrivedPlatformData?.platform_settings &&
                                                        retrivedPlatformData?.platform_settings[
                                                          `${settingField}_setting`
                                                        ]
                                                          ? retrivedPlatformData?.platform_settings[
                                                              `${settingField}_setting`
                                                            ].id
                                                          : null
                                                      }
                                                      savedMappings={savedMappings}
                                                      setFieldMappings={setFieldMappings}
                                                      fieldMappings={fieldMappings}
                                                      mainStoreData={mainStoreData}
                                                      retrivedPlatformData={retrivedPlatformData}
                                                      mappingSourceSide={
                                                        usesSourceChildMappings
                                                          ? Number(selectedPlatformId)
                                                          : undefined
                                                      }
                                                      mappingDestinationSide={
                                                        usesSourceChildMappings
                                                          ? sourceStoreData?.id ??
                                                            Number(selectedPlatformId)
                                                          : undefined
                                                      }
                                                      mappingSourcePlatform={
                                                        usesSourceChildMappings
                                                          ? retrivedPlatformData?.platform_info
                                                              ?.display_name ??
                                                            retrivedPlatformData?.display_name
                                                          : undefined
                                                      }
                                                      mappingDestinationPlatform={
                                                        usesSourceChildMappings
                                                          ? sourceStoreName
                                                          : undefined
                                                      }
                                                      usesSourceChildMappings={
                                                        usesSourceChildMappings
                                                      }
                                                      groupCode={setting.group_code}
                                                      secondaryOrderMappingsData={buildSecondaryOrderMappingsData(
                                                        {
                                                          platformSettings,
                                                          primaryPlatformSettings,
                                                          savedMappings,
                                                          settingId: childSettingId,
                                                        }
                                                      )}
                                                      sourceStoreData={sourceStoreData}
                                                      setSavedMappings={setSavedMappings}
                                                      platformCode={retrivedPlatformData?.code}
                                                      settingControlRenderOptions={
                                                        childSettingControlRenderOptions
                                                      }
                                                    />
                                                  )
                                                }
                                              )
                                          : null}
                                        {(() => {
                                          const additionalChildSettings =
                                            getSourceAdditionalChildSettings(
                                              selectedPlatformSettingsByGroup,
                                              effectiveSourceGroupCode,
                                              setting.name,
                                              setting.children
                                            )
                                          if (
                                            !selectedPlatformSettingsByGroup?.length ||
                                            !additionalChildSettings.length
                                          ) {
                                            return null
                                          }

                                          return additionalChildSettings.map(
                                                (
                                                  primaryChildItem: SETTINGS_OF_PLATFORM,
                                                  primaryChildItemIndex: number
                                                ) => {
                                                  if (
                                                    !shouldRenderChildByDropdownControl(
                                                      primaryChildItem,
                                                      additionalChildSettings,
                                                      values,
                                                      settingField,
                                                      setting?.children ?? [],
                                                      buildChildSettingControlRenderOptions(
                                                        selectedGroupSettingForChildren,
                                                        setting,
                                                        fieldMappings,
                                                        savedMappings
                                                      )
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  if (
                                                    setting?.children?.length &&
                                                    setting?.children?.find(
                                                      (it) => it.name == primaryChildItem.name
                                                    ) &&
                                                    !isSettingFileChildInputType(
                                                      primaryChildItem.input_type
                                                    )
                                                  ) {
                                                    //it means setting is exist in secondary channel so no need to map particular setting form primary
                                                    return null
                                                  } else {
                                                    const wrapExtraChild = (node: React.ReactNode) =>
                                                      sequenceWrapExtraChild(
                                                        primaryChildItem,
                                                        platformSettingIndex +
                                                          'primaryPlatformAdditionalSetting' +
                                                          primaryChildItemIndex,
                                                        node
                                                      )
                                                    if (primaryChildItem?.input_type == 'BOOLEAN') {
                                                      const sourceStoreData =
                                                        getStoreDataForSettingType(
                                                          platformSettingByGroup[
                                                            setting.group_code
                                                          ]?.settingType
                                                        )
                                                      const sourceStoreName =
                                                        sourceStoreData?.platform_info
                                                          ?.display_name ??
                                                        sourceStoreData?.display_name

                                                      return wrapExtraChild(
                                                        <DynamicChildSetting sourceChannelName={pricingEnabledFrom}
                                                          key={
                                                            platformSettingIndex +
                                                            'primaryPlatformAdditionalSetting' +
                                                            primaryChildItemIndex
                                                          }
                                                          childItem={primaryChildItem}
                                                          childItemIndex={primaryChildItemIndex}
                                                          settingField={settingField}
                                                          values={values}
                                                          handleChange={handleChange}
                                                          setFieldValue={setFieldValue}
                                                          settingName={`${settingField}_setting`}
                                                          settingId={
                                                            retrivedPlatformData
                                                              ?.platform_settings?.[
                                                              `${settingField}_setting`
                                                            ]?.id ?? null
                                                          }
                                                          savedMappings={
                                                            values[`${settingField}_setting`]?.[
                                                              `${mappings_setting_field}_field_mappings`
                                                            ] ?? []
                                                          }
                                                          setFieldMappings={setFieldMappings}
                                                          fieldMappings={fieldMappings}
                                                          mainStoreData={mainStoreData}
                                                          retrivedPlatformData={
                                                            retrivedPlatformData
                                                          }
                                                          mappingSourceSide={Number(
                                                            selectedPlatformId
                                                          )}
                                                          mappingDestinationSide={
                                                            sourceStoreData?.id ??
                                                            Number(selectedPlatformId)
                                                          }
                                                          mappingSourcePlatform={
                                                            retrivedPlatformData?.platform_info
                                                              ?.display_name ??
                                                            retrivedPlatformData?.display_name
                                                          }
                                                          mappingDestinationPlatform={
                                                            sourceStoreName
                                                          }
                                                          settingControlRenderOptions={buildChildSettingControlRenderOptions(
                                                            selectedGroupSettingForChildren,
                                                            setting,
                                                            fieldMappings,
                                                            savedMappings
                                                          )}
                                                        />
                                                      )
                                                    } else if (
                                                      primaryChildItem?.input_type == 'INTEGER'
                                                    ) {
                                                      return wrapExtraChild(
                                                        <CustomInput sourceChannelName={pricingEnabledFrom}
                                                          key={
                                                            platformSettingIndex +
                                                            'primaryPlatformAdditionalSetting' +
                                                            primaryChildItemIndex
                                                          }
                                                          label={primaryChildItem.display_name}
                                                          message={primaryChildItem.description}
                                                          containerClasses={getSequenceCustomInputContainerClass()}
                                                          useSequenceBandLayout
                                                          inputProps={{
                                                            type: 'number',
                                                            className:
                                                              'form-control form-control-lg',
                                                            name: settingField
                                                              ? `${settingField}_setting.${primaryChildItem.name}`
                                                              : primaryChildItem.name,
                                                            value: settingField
                                                              ? values[`${settingField}_setting`][
                                                                  `${primaryChildItem.name}`
                                                                ]
                                                              : values[primaryChildItem.name],
                                                            onChange: handleChange,
                                                            id:
                                                              primaryChildItem.group_code +
                                                              primaryChildItem.name,
                                                            required:
                                                              primaryChildItem.is_required || false,
                                                          }}
                                                        />
                                                      )
                                                    } else if (
                                                      primaryChildItem?.input_type == 'DATETIME'
                                                    ) {
                                                      return wrapExtraChild(
                                                        <CustomInput sourceChannelName={pricingEnabledFrom}
                                                          key={
                                                            platformSettingIndex +
                                                            'primaryPlatformAdditionalSetting' +
                                                            primaryChildItemIndex
                                                          }
                                                          label={primaryChildItem.display_name}
                                                          message={primaryChildItem.description}
                                                          containerClasses={getSequenceCustomInputContainerClass()}
                                                          useSequenceBandLayout
                                                          inputProps={{
                                                            type: 'datetime-local',
                                                            className:
                                                              'form-control form-control-lg',
                                                            name: settingField
                                                              ? `${settingField}_setting.${primaryChildItem.name}`
                                                              : primaryChildItem.name,
                                                            value: settingField
                                                              ? formatDateForDateTimeLocal(
                                                                  values[`${settingField}_setting`]?.[
                                                                    `${primaryChildItem.name}`
                                                                  ]
                                                                )
                                                              : values[primaryChildItem.name] ?? '',
                                                            onChange: handleChange,
                                                            id:
                                                              primaryChildItem.group_code +
                                                              primaryChildItem.name,
                                                            required:
                                                              primaryChildItem.is_required || false,
                                                          }}
                                                        />
                                                      )
                                                    } else if (
                                                      primaryChildItem?.input_type == 'SELECT'
                                                    ) {
                                                      return wrapExtraChild(
                                                        <div
                                                          className=''
                                                          key={
                                                            platformSettingIndex +
                                                            'primaryPlatformAdditionalSetting' +
                                                            primaryChildItemIndex
                                                          }
                                                        >
                                                          {/* <div className='row p-4'> */}
                                                          <>
                                                            <div
                                                              className={getSequenceFieldWrapperClass(
                                                                'col-12 col-sm-6 mt-4'
                                                              )}
                                                              style={{paddingRight: '5.5rem'}}
                                                            >
                                                              <label
                                                                className='form-label'
                                                                htmlFor={primaryChildItem.name}
                                                              >
                                                                {formatSettingDisplayText(primaryChildItem.display_name)}
                                                                &nbsp;&nbsp;
                                                                <InfoTooltip sourceChannelName={pricingEnabledFrom}
                                                                  message={
                                                                    primaryChildItem.description
                                                                  }
                                                                />
                                                              </label>
                                                              <select
                                                                name={primaryChildItem.name}
                                                                value={
                                                                  values[`${primaryChildItem.name}`]
                                                                }
                                                                onChange={handleChange}
                                                                className='form-select form-select-lg'
                                                              >
                                                                <option value=''>
                                                                  {formatSettingDisplayText(primaryChildItem.placeholder)}
                                                                </option>
                                                                {primaryChildItem.setting_options.map(
                                                                  (item: any) => {
                                                                    return (
                                                                      <option
                                                                        key={item.id}
                                                                        value={item.name}
                                                                      >
                                                                        {formatSettingDisplayText(item.display_name)}
                                                                      </option>
                                                                    )
                                                                  }
                                                                )}
                                                              </select>
                                                            </div>
                                                          </>
                                                        </div>
                                                        // </div>
                                                      )
                                                    } else if (
                                                      primaryChildItem?.input_type == 'TEXT' &&
                                                      primaryChildItem?.showShortcodes
                                                    ) {
                                                      return wrapExtraChild(
                                                        <ShortCodeInput sourceChannelName={pricingEnabledFrom}
                                                          key={
                                                            platformSettingIndex +
                                                            'primaryPlatformAdditionalSetting' +
                                                            primaryChildItemIndex
                                                          }
                                                          label={primaryChildItem.display_name}
                                                          message={primaryChildItem.description}
                                                          containerClasses={getSequenceCustomInputContainerClass()}
                                                          useSequenceBandLayout
                                                          inputProps={{
                                                            type: 'text',
                                                            className:
                                                              'form-control form-control-lg',
                                                            placeholder:
                                                              primaryChildItem.placeholder ?? '',
                                                            name: settingField
                                                              ? `${settingField}_setting.${primaryChildItem.name}`
                                                              : primaryChildItem.name,
                                                            value: settingField
                                                              ? values[`${settingField}_setting`][
                                                                  `${primaryChildItem.name}`
                                                                ]
                                                              : values[primaryChildItem.name],
                                                            onChange: handleChange,
                                                            id:
                                                              primaryChildItem.group_code +
                                                              primaryChildItem.name,
                                                            required:
                                                              primaryChildItem.is_required || false,
                                                          }}
                                                        />
                                                      )
                                                    } else if (primaryChildItem?.input_type === 'TEXT_READONLY') {
                                                      return wrapExtraChild(
                                                        <div
                                                          key={
                                                            platformSettingIndex +
                                                            'primaryPlatformAdditionalSetting' +
                                                            primaryChildItemIndex
                                                          }
                                                          className={getSequenceFieldWrapperClass(
                                                            'col-12 col-sm-6 mt-4'
                                                          )}
                                                          style={{paddingRight: '5.5rem' }}
                                                        >
                                                          <CustomInput sourceChannelName={pricingEnabledFrom}
                                                            label={primaryChildItem.display_name}
                                                            message={primaryChildItem.description}
                                                            containerClasses=''
                                                            inputProps={{
                                                              type: 'text',
                                                              className:
                                                                'form-control form-control-lg',
                                                              name: settingField
                                                                ? `${settingField}_setting.${primaryChildItem.name}`
                                                                : primaryChildItem.name,
                                                              value: settingField
                                                                ? values[`${settingField}_setting`][
                                                                    `${primaryChildItem.name}`
                                                                  ]
                                                                : values[primaryChildItem.name],
                                                              id:
                                                                primaryChildItem.group_code +
                                                                primaryChildItem.name,
                                                              required:
                                                                primaryChildItem.is_required || false,
                                                              readOnly: true,
                                                              'aria-readonly': true,
                                                            }}
                                                            showCopyButton
                                                          />
                                                          <SettingNotes
                                                            notes={primaryChildItem.notes}
                                                            retrivedPlatformData={retrivedPlatformData}
                                                            mainStoreData={mainStoreData ?? undefined}
                                                            pricingEnabledFrom={pricingEnabledFrom}
                                                          />
                                                        </div>
                                                      )
                                                    } else {
                                                      return wrapExtraChild(
                                                        <CustomInput sourceChannelName={pricingEnabledFrom}
                                                          key={
                                                            platformSettingIndex +
                                                            'primaryPlatformAdditionalSetting' +
                                                            primaryChildItemIndex
                                                          }
                                                          label={primaryChildItem.display_name}
                                                          message={primaryChildItem.description}
                                                          inputProps={{
                                                            type: 'text',
                                                            className:
                                                              'form-control form-control-lg',
                                                            name: settingField
                                                              ? `${settingField}_setting.${primaryChildItem.name}`
                                                              : primaryChildItem.name,
                                                            value: settingField
                                                              ? values[`${settingField}_setting`][
                                                                  `${primaryChildItem.name}`
                                                                ]
                                                              : values[primaryChildItem.name],
                                                            onChange: handleChange,
                                                            id:
                                                              primaryChildItem.group_code +
                                                              primaryChildItem.name,
                                                            required:
                                                              primaryChildItem.is_required || false,
                                                          }}
                                                        />
                                                      )
                                                    }
                                                  }
                                                }
                                              )
                                        })()}
                                      </>
                                    ) : null}
                                  </ChannelSettingLegacySequenceContainer>
                                  {/* {(mainStoreData?.id !== Number(selectedPlatformId)) && setting?.field_mappings?.length ? (
                                    <>
                                      {values[`${settingField}_setting`] && values[`${settingField}_setting`][
                                        `${setting.name}`
                                      ] ? setting.field_mappings.map((field_mapping:FIELD_MAPPING_TYPE, index)=>{
                                        return (
                                        <MappingInput
                                          key={field_mapping.display_name+index+isMappingChanged+''}
                                          selectedPlatformId={Number(selectedPlatformId)}
                                          sourceSide={mainStoreData?.id!}
                                          destinationSide={Number(selectedPlatformId)!}
                                          sourcePlatform={mainStoreData?.platform_info?.display_name}
                                          destinationPlatform={retrivedPlatformData?.platform_info?.display_name}
                                          isMappingVisible={
                                            values[`${settingField}_setting`] &&  values[`${settingField}_setting`][
                                              `${setting.name}`
                                            ]
                                              ? values[`${settingField}_setting`][
                                                  `${setting.name}`
                                                ]
                                              : false
                                          }
                                          handleChange={handleChange}
                                          field_mapping={field_mapping}
                                          savedMapping={ values[`${settingField}_setting`] && values[`${settingField}_setting`][`${settingField}_field_mappings`]?.length ?
                                                values[`${settingField}_setting`][`${settingField}_field_mappings`].find((it)=>(it?.destination_field?.api_code===field_mapping.field_code)) : null
                                          }
                                          settingName={`${settingField}_setting`}
                                          settingId={ retrivedPlatformData?.platform_settings && retrivedPlatformData?.platform_settings[`${settingField}_setting`] ? retrivedPlatformData?.platform_settings[`${settingField}_setting`].id : null }
                                          setFieldMappings={setFieldMappings}
                                          fieldMappings={fieldMappings}
                                        />
                                      ) 
                                      })
                                      : null}
                                    </>
                                  ) : null} */}

                                  {/* { values[`${settingField}_setting`] &&
                                     values[`${settingField}_setting`][
                                      `${setting.name}`
                                    ] && primaryPlatformSettings.length ? // checking the length of primary pltfm setting
                                        primaryPlatformSettings.find(it=>it.group_code===setting.group_code)?.field_mappings.length ?
                                        primaryPlatformSettings.find(it=>it.group_code===setting.group_code)?.field_mappings.map((field_mapping:FIELD_MAPPING_TYPE, index)=>{
                                          return (<>
                                              <MappingInput
                                                key={field_mapping.display_name+index+isMappingChanged+''}
                                                selectedPlatformId={Number(selectedPlatformId)}
                                                sourceSide={Number(selectedPlatformId)}
                                                destinationSide={Number(mainStoreData?.id)}
                                                sourcePlatform={retrivedPlatformData?.platform_info?.display_name}
                                                destinationPlatform={mainStoreData?.platform_info?.display_name}
                                                isMappingVisible={values[`${settingField}_setting`][`${setting.name}`]}
                                                handleChange={handleChange}
                                                field_mapping={field_mapping}
                                                savedMapping={values[`${settingField}_setting`][`${settingField}_field_mappings`]?.length ?
                                                  values[`${settingField}_setting`][`${settingField}_field_mappings`].find((it)=>(it?.destination_field?.api_code===field_mapping.field_code)) : null
                                                }
                                                settingName={`${settingField}_setting`}
                                                settingId={retrivedPlatformData?.platform_settings[`${settingField}_setting`] ? retrivedPlatformData?.platform_settings[`${settingField}_setting`].id : null }
                                                setFieldMappings={setFieldMappings}
                                                fieldMappings={fieldMappings}
                                              />
                                          </>)
                                        })
                                            : 
                                          null
                                      : null
                                  } */}
                                  {/* {values[`${settingField}_setting`] &&
                                  values[`${settingField}_setting`][`${setting.name}`] && <div>
                                    
                                    </div>} */}
                                  {/* Primary Platform Mappings */}
                                  {platformSettingByGroup[setting.group_code].showSetting &&
                                  values[`${settingField}_setting`] &&
                                  values[`${settingField}_setting`][`${setting.name}`] &&
                                  selectedPlatformSettingsByGroup?.length > 0
                                    ? (() => {
                                        const selectedGroupSetting =
                                          findSourcePlatformSettingByGroup(
                                            selectedPlatformSettingsByGroup,
                                            effectiveSourceGroupCode,
                                            setting.name
                                          ) as any

                                        const primaryFieldMappings: any =
                                          selectedGroupSetting?.mappings_data || []

                                        const primaryFieldMetaMap = buildFieldMappingMetaMap(
                                          selectedGroupSetting?.field_mappings
                                        )

                                        const {settingType} =
                                          platformSettingByGroup[setting.group_code]
                                        const sourceStoreData = selectedSourceStoreData

                                        const normalizedPrimaryMappings = (
                                          primaryFieldMappings ?? []
                                        )
                                          .map((field_mapping: any, index: number) => ({
                                            enrichedFieldMapping: enrichFieldMapping(
                                              field_mapping,
                                              primaryFieldMetaMap
                                            ),
                                            index,
                                          }))
                                          .filter(
                                            ({enrichedFieldMapping}) =>
                                              isMappingDependencySatisfied(enrichedFieldMapping) &&
                                              !isSettingFileActionMapping(enrichedFieldMapping)
                                          )

                                        const isPrimaryMappingDropdownVisible = (mapping: any) =>
                                          shouldRenderMappingByDropdownControl(
                                            mapping,
                                            primaryFieldMappings,
                                            fieldMappings,
                                            savedMappings,
                                            setting?.mappings_data ?? []
                                          )

                                        const wrapPrimaryMapping = (
                                          node: React.ReactNode,
                                          enrichedFieldMapping: any,
                                          mappingIndex: number
                                        ) =>
                                          sequenceWrapPrimaryMapping(
                                            enrichedFieldMapping,
                                            mappingIndex,
                                            node
                                          )

                                        const appendPrimaryMappingElement = (
                                          acc: {independent: React.ReactNode[]; dependent: React.ReactNode[]},
                                          {enrichedFieldMapping, index}: {enrichedFieldMapping: any; index: number}
                                        ) => {
                                            if (!isPrimaryMappingDropdownVisible(enrichedFieldMapping)) {
                                              return acc
                                            }
                                            if (
                                              // Hide default Location Independent Mapping unless this group also has a pair slot; in: mapping row, types, other-side mappings_data, this mappings_data; out: true to skip.
                                              shouldHideDefaultLocationMapping(
                                                enrichedFieldMapping,
                                                selectedGroupSetting?.type ?? settingType,
                                                setting?.mappings_data ?? [],
                                                primaryFieldMappings ?? []
                                              )
                                            ) {
                                              return acc
                                            }
                                            if (
                                              shouldHideDefaultWhenOneToOneExists({
                                                mapping: enrichedFieldMapping,
                                                savedMappings,
                                                pendingMappings:
                                                  values[`${settingField}_setting`]?.[
                                                    `${mappings_setting_field}_field_mappings`
                                                  ] ?? [],
                                                settingId:
                                                  retrivedPlatformData?.platform_settings?.[
                                                    `${settingField}_setting`
                                                  ]?.id ?? setting?.id ?? null,
                                                targetCode: 'SHIPPINGPROVIDER',
                                              })
                                            ) {
                                              return acc
                                            }
                                            if (
                                              shouldSourceLocationOwnPair(
                                                enrichedFieldMapping,
                                                setting?.mappings_data ?? [],
                                                primaryFieldMappings ?? []
                                              )
                                            ) {
                                              return acc
                                            }
                                            if (enrichedFieldMapping?.isDefault) {
                                              acc?.independent.push(
                                                wrapPrimaryMapping(
                                                <IndependentMapping
                                                  key={`independent_${enrichedFieldMapping.display_name}_${index}_${isMappingChanged}`}
                                                  selectedPlatformId={Number(selectedPlatformId)}
                                                  sourceSide={sourceStoreData?.id!}
                                                  destinationSide={Number(selectedPlatformId)!}
                                                  sourcePlatform={
                                                    sourceStoreData?.platform_info?.display_name
                                                  }
                                                  destinationPlatform={
                                                    retrivedPlatformData?.platform_info
                                                      ?.display_name
                                                  }
                                                  isMappingVisible={
                                                    values[`${settingField}_setting`]?.[
                                                      `${setting.name}`
                                                    ] ?? false
                                                  }
                                                  handleChange={handleChange}
                                                  field_mapping={enrichedFieldMapping}
                                                  savedMapping={findIndependentSavedFieldMapping(
                                                    values[`${settingField}_setting`]?.[
                                                      `${mappings_setting_field}_field_mappings`
                                                    ] ?? [],
                                                    enrichedFieldMapping,
                                                    {
                                                      destinationPlatformId: sourceStoreData?.id,
                                                      settingId:
                                                        retrivedPlatformData?.platform_settings?.[
                                                          `${settingField}_setting`
                                                        ]?.id ?? null,
                                                    }
                                                  )}
                                                  settingName={`${settingField}_setting`}
                                                  settingId={
                                                    retrivedPlatformData?.platform_settings?.[
                                                      `${settingField}_setting`
                                                    ]?.id ?? null
                                                  }
                                                  setFieldMappings={setFieldMappings}
                                                  fieldMappings={fieldMappings}
                                                  index={index}
                                                  savedMappings={savedMappings}
                                                  setSavedMappings={setSavedMappings}
                                                  isRequiredMissing={missingRequiredMappingKeys.has(
                                                    buildMappingErrorKey({
                                                      settingMappingId:
                                                        enrichedFieldMapping?.setting_mapping_id,
                                                    })
                                                  )}
                                                />,
                                                enrichedFieldMapping,
                                                index
                                              )
                                              )
                                            } else {
                                              if (
                                                usesNewDependentPairFormation(setting?.group_code)
                                              ) {
                                                return acc
                                              }

                                              const isMappedWith =
                                                enrichedFieldMapping?.map_with ??
                                                findSourceLocationMapping(
                                                  [
                                                    {
                                                      group_code: setting?.group_code,
                                                      mappings_data: setting?.mappings_data ?? [],
                                                    },
                                                  ],
                                                  setting?.group_code,
                                                  enrichedFieldMapping
                                                )

                                              if (
                                                shouldResolveIndependentLocationFieldMappingSlot(
                                                  enrichedFieldMapping,
                                                  isMappedWith,
                                                  setting?.mappings_data ?? []
                                                )
                                              ) {
                                                const locationSettingId =
                                                  retrivedPlatformData?.platform_settings?.[
                                                    `${settingField}_setting`
                                                  ]?.id ?? null
                                                const locationSlotCandidates =
                                                  collectLocationSlotCandidates(
                                                    setting?.mappings_data ?? []
                                                  )
                                                const resolvedLocationFieldMapping =
                                                  resolveIndependentLocationFieldMappingSlot(
                                                    enrichedFieldMapping,
                                                    savedMappings,
                                                    {
                                                      destinationPlatformId: sourceStoreData?.id,
                                                      settingId: locationSettingId,
                                                      locationSlotCandidates,
                                                    }
                                                  )
                                                const resolvedLocationEnriched = enrichFieldMapping(
                                                  resolvedLocationFieldMapping as any,
                                                  primaryFieldMetaMap
                                                )
                                                const resolvedLocationSavedMapping =
                                                  findIndependentSavedFieldMapping(
                                                    savedMappings,
                                                    resolvedLocationEnriched,
                                                    {
                                                      destinationPlatformId: sourceStoreData?.id,
                                                      settingId: locationSettingId,
                                                    }
                                                  ) ??
                                                  findIndependentSavedFieldMapping(
                                                    values[`${settingField}_setting`]?.[
                                                      `${mappings_setting_field}_field_mappings`
                                                    ] ?? [],
                                                    resolvedLocationEnriched,
                                                    {
                                                      destinationPlatformId: sourceStoreData?.id,
                                                      settingId: locationSettingId,
                                                    }
                                                  )

                                                acc?.independent.push(
                                                  wrapPrimaryMapping(
                                                  <IndependentMapping
                                                    key={`independent_location_${setting?.group_code}_${resolvedLocationEnriched.display_name}_${resolvedLocationEnriched?.setting_mapping_id ?? index}_${isMappingChanged}`}
                                                    selectedPlatformId={Number(selectedPlatformId)}
                                                    sourceSide={sourceStoreData?.id!}
                                                    destinationSide={Number(selectedPlatformId)!}
                                                    sourcePlatform={
                                                      sourceStoreData?.platform_info?.display_name
                                                    }
                                                    destinationPlatform={
                                                      retrivedPlatformData?.platform_info
                                                        ?.display_name
                                                    }
                                                    isMappingVisible={
                                                      values[`${settingField}_setting`]?.[
                                                        `${setting.name}`
                                                      ] ?? false
                                                    }
                                                    handleChange={handleChange}
                                                    field_mapping={resolvedLocationEnriched}
                                                    savedMapping={resolvedLocationSavedMapping}
                                                    settingName={`${settingField}_setting`}
                                                    settingId={locationSettingId}
                                                    setFieldMappings={setFieldMappings}
                                                    fieldMappings={fieldMappings}
                                                    index={index}
                                                    savedMappings={savedMappings}
                                                    setSavedMappings={setSavedMappings}
                                                    isRequiredMissing={missingRequiredMappingKeys.has(
                                                      buildMappingErrorKey({
                                                        settingMappingId:
                                                          resolvedLocationEnriched?.setting_mapping_id,
                                                      })
                                                    )}
                                                  />,
                                                  resolvedLocationEnriched,
                                                  index
                                                )
                                                )
                                                return acc
                                              }

                                              acc.dependent.push(
                                                wrapPrimaryMapping(
                                                <DependentMapping
                                                  key={`dependent_${
                                                    setting?.group_code
                                                  }_${settingField}_${
                                                    enrichedFieldMapping?.setting_mapping_id ??
                                                    enrichedFieldMapping?.id ??
                                                    enrichedFieldMapping?.api_code
                                                  }_${
                                                    isMappedWith?.id ?? 'nomap'
                                                  }_${index}_${isMappingChanged}`}
                                                  selectedPlatformId={Number(selectedPlatformId)}
                                                  sourcePlatform={
                                                    sourceStoreData?.platform_info?.display_name
                                                  }
                                                  destinationPlatform={
                                                    retrivedPlatformData?.platform_info
                                                      ?.display_name
                                                  }
                                                  isMappingVisible={
                                                    values[`${settingField}_setting`]?.[
                                                      `${setting.name}`
                                                    ] ?? false
                                                  }
                                                  handleChange={handleChange}
                                                  field_mapping={enrichedFieldMapping}
                                                  savedMapping={
                                                    findDependentSavedFieldMapping(
                                                      [
                                                        ...(values[`${settingField}_setting`]?.[
                                                          `${mappings_setting_field}_field_mappings`
                                                        ] ?? []),
                                                        ...(savedMappings ?? []),
                                                      ],
                                                      {
                                                        sourceSide: enrichedFieldMapping,
                                                        destinationSide: isMappedWith,
                                                        effectiveSettingMappingId:
                                                          enrichedFieldMapping?.setting_mapping_id ??
                                                          isMappedWith?.setting_mapping_id,
                                                        settingId:
                                                          retrivedPlatformData?.platform_settings?.[
                                                            `${settingField}_setting`
                                                          ]?.id ?? null,
                                                        isDefault: enrichedFieldMapping?.isDefault,
                                                        sourceCode: enrichedFieldMapping?.api_code,
                                                        destinationCode: isMappedWith?.api_code,
                                                        sourcePlatformId: sourceStoreData?.id,
                                                        destinationPlatformId:
                                                          Number(selectedPlatformId),
                                                      }
                                                    ) as SECTION_WISE_SAVED_FIELD_MAPPING | null
                                                  }
                                                  settingName={`${settingField}_setting`}
                                                  settingId={
                                                    retrivedPlatformData?.platform_settings?.[
                                                      `${settingField}_setting`
                                                    ]?.id ?? null
                                                  }
                                                  setFieldMappings={setFieldMappings}
                                                  fieldMappings={fieldMappings}
                                                  index={index}
                                                  savedMappings={savedMappings}
                                                  setSavedMappings={setSavedMappings}
                                                  primary_settings={true}
                                                  group_code={setting?.group_code}
                                                  isMappedWith={isMappedWith}
                                                  platformCode={(
                                                    retrivedPlatformData?.code ?? ''
                                                  ).toUpperCase()}
                                                  showUploadButton={shouldShowShippingMethodUploadButton({
                                                    groupCode: setting?.group_code,
                                                    sourceStore: sourceStoreData,
                                                    fieldMapping: enrichedFieldMapping,
                                                    mappedPartner: isMappedWith,
                                                  })}
                                                  onUploadClick={() =>
                                                    openShippingProviderUploadModal(
                                                      getPlatformCode(sourceStoreData) ===
                                                        'SHIPHERO'
                                                        ? sourceStoreData
                                                        : undefined
                                                    )
                                                  }
                                                  isRequiredMissing={missingRequiredMappingKeys.has(
                                                    buildMappingErrorKey({
                                                      settingMappingId:
                                                        enrichedFieldMapping?.setting_mapping_id,
                                                    })
                                                  )}
                                                />,
                                                enrichedFieldMapping,
                                                index
                                              )
                                              )
                                            }
                                            return acc
                                        }

                                        ;(() => {
                                        const {parentEntries, childrenByParentId} =
                                          groupMappingRenderEntries(normalizedPrimaryMappings)
                                        return parentEntries.reduce(
                                          (acc, entry) => {
                                            if (
                                              !isPrimaryMappingDropdownVisible(
                                                entry.enrichedFieldMapping
                                              )
                                            ) {
                                              return acc
                                            }
                                            const childEntries = getBooleanMappingChildren(
                                              entry.enrichedFieldMapping,
                                              childrenByParentId
                                            )
                                            if (!childEntries.length) {
                                              return appendPrimaryMappingElement(acc, entry)
                                            }

                                            const parentAcc = appendPrimaryMappingElement(
                                              {independent: [], dependent: []},
                                              entry
                                            )
                                            const childAcc = childEntries
                                              .filter((childEntry) =>
                                                isPrimaryMappingDropdownVisible(
                                                  childEntry.enrichedFieldMapping
                                                )
                                              )
                                              .reduce(
                                              (next, childEntry) =>
                                                appendPrimaryMappingElement(next, childEntry),
                                              {
                                                independent: [] as React.ReactNode[],
                                                dependent: [] as React.ReactNode[],
                                              }
                                            )
                                            const parentSettingMappingId = getMappingOwnId(
                                              entry.enrichedFieldMapping
                                            )
                                            acc.independent.push(
                                              wrapPrimaryMapping(
                                                <LinkedBooleanMappingBlock
                                                  key={`mapping_parent_${parentSettingMappingId}_${entry.index}`}
                                                  isParentEnabled={isTruthyMappingParentValue(
                                                    getMappingValueBySettingMappingId(
                                                      parentSettingMappingId
                                                    )
                                                  )}
                                                  parentControl={
                                                    <>
                                                      {parentAcc.independent}
                                                      {parentAcc.dependent}
                                                    </>
                                                  }
                                                >
                                                  <div className='row g-4'>
                                                    {childAcc.independent}
                                                    {childAcc.dependent}
                                                  </div>
                                                </LinkedBooleanMappingBlock>,
                                                entry.enrichedFieldMapping,
                                                entry.index
                                              )
                                            )
                                            return acc
                                          },
                                          {
                                            independent: [] as React.ReactNode[],
                                            dependent: [] as React.ReactNode[],
                                          }
                                        )
                                          })()

                                        return null
                                      })()
                                    : null}

                                  {/* Secondary Platform Mappings */}
                                  {platformSettingByGroup[setting.group_code].showSetting &&
                                  shouldRenderThisSideMappingsOnPrimaryHub(
                                    setting?.group_code,
                                    isSelectedPrimaryHubStore
                                  ) &&
                                  setting?.mappings_data?.length > 0 ? (
                                    <>
                                      {values[`${settingField}_setting`] &&
                                      values[`${settingField}_setting`][`${setting.name}`]
                                        ? (() => {
                                            const {settingType} =
                                              platformSettingByGroup[setting.group_code]
                                            const sourceStoreData = selectedSourceStoreData

                                            const source_platform_id = [
                                              'SHIPMENT',
                                              'TICKET',
                                              'INVENTORY',
                                              'PRICING',
                                              'PRODUCT',
                                              'INVOICE',
                                            ].includes(setting?.group_code)
                                              ? sourceStoreData?.id
                                              : Number(selectedPlatformId)
                                            const destination_platform_id = [
                                              'SHIPMENT',
                                              'TICKET',
                                              'INVENTORY',
                                              'PRICING',
                                              'PRODUCT',
                                              'INVOICE',
                                            ].includes(setting?.group_code)
                                              ? Number(selectedPlatformId)
                                              : sourceStoreData?.id

                                            const fieldMappingMetaMap = buildFieldMappingMetaMap(
                                              setting.field_mappings
                                            )

                                            const oppositeLocationMappings =
                                              selectedPlatformSettingsByGroup?.find(
                                                (item) => item.group_code === setting?.group_code
                                              )?.mappings_data ?? []

                                            const normalizedMappings =
                                              filterMappingsByRelatedAvailablePlatform(
                                                setting.mappings_data ?? [],
                                                setting.field_mappings ?? [],
                                                availablePlatformId
                                              )
                                              .map((field_mapping: any, index: number) => ({
                                                enrichedFieldMapping: enrichFieldMapping(
                                                  field_mapping,
                                                  fieldMappingMetaMap
                                                ),
                                                index,
                                              }))
                                              .filter(
                                                ({enrichedFieldMapping}) =>
                                                  isMappingDependencySatisfied(enrichedFieldMapping) &&
                                                  !isSettingFileActionMapping(enrichedFieldMapping)
                                              )

                                            const renderMappingControl = (
                                              enrichedFieldMapping: any,
                                              index: number
                                            ) => {
                                              if (
                                                // Hide default Location Independent Mapping unless this group also has a pair slot; in: mapping row, types, other-side mappings_data, this mappings_data; out: true to skip.
                                              shouldHideDefaultLocationMapping(
                                                  enrichedFieldMapping,
                                                  settingType,
                                                  oppositeLocationMappings,
                                                  setting?.mappings_data ?? []
                                                )
                                              ) {
                                                return null
                                              }
                                              if (
                                                shouldHideDefaultWhenOneToOneExists({
                                                  mapping: enrichedFieldMapping,
                                                  savedMappings,
                                                  pendingMappings:
                                                    values[`${settingField}_setting`]?.[
                                                      `${mappings_setting_field}_field_mappings`
                                                    ] ?? [],
                                                  settingId:
                                                    retrivedPlatformData?.platform_settings?.[
                                                      `${settingField}_setting`
                                                    ]?.id ?? setting?.id ?? null,
                                                  targetCode: 'SHIPPINGPROVIDER',
                                                })
                                              ) {
                                                return null
                                              }

                                              if (
                                                shouldHideOneToOneLocationSlot(
                                                  enrichedFieldMapping,
                                                  oppositeLocationMappings,
                                                  setting?.mappings_data ?? []
                                                )
                                              ) {
                                                return null
                                              }

                                              if (enrichedFieldMapping?.isDefault) {
                                                return (
                                                  <IndependentMapping
                                                    key={`independent_${enrichedFieldMapping.display_name}_${index}_${isMappingChanged}`}
                                                    selectedPlatformId={Number(selectedPlatformId)}
                                                    sourceSide={sourceStoreData?.id!}
                                                    destinationSide={Number(selectedPlatformId)!}
                                                    sourcePlatform={
                                                      retrivedPlatformData?.platform_info
                                                        ?.display_name
                                                    }
                                                    destinationPlatform={
                                                      retrivedPlatformData?.platform_info
                                                        ?.display_name
                                                    }
                                                    isMappingVisible={
                                                      values[`${settingField}_setting`]?.[
                                                        `${setting.name}`
                                                      ] ?? false
                                                    }
                                                    handleChange={handleChange}
                                                    field_mapping={enrichedFieldMapping}
                                                    savedMapping={
                                                      findIndependentSavedFieldMapping(
                                                        savedMappings,
                                                        enrichedFieldMapping,
                                                        {
                                                          destinationPlatformId:
                                                            Number(selectedPlatformId),
                                                          settingId:
                                                            retrivedPlatformData?.platform_settings?.[
                                                              `${settingField}_setting`
                                                            ]?.id ?? null,
                                                        }
                                                      ) ??
                                                      findIndependentSavedFieldMapping(
                                                        values[`${settingField}_setting`]?.[
                                                          `${mappings_setting_field}_field_mappings`
                                                        ] ?? [],
                                                        enrichedFieldMapping,
                                                        {
                                                          destinationPlatformId:
                                                            Number(selectedPlatformId),
                                                          settingId:
                                                            retrivedPlatformData?.platform_settings?.[
                                                              `${settingField}_setting`
                                                            ]?.id ?? null,
                                                        }
                                                      )
                                                    }
                                                    settingName={`${settingField}_setting`}
                                                    settingId={
                                                      retrivedPlatformData?.platform_settings?.[
                                                        `${settingField}_setting`
                                                      ]?.id ?? null
                                                    }
                                                    setFieldMappings={setFieldMappings}
                                                    fieldMappings={fieldMappings}
                                                    index={index}
                                                    savedMappings={savedMappings}
                                                    setSavedMappings={setSavedMappings}
                                                    isRequiredMissing={missingRequiredMappingKeys.has(
                                                      buildMappingErrorKey({
                                                        settingMappingId:
                                                          enrichedFieldMapping?.setting_mapping_id,
                                                      })
                                                    )}
                                                  />
                                                )
                                              }

                                              const otherSideMapping =
                                                findSourcePlatformSettingByGroup(
                                                  selectedPlatformSettingsByGroup,
                                                  effectiveSourceGroupCode,
                                                  setting.name
                                                ) as any

                                              const shippingGroupCandidate =
                                                setting?.group_code === 'ORDER'
                                                  ? shippingPlatformSettings?.find(
                                                      (item: any) => item?.group_code === 'SHIPMENT'
                                                    )
                                                  : null

                                              const oppositeFieldMetaMap = buildFieldMappingMetaMap(
                                                otherSideMapping?.field_mappings
                                              )

                                              const usesNewPairFormation =
                                                usesNewDependentPairFormation(setting?.group_code)

                                              const isMappedWith = (() => {
                                                if (usesNewPairFormation) {
                                                  const partner = resolveDependentMappingPartner({
                                                    anchor: enrichedFieldMapping,
                                                    oppositeMappings:
                                                      otherSideMapping?.mappings_data ?? [],
                                                    groupCode: setting?.group_code,
                                                    shippingOppositeMappings:
                                                      shippingGroupCandidate?.mappings_data ?? [],
                                                    oppositeSettingsGroups:
                                                      selectedPlatformSettingsByGroup ?? [],
                                                    preferredSettingMappingId:
                                                      enrichedFieldMapping?.setting_mapping_id,
                                                  })
                                                  return partner
                                                    ? enrichFieldMapping(
                                                        partner as any,
                                                        oppositeFieldMetaMap
                                                      )
                                                    : null
                                                }

                                                const mappingsData =
                                                  otherSideMapping?.mappings_data?.find(
                                                    (mapping: any) =>
                                                      mapping?.api_code ===
                                                        enrichedFieldMapping?.api_code &&
                                                      mapping?.isDefault === false
                                                  ) ??
                                                  findSourceLocationMapping(
                                                    selectedPlatformSettingsByGroup,
                                                    setting?.group_code,
                                                    enrichedFieldMapping
                                                  )

                                                const shippingMappingsData =
                                                  shippingGroupCandidate?.mappings_data?.find(
                                                    (mapping: any) =>
                                                      mapping?.api_code ===
                                                        enrichedFieldMapping?.api_code &&
                                                      mapping?.isDefault === false
                                                  )

                                                return (
                                                  enrichedFieldMapping?.map_with ??
                                                  mappingsData ??
                                                  shippingMappingsData
                                                )
                                              })()

                                              if (!isMappedWith) {
                                                return null
                                              }

                                              if (
                                                shouldResolveIndependentLocationFieldMappingSlot(
                                                  enrichedFieldMapping,
                                                  isMappedWith,
                                                  setting?.mappings_data ?? []
                                                )
                                              ) {
                                                const locationSettingId =
                                                  retrivedPlatformData?.platform_settings?.[
                                                    `${settingField}_setting`
                                                  ]?.id ?? null
                                                const locationSlotCandidates =
                                                  collectLocationSlotCandidates(
                                                    setting?.mappings_data ?? []
                                                  )
                                                const resolvedLocationFieldMapping =
                                                  resolveIndependentLocationFieldMappingSlot(
                                                    enrichedFieldMapping,
                                                    savedMappings,
                                                    {
                                                      destinationPlatformId:
                                                        Number(selectedPlatformId),
                                                      settingId: locationSettingId,
                                                      locationSlotCandidates,
                                                      oppositeMappings: oppositeLocationMappings,
                                                    }
                                                  )
                                                const resolvedLocationEnriched = enrichFieldMapping(
                                                  resolvedLocationFieldMapping as any,
                                                  fieldMappingMetaMap
                                                )
                                                const resolvedLocationSavedMapping =
                                                  findIndependentSavedFieldMapping(
                                                    savedMappings,
                                                    resolvedLocationEnriched,
                                                    {
                                                      destinationPlatformId:
                                                        Number(selectedPlatformId),
                                                      settingId: locationSettingId,
                                                    }
                                                  ) ??
                                                  findIndependentSavedFieldMapping(
                                                    values[`${settingField}_setting`]?.[
                                                      `${mappings_setting_field}_field_mappings`
                                                    ] ?? [],
                                                    resolvedLocationEnriched,
                                                    {
                                                      destinationPlatformId:
                                                        Number(selectedPlatformId),
                                                      settingId: locationSettingId,
                                                    }
                                                  )

                                                return (
                                                  <IndependentMapping
                                                    key={`independent_location_${setting?.group_code}_${resolvedLocationEnriched.display_name}_${resolvedLocationEnriched?.setting_mapping_id ?? index}_${isMappingChanged}`}
                                                    selectedPlatformId={Number(selectedPlatformId)}
                                                    sourceSide={sourceStoreData?.id!}
                                                    destinationSide={Number(selectedPlatformId)!}
                                                    sourcePlatform={
                                                      retrivedPlatformData?.platform_info
                                                        ?.display_name
                                                    }
                                                    destinationPlatform={
                                                      retrivedPlatformData?.platform_info
                                                        ?.display_name
                                                    }
                                                    isMappingVisible={
                                                      values[`${settingField}_setting`]?.[
                                                        `${setting.name}`
                                                      ] ?? false
                                                    }
                                                    handleChange={handleChange}
                                                    field_mapping={resolvedLocationEnriched}
                                                    savedMapping={resolvedLocationSavedMapping}
                                                    settingName={`${settingField}_setting`}
                                                    settingId={locationSettingId}
                                                    setFieldMappings={setFieldMappings}
                                                    fieldMappings={fieldMappings}
                                                    index={index}
                                                    savedMappings={savedMappings}
                                                    setSavedMappings={setSavedMappings}
                                                    isRequiredMissing={missingRequiredMappingKeys.has(
                                                      buildMappingErrorKey({
                                                        settingMappingId:
                                                          resolvedLocationEnriched?.setting_mapping_id,
                                                      })
                                                    )}
                                                  />
                                                )
                                              }

                                              const orderTypeLookupCodes =
                                                resolveSecondaryOrderTypeDependentLookupCodes(
                                                  setting?.group_code,
                                                  enrichedFieldMapping,
                                                  isMappedWith
                                                )

                                              const dependentSavedMappingLookup = usesNewPairFormation
                                                ? {
                                                    sourceSide: enrichedFieldMapping,
                                                    destinationSide: isMappedWith,
                                                    effectiveSettingMappingId:
                                                      enrichedFieldMapping?.setting_mapping_id ??
                                                      isMappedWith?.setting_mapping_id,
                                                    settingId:
                                                      retrivedPlatformData?.platform_settings?.[
                                                        `${settingField}_setting`
                                                      ]?.id ?? null,
                                                    isDefault: enrichedFieldMapping?.isDefault,
                                                    sourceCode: enrichedFieldMapping?.api_code,
                                                    destinationCode: isMappedWith?.api_code,
                                                    sourcePlatformId: Number(selectedPlatformId),
                                                    destinationPlatformId: sourceStoreData?.id,
                                                  }
                                                : {
                                                    sourceSide: isMappedWith,
                                                    destinationSide: enrichedFieldMapping,
                                                    effectiveSettingMappingId:
                                                      enrichedFieldMapping?.setting_mapping_id,
                                                    settingId:
                                                      retrivedPlatformData?.platform_settings?.[
                                                        `${settingField}_setting`
                                                      ]?.id ?? null,
                                                    isDefault: enrichedFieldMapping?.isDefault,
                                                    sourceCode: orderTypeLookupCodes.sourceCode,
                                                    destinationCode:
                                                      orderTypeLookupCodes.destinationCode,
                                                    sourcePlatformId: source_platform_id,
                                                    destinationPlatformId:
                                                      destination_platform_id,
                                                  }

                                              return (
                                                <DependentMapping
                                                  key={`dependent_${
                                                    setting?.group_code
                                                  }_${settingField}_${
                                                    enrichedFieldMapping?.setting_mapping_id ??
                                                    enrichedFieldMapping?.id ??
                                                    enrichedFieldMapping?.api_code
                                                  }_${
                                                    isMappedWith?.id ??
                                                    enrichedFieldMapping?.map_with?.id ??
                                                    'nomap'
                                                  }_${index}_${isMappingChanged}`}
                                                  selectedPlatformId={Number(selectedPlatformId)}
                                                  sourcePlatform={
                                                    usesNewPairFormation
                                                      ? retrivedPlatformData?.platform_info
                                                          ?.display_name
                                                      : sourceStoreData?.platform_info?.display_name
                                                  }
                                                  destinationPlatform={
                                                    usesNewPairFormation
                                                      ? sourceStoreData?.platform_info?.display_name
                                                      : retrivedPlatformData?.platform_info
                                                          ?.display_name
                                                  }
                                                  isMappingVisible={
                                                    values[`${settingField}_setting`]?.[
                                                      `${setting.name}`
                                                    ] ?? false
                                                  }
                                                  handleChange={handleChange}
                                                  field_mapping={enrichedFieldMapping}
                                                  savedMapping={
                                                    findDependentSavedFieldMapping(
                                                      [
                                                        ...(values[`${settingField}_setting`]?.[
                                                          `${mappings_setting_field}_field_mappings`
                                                        ] ?? []),
                                                        ...(savedMappings ?? []),
                                                      ],
                                                      dependentSavedMappingLookup
                                                    ) as SECTION_WISE_SAVED_FIELD_MAPPING | null
                                                  }
                                                  settingName={`${settingField}_setting`}
                                                  settingId={
                                                    retrivedPlatformData?.platform_settings?.[
                                                      `${settingField}_setting`
                                                    ]?.id ?? null
                                                  }
                                                  setFieldMappings={setFieldMappings}
                                                  fieldMappings={fieldMappings}
                                                  index={index}
                                                  isMappedWith={isMappedWith}
                                                  savedMappings={savedMappings}
                                                  setSavedMappings={setSavedMappings}
                                                  primary_settings={false}
                                                  group_code={setting?.group_code}
                                                  useGroup2ChildMappingDirection={
                                                    usesNewPairFormation
                                                  }
                                                  platformCode={(
                                                    retrivedPlatformData?.code ?? ''
                                                  ).toUpperCase()}
                                                  showUploadButton={shouldShowShippingMethodUploadButton({
                                                    groupCode: setting?.group_code,
                                                    sourceStore: sourceStoreData,
                                                    fieldMapping: enrichedFieldMapping,
                                                    mappedPartner: isMappedWith,
                                                  })}
                                                  onUploadClick={() =>
                                                    openShippingProviderUploadModal(
                                                      getPlatformCode(sourceStoreData) ===
                                                        'SHIPHERO'
                                                        ? sourceStoreData
                                                        : undefined
                                                    )
                                                  }
                                                  isRequiredMissing={missingRequiredMappingKeys.has(
                                                    buildMappingErrorKey({
                                                      settingMappingId:
                                                        enrichedFieldMapping?.setting_mapping_id,
                                                    })
                                                  )}
                                                />
                                              )
                                            }

                                            const isTruthyMappingValue = (
                                              value: string | null
                                            ): boolean => {
                                              if (value === null || value === undefined)
                                                return false
                                              const normalized = `${value}`.trim().toLowerCase()
                                              return ['true', '1', 'yes', 'y', 'on'].includes(
                                                normalized
                                              )
                                            }

                                            const oppositeSideMappingsForControl =
                                              findSourcePlatformSettingByGroup(
                                                selectedPlatformSettingsByGroup,
                                                effectiveSourceGroupCode,
                                                setting.name
                                              )?.mappings_data ?? []

                                            const isMappingDropdownVisible = (mapping: any) =>
                                              shouldRenderMappingByDropdownControl(
                                                mapping,
                                                setting.mappings_data ?? [],
                                                fieldMappings,
                                                savedMappings,
                                                oppositeSideMappingsForControl
                                              )

                                            const wrapThisMapping = (
                                              node: React.ReactNode,
                                              enrichedFieldMapping: any,
                                              mappingIndex: number
                                            ) =>
                                              sequenceWrapThisMapping(
                                                enrichedFieldMapping,
                                                mappingIndex,
                                                node
                                              )

                                            const {parentEntries, childrenByParentId} =
                                              groupMappingRenderEntries(normalizedMappings)

                                            return (
                                              <>
                                                {parentEntries.map((entry) => {
                                                  const childMappings = getBooleanMappingChildren(
                                                    entry.enrichedFieldMapping,
                                                    childrenByParentId
                                                  )
                                                  if (!isMappingDropdownVisible(entry.enrichedFieldMapping)) {
                                                    return null
                                                  }
                                                  if (!childMappings.length) {
                                                    return wrapThisMapping(
                                                      renderMappingControl(
                                                        entry.enrichedFieldMapping,
                                                        entry.index
                                                      ),
                                                      entry.enrichedFieldMapping,
                                                      entry.index
                                                    )
                                                  }

                                                  const parentSettingMappingId = getMappingOwnId(
                                                    entry.enrichedFieldMapping
                                                  )
                                                  const visibleChildMappings = childMappings.filter(
                                                    (childEntry) =>
                                                      isMappingDropdownVisible(
                                                        childEntry.enrichedFieldMapping
                                                      )
                                                  )

                                                  return wrapThisMapping(
                                                    <LinkedBooleanMappingBlock
                                                      key={`mapping_parent_${parentSettingMappingId}_${entry.index}`}
                                                      isParentEnabled={isTruthyMappingParentValue(
                                                        getMappingValueBySettingMappingId(
                                                          parentSettingMappingId
                                                        )
                                                      )}
                                                      parentControl={renderMappingControl(
                                                        entry.enrichedFieldMapping,
                                                        entry.index
                                                      )}
                                                    >
                                                      <div className='row g-4'>
                                                        {visibleChildMappings.map((childEntry) => (
                                                          <React.Fragment
                                                            key={`mapping_child_${childEntry.enrichedFieldMapping?.api_code}_${childEntry.index}`}
                                                          >
                                                            {renderMappingControl(
                                                              childEntry.enrichedFieldMapping,
                                                              childEntry.index
                                                            )}
                                                          </React.Fragment>
                                                        ))}
                                                      </div>
                                                    </LinkedBooleanMappingBlock>,
                                                    entry.enrichedFieldMapping,
                                                    entry.index
                                                  )
                                                })}
                                              </>
                                            )
                                          })()
                                        : null}
                                    </>
                                  ) : null}
                                  {platformSettingByGroup[setting.group_code].showSetting &&
                                  values[`${settingField}_setting`] &&
                                  isCurrentSettingEnabled ? (
                                    <ChannelSettingSequenceRow
                                      siblingRanks={siblingRanks}
                                      nodeByKey={sequenceNodeRegistry}
                                      thisSetting={setting}
                                      extraChildren={primaryAdditionalChildSettings}
                                      otherSetting={selectedGroupSettingForChildren}
                                    />
                                  ) : null}
                                </div>
                              ) : isShopwarePlatform && setting.name === 'account_mode' ? (
                                <div
                                  className='row p-4'
                                  key={
                                    platformSettingIndex + 'parentSetting' + platformSettingIndex
                                  }
                                >
                                  <div className='col-12 col-sm-6'>
                                    <label className='form-label' htmlFor='shopware-account-mode'>
                                      {formatSettingDisplayText(setting.display_name)}
                                      {setting.description ? (
                                        <>
                                          &nbsp;&nbsp;
                                          <InfoTooltip sourceChannelName={pricingEnabledFrom} message={setting.description} />
                                        </>
                                      ) : null}
                                    </label>
                                    <select
                                      id='shopware-account-mode'
                                      className='form-select form-select-lg'
                                      name='account_mode'
                                      value={values.account_mode ?? ''}
                                      onChange={handleChange}
                                      required={setting.is_required || false}
                                    >
                                      <option value=''>
                                        {formatSettingDisplayText(setting.placeholder) || 'Select Account Mode'}
                                      </option>
                                      {shopwareAccountModeOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                          {option.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                              ) : setting.input_type === 'SELECT' ? (
                                <div
                                  className='row p-4'
                                  key={
                                    platformSettingIndex + 'parentSetting' + platformSettingIndex
                                  }
                                >
                                  <div className='row p-4'>
                                    <>
                                      {(() => {
                                        const numericSelectedId = Number(selectedPlatformId)
                                        const resolvedHubStoreId =
                                          Number(effectivePrimarySourceStoreData?.id) ||
                                          (isRetrievedPrimaryHubStore &&
                                          Number(retrivedPlatformData?.id) === numericSelectedId
                                            ? Number(retrivedPlatformData?.id)
                                            : 0)
                                        const primaryHubSettings =
                                          isSelectedPrimaryHubStore &&
                                          resolvedHubStoreId === numericSelectedId
                                            ? platformSettings
                                            : primaryPlatformSettings
                                        const sourceChannel =
                                          mainStoreData && mainStoreData.id !== numericSelectedId
                                            ? {
                                                store: mainStoreData,
                                                setting: primaryHubSettings?.find(
                                                  (it) => it.group_code === setting.group_code
                                                ),
                                              }
                                            : omsStoreData && omsStoreData.id !== numericSelectedId
                                            ? {
                                                store: omsStoreData,
                                                setting: (
                                                  omsStoreData.id === numericSelectedId
                                                    ? platformSettings
                                                    : omsPlatformSettings
                                                )?.find(
                                                  (it) => it.group_code === setting.group_code
                                                ),
                                              }
                                            : erpStoreData && erpStoreData.id !== numericSelectedId
                                            ? {
                                                store: erpStoreData,
                                                setting: erpPlatformSettings?.find(
                                                  (it) => it.group_code === setting.group_code
                                                ),
                                              }
                                            : null

                                        if (sourceChannel?.store?.id === erpStoreData?.id) {
                                          return null
                                        }

                                        const sourceSelectSetting = sourceChannel?.setting
                                        let fallbackSourceSetting =
                                          sourceSelectSetting ??
                                          primaryHubSettings?.find(
                                            (it) => it.group_code === setting.group_code
                                          )
                                        const destinationSelectSetting = {
                                          ...setting,
                                          display_name: selectedStoreIdentifierLabel,
                                        }
                                        if (
                                          !fallbackSourceSetting &&
                                          setting.group_code === 'IDENTIFIER'
                                        ) {
                                          fallbackSourceSetting = {
                                            ...destinationSelectSetting,
                                            name: 'main_product_identifier',
                                            display_name: 'Source Channel Identifier',
                                            placeholder:
                                              setting.placeholder ?? 'Select Unique identifier',
                                          }
                                        }
                                        const hasSourceSelect = Boolean(fallbackSourceSetting)

                                        const sourceDisplayName =
                                          sourceChannel?.store?.platform_info?.display_name ??
                                          sourceChannel?.store?.display_name ??
                                          'Source Channel'

                                        const destinationDisplayName =
                                          retrivedPlatformData?.platform_info?.display_name ??
                                          retrivedPlatformData?.display_name ??
                                          'Destination'

                                        return (
                                          <>
                                            {/* Ensure current channel selector stays on the left */}
                                            <div className='col-12 col-sm-6 mb-2'>
                                              <CustomSelect sourceChannelName={pricingEnabledFrom}
                                                setting={destinationSelectSetting}
                                                values={values}
                                                handleChange={handleChange}
                                                hasIdentifier={hasIdentifier}
                                              />
                                            </div>
                                            {hasSourceSelect ? (
                                              <div className='col-12 col-sm-6 mb-2'>
                                                <CustomSelect sourceChannelName={pricingEnabledFrom}
                                                  setting={fallbackSourceSetting}
                                                  values={values}
                                                  handleChange={handleChange}
                                                  hasIdentifier={hasIdentifier}
                                                />
                                              </div>
                                            ) : null}
                                            {hasSourceSelect ? (
                                              <div
                                                className='px-4 d-flex fw-medium pb-3'
                                                style={{color: 'darkgrey'}}
                                              >
                                                <span
                                                  style={{margin: '1px 4px', color: 'darkgrey'}}
                                                >
                                                  <FontAwesomeIcon icon={faCircleInfo} />
                                                </span>
                                                {`Important Note : Here you need to map the product identifier of ${destinationDisplayName} with the product identifier of ${sourceDisplayName}. This mapping is important because it will be used to identify products across your channels for inventory & order management.`}
                                              </div>
                                            ) : null}
                                          </>
                                        )
                                      })()}

                                      {
                                        // (mainStoreData?.id === Number(selectedPlatformId) &&
                                        //   values?.[`accounting_order_setting`]?.[
                                        //     `isImportOrderToSource`
                                        //   ]) ||
                                        // (mainStoreData?.id !== Number(selectedPlatformId) &&
                                        //   (isInventoryEnabledAccounting ||
                                        //     isPricingEnabledAccounting ||
                                        //     values[`accounting_order_setting`]?.[
                                        //       `isImportOrderToSource`
                                        //     ]))
                                        accountingStoreData ? (
                                          <>
                                            {/* <span
                                        className='p-1 d-flex ms-1 fw-medium'
                                        style={{color: 'darkgrey'}}
                                      >
                                        <span style={{margin: '1px 4px', color: 'darkgrey'}}>
                                          <FontAwesomeIcon icon={faCircleInfo} />
                                        </span>
                                        {`Map product identifier from your Accounting Channel to ${retrivedPlatformData?.display_name} to enable accurate product tracking across both channels for inventory and order management.`}
                                      </span> */}
                                            <div className='col-12 col-sm-6'>
                                              <CustomSelect sourceChannelName={pricingEnabledFrom}
                                                setting={{
                                                  ...setting,
                                                  display_name: selectedStoreIdentifierLabel,
                                                  name: isSelectedPrimaryHubStore
                                                    ? 'primary_accounting_identifier'
                                                    : 'secondary_accounting_identifier',
                                                }}
                                                values={values}
                                                handleChange={handleChange}
                                                hasIdentifier={hasIdentifier}
                                              />
                                            </div>
                                            <div className='col-12 col-sm-6 mb-2'>
                                              <CustomSelect sourceChannelName={pricingEnabledFrom}
                                                setting={{
                                                  ...accountingPlatformSettings?.find(
                                                    (it) => it.input_type === setting.input_type
                                                  ),
                                                  name: isSelectedPrimaryHubStore
                                                    ? 'accounting_identifier_primary'
                                                    : 'accounting_identifier',
                                                }}
                                                values={values}
                                                handleChange={handleChange}
                                                hasIdentifier={hasIdentifier}
                                              />
                                            </div>
                                            <div
                                              className='px-4 d-flex fw-medium pb-3'
                                              style={{color: 'darkgrey'}}
                                            >
                                              <span style={{margin: '1px 4px', color: 'darkgrey'}}>
                                                <FontAwesomeIcon icon={faCircleInfo} />
                                              </span>
                                              {`Important Note : Here you need to map the product identifier of ${accountingStoreData?.platform_info?.display_name} with the product identifier of ${retrivedPlatformData?.platform_info?.display_name}. This mapping is important because it will be used to identify products across your channels for inventory & order management.`}
                                            </div>
                                          </>
                                        ) : null
                                      }

                                      {erpStoreData ? (
                                        <>
                                          {(() => {
                                            const isPrimarySelected = isSelectedPrimaryHubStore
                                            const erpSourceSetting =
                                              erpPlatformSettings?.find(
                                                (it) => it.group_code === setting.group_code
                                              ) ?? null

                                            const erpChannelSelectSetting = erpSourceSetting
                                              ? {
                                                  ...erpSourceSetting,
                                                  name: isPrimarySelected
                                                    ? `${ERP_IDENTIFIER_KEY}_primary`
                                                    : ERP_IDENTIFIER_KEY,
                                                }
                                              : null

                                            const destinationSelectSetting = {
                                              ...setting,
                                              display_name: selectedStoreIdentifierLabel,
                                              name: isPrimarySelected
                                                ? 'primary_erp_identifier'
                                                : 'secondary_erp_identifier',
                                            }

                                            const leftSetting = destinationSelectSetting
                                            const rightSetting = erpChannelSelectSetting

                                            return (
                                              <>
                                                <div className='col-12 col-sm-6 mb-2'>
                                                  <CustomSelect sourceChannelName={pricingEnabledFrom}
                                                    setting={leftSetting}
                                                    values={values}
                                                    handleChange={handleChange}
                                                    hasIdentifier={hasIdentifier}
                                                  />
                                                </div>
                                                {rightSetting ? (
                                                  <div className='col-12 col-sm-6 mb-2'>
                                                    <CustomSelect sourceChannelName={pricingEnabledFrom}
                                                      setting={rightSetting}
                                                      values={values}
                                                      handleChange={handleChange}
                                                      hasIdentifier={hasIdentifier}
                                                    />
                                                  </div>
                                                ) : null}
                                              </>
                                            )
                                          })()}
                                          <div
                                            className='px-4 d-flex fw-medium pb-3'
                                            style={{color: 'darkgrey'}}
                                          >
                                            <span style={{margin: '1px 4px', color: 'darkgrey'}}>
                                              <FontAwesomeIcon icon={faCircleInfo} />
                                            </span>
                                            {`Important Note : Here you need to map the product identifier of ${erpStoreData?.platform_info?.display_name} with the product identifier of ${retrivedPlatformData?.platform_info?.display_name}. This mapping is important because it will be used to identify products across your channels for inventory & order management.`}
                                          </div>
                                        </>
                                      ) : null}

                                      {omsStoreData && omsStoreData.id !== Number(selectedPlatformId) ? (
                                        <>
                                          {(() => {
                                            const isPrimarySelected = isSelectedPrimaryHubStore
                                            const omsSourceSetting =
                                              omsPlatformSettings?.find(
                                                (it) => it.group_code === setting.group_code
                                              ) ?? null

                                            const omsChannelSelectSetting = omsSourceSetting
                                              ? {
                                                  ...omsSourceSetting,
                                                  name: isPrimarySelected
                                                    ? 'oms_identifier_primary'
                                                    : 'oms_identifier',
                                                }
                                              : null

                                            const destinationSelectSetting = {
                                              ...setting,
                                              display_name: selectedStoreIdentifierLabel,
                                              name: isPrimarySelected
                                                ? 'primary_oms_identifier'
                                                : 'secondary_oms_identifier',
                                            }

                                            const leftSetting = destinationSelectSetting
                                            const rightSetting = omsChannelSelectSetting

                                            return (
                                              <>
                                                <div className='col-12 col-sm-6 mb-2'>
                                                  <CustomSelect sourceChannelName={pricingEnabledFrom}
                                                    setting={leftSetting}
                                                    values={values}
                                                    handleChange={handleChange}
                                                    hasIdentifier={hasIdentifier}
                                                  />
                                                </div>
                                                {rightSetting ? (
                                                  <div className='col-12 col-sm-6 mb-2'>
                                                    <CustomSelect sourceChannelName={pricingEnabledFrom}
                                                      setting={rightSetting}
                                                      values={values}
                                                      handleChange={handleChange}
                                                      hasIdentifier={hasIdentifier}
                                                    />
                                                  </div>
                                                ) : null}
                                              </>
                                            )
                                          })()}
                                          <div
                                            className='px-4 d-flex fw-medium pb-3'
                                            style={{color: 'darkgrey'}}
                                          >
                                            <span style={{margin: '1px 4px', color: 'darkgrey'}}>
                                              <FontAwesomeIcon icon={faCircleInfo} />
                                            </span>
                                            {`Important Note : Here you need to map the product identifier of ${omsStoreData?.platform_info?.display_name} with the product identifier of ${retrivedPlatformData?.platform_info?.display_name}. This mapping is important because it will be used to identify products across your channels for inventory & order management.`}
                                          </div>
                                        </>
                                      ) : null}

                                      {
                                        // (mainStoreData?.id === Number(selectedPlatformId) &&
                                        //   values?.[`shipment_setting`]?.[`isImportShipmentFromMain`]) ||
                                        // (mainStoreData?.id !== Number(selectedPlatformId) &&
                                        //   (isInventoryEnabledShipping ||
                                        //     isPricingEnabledShipping ||
                                        //     platformSettingByGroup?.['SHIPMENT']?.settingType ===
                                        //       'SHIPPING_STORE_SETTING'))
                                        shippingStoreData ? (
                                          <>
                                            {/* <span
                                        className='p-1 d-flex ms-1 mt-3 fw-medium'
                                        style={{color: 'darkgrey'}}
                                      >
                                        <span style={{margin: '1px 4px', color: 'darkgrey'}}>
                                          <FontAwesomeIcon icon={faCircleInfo} />
                                        </span>
                                        {`Map product identifier from your Shipping Channel to ${retrivedPlatformData?.display_name} to enable accurate product tracking across both channels for inventory and order management.`}
                                      </span> */}
                                            <div className='col-12 col-sm-6'>
                                              <CustomSelect sourceChannelName={pricingEnabledFrom}
                                                setting={{
                                                  ...setting,
                                                  display_name: selectedStoreIdentifierLabel,
                                                  name: isSelectedPrimaryHubStore
                                                    ? 'primary_shipping_identifier'
                                                    : 'secondary_shipping_identifier',
                                                }}
                                                values={values}
                                                handleChange={handleChange}
                                                hasIdentifier={hasIdentifier}
                                              />
                                            </div>
                                            <div className='col-12 col-sm-6 mb-2'>
                                              <CustomSelect sourceChannelName={pricingEnabledFrom}
                                                setting={{
                                                  ...shippingPlatformSettings?.find(
                                                    (it) => it.input_type === setting.input_type
                                                  ),
                                                  name: isSelectedPrimaryHubStore
                                                    ? 'shipping_identifier_primary'
                                                    : 'shipping_identifier',
                                                }}
                                                values={values}
                                                handleChange={handleChange}
                                                hasIdentifier={hasIdentifier}
                                              />
                                            </div>{' '}
                                            <div
                                              className='px-4 d-flex fw-medium'
                                              style={{color: 'darkgrey'}}
                                            >
                                              <span style={{margin: '1px 4px', color: 'darkgrey'}}>
                                                <FontAwesomeIcon icon={faCircleInfo} />
                                              </span>
                                              {`Important Note : Here you need to map the product identifier of ${shippingStoreData?.platform_info?.display_name} with the product identifier of ${retrivedPlatformData?.platform_info?.display_name}. This mapping is important because it will be used to identify products across your channels for inventory & order management.`}
                                            </div>
                                          </>
                                        ) : null
                                      }
                                    </>
                                  </div>
                                </div>
                              ) : setting.input_type === 'INTEGER' ? (
                                <CustomInput sourceChannelName={pricingEnabledFrom}
                                  key={
                                    platformSettingIndex + 'parentSetting' + platformSettingIndex
                                  }
                                  label={setting.display_name}
                                  message={setting.description}
                                  inputProps={{
                                    type: 'number',
                                    className: 'form-control form-control-lg',
                                    placeholder: setting.placeholder ?? '',
                                    name:
                                      setting.group_code === 'IDENTIFIER' &&
                                      setting.name === 'platform_partner_id'
                                        ? setting.name
                                        : settingField
                                        ? `${settingField}_setting.${setting.name}`
                                        : setting.name,
                                    value:
                                      setting.group_code === 'IDENTIFIER' &&
                                      setting.name === 'platform_partner_id'
                                        ? values[setting.name] ??
                                          values[`${settingField}_setting`]?.[setting.name] ??
                                          ''
                                        : settingField && values[`${settingField}_setting`]
                                        ? values[`${settingField}_setting`][`${setting.name}`]
                                        : values[setting.name] ?? '',
                                    onChange: handleChange,
                                    id: setting.group_code + setting.name,
                                    required: setting.is_required || false,
                                  }}
                                />
                              ) : setting.input_type === 'TEXT_READONLY' ? (
                                <div
                                  className='col-12 col-sm-6 mt-4'
                                  style={{paddingRight: '5.5rem'}}
                                >
                                  <CustomInput sourceChannelName={pricingEnabledFrom}
                                    key={
                                      platformSettingIndex + 'parentSetting' + platformSettingIndex
                                    }
                                    label={setting.display_name}
                                    message={setting.description}
                                    containerClasses=''
                                    inputProps={{
                                      type: 'text',
                                      className: 'form-control form-control-lg',
                                      placeholder: setting.placeholder ?? '',
                                      name:
                                        setting.group_code === 'IDENTIFIER' &&
                                        setting.name === 'platform_partner_id'
                                          ? setting.name
                                          : settingField
                                          ? `${settingField}_setting.${setting.name}`
                                          : setting.name,
                                      value:
                                        setting.group_code === 'IDENTIFIER' &&
                                        setting.name === 'platform_partner_id'
                                          ? values[setting.name] ??
                                            values[`${settingField}_setting`]?.[setting.name] ??
                                            ''
                                          : settingField && values[`${settingField}_setting`]
                                          ? values[`${settingField}_setting`][`${setting.name}`]
                                          : values[setting.name] ?? '',
                                      id: setting.group_code + setting.name,
                                      required: setting.is_required || false,
                                      readOnly: true,
                                      'aria-readonly': true,
                                    }}
                                    showCopyButton
                                  />
                                  <SettingNotes
                                    notes={setting.notes}
                                    retrivedPlatformData={retrivedPlatformData}
                                    mainStoreData={mainStoreData ?? undefined}
                                    pricingEnabledFrom={pricingEnabledFrom}
                                  />
                                </div>
                              ) : setting.input_type === 'DATETIME' ? (
                                <CustomInput sourceChannelName={pricingEnabledFrom}
                                  key={
                                    platformSettingIndex + 'parentSetting' + platformSettingIndex
                                  }
                                  label={setting.display_name}
                                  message={setting.description}
                                  inputProps={{
                                    type: 'datetime-local',
                                    className: 'form-control form-control-lg',
                                    name:
                                      setting.group_code === 'IDENTIFIER' &&
                                      setting.name === 'platform_partner_id'
                                        ? setting.name
                                        : settingField
                                        ? `${settingField}_setting.${setting.name}`
                                        : setting.name,
                                    value:
                                      setting.group_code === 'IDENTIFIER' &&
                                      setting.name === 'platform_partner_id'
                                        ? values[setting.name] ??
                                          values[`${settingField}_setting`]?.[setting.name] ??
                                          ''
                                        : formatDateForDateTimeLocal(
                                            settingField
                                              ? values[`${settingField}_setting`]?.[
                                                  `${setting.name}`
                                                ]
                                              : values[setting.name]
                                          ),
                                    onChange: handleChange,
                                    id: setting.group_code + setting.name,
                                    required: setting.is_required || false,
                                  }}
                                />
                              ) : //default is text field
                              setting.showShortcodes ? (
                                <>
                                  <ShortCodeInput sourceChannelName={pricingEnabledFrom}
                                    key={
                                      platformSettingIndex + 'parentSetting' + platformSettingIndex
                                    }
                                    label={setting.display_name}
                                    message={setting.description}
                                    inputProps={{
                                      type: 'text',
                                      className: 'form-control form-control-lg',
                                      placeholder: setting.placeholder ?? '',
                                      name:
                                        setting.group_code === 'IDENTIFIER' &&
                                        setting.name === 'platform_partner_id'
                                          ? setting.name
                                          : settingField
                                          ? `${settingField}_setting.${setting.name}`
                                          : setting.name,
                                      value:
                                        setting.group_code === 'IDENTIFIER' &&
                                        setting.name === 'platform_partner_id'
                                          ? values[setting.name] ??
                                            values[`${settingField}_setting`]?.[setting.name] ??
                                            ''
                                          : settingField && values[`${settingField}_setting`]
                                          ? values[`${settingField}_setting`][`${setting.name}`]
                                          : values[setting.name] ?? '',
                                      onChange: handleChange,
                                      id: setting.group_code + setting.name,
                                      required: setting.is_required || false,
                                    }}
                                  />
                                </>
                              ) : (
                                <CustomInput sourceChannelName={pricingEnabledFrom}
                                  key={
                                    platformSettingIndex + 'parentSetting' + platformSettingIndex
                                  }
                                  label={setting.display_name}
                                  message={setting.description}
                                  inputProps={{
                                    type: 'text',
                                    className: 'form-control form-control-lg',
                                    placeholder: setting.placeholder ?? '',
                                    name:
                                      setting.group_code === 'IDENTIFIER' &&
                                      setting.name === 'platform_partner_id'
                                        ? setting.name
                                        : settingField
                                        ? `${settingField}_setting.${setting.name}`
                                        : setting.name,
                                    value:
                                      setting.group_code === 'IDENTIFIER' &&
                                      setting.name === 'platform_partner_id'
                                        ? values[setting.name] ??
                                          values[`${settingField}_setting`]?.[setting.name] ??
                                          ''
                                        : settingField && values[`${settingField}_setting`]
                                        ? values[`${settingField}_setting`][`${setting.name}`]
                                        : values[setting.name] ?? '',
                                    onChange: handleChange,
                                    id: setting.group_code + setting.name,
                                    required: setting.is_required || false,
                                  }}
                                />
                              )
                            ) : //rest input type of parent...

                            //under this part the rest settings come those are not parent setting
                            // setting.input_type === 'BOOLEAN' ? (
                            //   <div
                            //     className='col-12 col-sm-6 mt-4'
                            //     key={platformSettingIndex + 'parentSetting' + platformSettingIndex}
                            //   >
                            //     <CustomInput sourceChannelName={pricingEnabledFrom}
                            //       label={setting.display_name}
                            //       labelClass='form-label  me-sm-10 me-0 mb-0'
                            //       message={setting.description}
                            //       containerClasses='form-check form-switch form-check-solid '
                            //       inputProps={{
                            //         type: 'checkbox',
                            //         className: 'form-check-input h-30px w-50px ms-sm-5 ms-0',
                            //         name: settingField
                            //           ? `${settingField}_setting.${setting.name}`
                            //           : setting.name,
                            //         checked: settingField
                            //           ? values[`${settingField}_setting`][`${setting.name}`]
                            //           : values[setting.name],
                            //         onChange: handleChange,
                            //         id: setting.group_code + setting.name,
                            //       }}
                            //     />
                            //   </div>
                            // ) : setting.input_type === 'SELECT' ? (
                            //   <div
                            //     className='row p-4'
                            //     key={platformSettingIndex + 'parentSetting' + platformSettingIndex}
                            //   >
                            //     <div className='row p-4'>
                            //       <>
                            //         <div className='col-12 col-sm-6'>
                            //           <label className='form-label' htmlFor={setting.name}>
                            //             {setting.display_name}
                            //             &nbsp;&nbsp;
                            //             <InfoTooltip sourceChannelName={pricingEnabledFrom} message={setting.description} />
                            //           </label>
                            //           <select
                            //             name={setting.name}
                            //             value={values[`${setting.name}`]}
                            //             onChange={handleChange}
                            //             className='form-select form-select-lg'
                            //           >
                            //             <option value=''>{setting.placeholder}</option>
                            //             {setting.setting_options.map((item: any) => {
                            //               return (
                            //                 <option key={item.id} value={item.name}>
                            //                   {formatSettingDisplayText(item.display_name)}
                            //                 </option>
                            //               )
                            //             })}
                            //           </select>
                            //         </div>
                            //       </>
                            //     </div>
                            //   </div>
                            // ) : setting.input_type === 'INTEGER' ? (
                            //   <CustomInput sourceChannelName={pricingEnabledFrom}
                            //     key={platformSettingIndex + 'parentSetting' + platformSettingIndex}
                            //     label={setting.display_name}
                            //     message={setting.description}
                            //     inputProps={{
                            //       type: 'number',
                            //       className: 'form-control form-control-lg',
                            //       name: settingField
                            //         ? `${settingField}_setting.${setting.name}`
                            //         : setting.name,
                            //       value: settingField
                            //         ? values[`${settingField}_setting`][`${setting.name}`]
                            //         : values[setting.name],
                            //       onChange: handleChange,
                            //       id: setting.group_code + setting.name,
                            //     }}
                            //   />
                            // ) : setting.input_type === 'DATETIME' ? (
                            //   <CustomInput sourceChannelName={pricingEnabledFrom}
                            //     key={platformSettingIndex + 'parentSetting' + platformSettingIndex}
                            //     label={setting.display_name}
                            //     message={setting.description}
                            //     inputProps={{
                            //       type: 'datetime-local',
                            //       className: 'form-control form-control-lg',
                            //       name: settingField
                            //         ? `${settingField}_setting.${setting.name}`
                            //         : setting.name,
                            //       value: settingField
                            //         ? new Date(values[`${settingField}_setting`][`${setting.name}`])
                            //             .toISOString()
                            //             .slice(0, 16)
                            //         : values[setting.name],
                            //       onChange: handleChange,
                            //       id: setting.group_code + setting.name,
                            //     }}
                            //   />
                            // ) : //default is text field
                            // setting.showShortcodes ? (
                            //   <>
                            //     <ShortCodeInput sourceChannelName={pricingEnabledFrom}
                            //       key={platformSettingIndex + 'parentSetting' + platformSettingIndex}
                            //       label={setting.display_name}
                            //       message={setting.description}
                            //       inputProps={{
                            //         type: 'text',
                            //         className: 'form-control form-control-lg',
                            //         name: settingField
                            //           ? `${settingField}_setting.${setting.name}`
                            //           : setting.name,
                            //         value: settingField
                            //           ? values[`${settingField}_setting`][`${setting.name}`]
                            //           : values[setting.name],
                            //         onChange: handleChange,
                            //         id: setting.group_code + setting.name,
                            //       }}
                            //     />
                            //   </>
                            // ) : (
                            //   <CustomInput sourceChannelName={pricingEnabledFrom}
                            //     key={platformSettingIndex + 'parentSetting' + platformSettingIndex}
                            //     label={setting.display_name}
                            //     message={setting.description}
                            //     inputProps={{
                            //       type: 'text',
                            //       className: 'form-control form-control-lg',
                            //       name: settingField
                            //         ? `${settingField}_setting.${setting.name}`
                            //         : setting.name,
                            //       value: settingField
                            //         ? values[`${settingField}_setting`][`${setting.name}`]
                            //         : values[setting.name],
                            //       onChange: handleChange,
                            //       id: setting.group_code + setting.name,
                            //     }}
                            //   />
                            // )
                            null}
                          </div>
                        </div>
                      </section>
                    )
                  })
              ) : (
                <div className='card-body mt-8'>
                  <p className='h3'>No settings found</p>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
      <ShippingProviderUploadModal
        show={showShippingProviderUploadModal}
        handleClose={closeShippingProviderUploadModal}
        platformId={shippingProviderUploadTarget?.platformId ?? selectedPlatformId ?? ''}
        platformName={
          shippingProviderUploadTarget?.platformName ?? retrivedPlatformData?.code ?? ''
        }
        platformDisplayName={
          shippingProviderUploadTarget?.platformDisplayName ??
          retrivedPlatformData?.display_name ??
          ''
        }
      />
    </>
  )
}

export default DynamicPlatformSettingNew
